/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var u = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
  var Is = u(() => {
    (function () {
      if (typeof window > "u") return;
      let e = window.navigator.userAgent.match(/Edge\/(\d{2})\./),
        t = e ? parseInt(e[1], 10) >= 16 : !1;
      if ("objectFit" in document.documentElement.style && !t) {
        window.objectFitPolyfill = function () {
          return !1;
        };
        return;
      }
      let n = function (s) {
          let c = window.getComputedStyle(s, null),
            f = c.getPropertyValue("position"),
            E = c.getPropertyValue("overflow"),
            v = c.getPropertyValue("display");
          (!f || f === "static") && (s.style.position = "relative"),
            E !== "hidden" && (s.style.overflow = "hidden"),
            (!v || v === "inline") && (s.style.display = "block"),
            s.clientHeight === 0 && (s.style.height = "100%"),
            s.className.indexOf("object-fit-polyfill") === -1 &&
              (s.className += " object-fit-polyfill");
        },
        o = function (s) {
          let c = window.getComputedStyle(s, null),
            f = {
              "max-width": "none",
              "max-height": "none",
              "min-width": "0px",
              "min-height": "0px",
              top: "auto",
              right: "auto",
              bottom: "auto",
              left: "auto",
              "margin-top": "0px",
              "margin-right": "0px",
              "margin-bottom": "0px",
              "margin-left": "0px",
            };
          for (let E in f)
            c.getPropertyValue(E) !== f[E] && (s.style[E] = f[E]);
        },
        i = function (s) {
          let c = s.parentNode;
          n(c),
            o(s),
            (s.style.position = "absolute"),
            (s.style.height = "100%"),
            (s.style.width = "auto"),
            s.clientWidth > c.clientWidth
              ? ((s.style.top = "0"),
                (s.style.marginTop = "0"),
                (s.style.left = "50%"),
                (s.style.marginLeft = s.clientWidth / -2 + "px"))
              : ((s.style.width = "100%"),
                (s.style.height = "auto"),
                (s.style.left = "0"),
                (s.style.marginLeft = "0"),
                (s.style.top = "50%"),
                (s.style.marginTop = s.clientHeight / -2 + "px"));
        },
        a = function (s) {
          if (typeof s > "u" || s instanceof Event)
            s = document.querySelectorAll("[data-object-fit]");
          else if (s && s.nodeName) s = [s];
          else if (typeof s == "object" && s.length && s[0].nodeName) s = s;
          else return !1;
          for (let c = 0; c < s.length; c++) {
            if (!s[c].nodeName) continue;
            let f = s[c].nodeName.toLowerCase();
            if (f === "img") {
              if (t) continue;
              s[c].complete
                ? i(s[c])
                : s[c].addEventListener("load", function () {
                    i(this);
                  });
            } else
              f === "video"
                ? s[c].readyState > 0
                  ? i(s[c])
                  : s[c].addEventListener("loadedmetadata", function () {
                      i(this);
                    })
                : i(s[c]);
          }
          return !0;
        };
      document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", a)
        : a(),
        window.addEventListener("resize", a),
        (window.objectFitPolyfill = a);
    })();
  });
  var ms = u(() => {
    (function () {
      if (typeof window > "u") return;
      function e(n) {
        Webflow.env("design") ||
          ($("video").each(function () {
            n && $(this).prop("autoplay") ? this.play() : this.pause();
          }),
          $(".w-background-video--control").each(function () {
            n ? r($(this)) : t($(this));
          }));
      }
      function t(n) {
        n.find("> span").each(function (o) {
          $(this).prop("hidden", () => o === 0);
        });
      }
      function r(n) {
        n.find("> span").each(function (o) {
          $(this).prop("hidden", () => o === 1);
        });
      }
      $(document).ready(() => {
        let n = window.matchMedia("(prefers-reduced-motion: reduce)");
        n.addEventListener("change", (o) => {
          e(!o.matches);
        }),
          n.matches && e(!1),
          $("video:not([autoplay])").each(function () {
            $(this)
              .parent()
              .find(".w-background-video--control")
              .each(function () {
                t($(this));
              });
          }),
          $(document).on("click", ".w-background-video--control", function (o) {
            if (Webflow.env("design")) return;
            let i = $(o.currentTarget),
              a = $(`video#${i.attr("aria-controls")}`).get(0);
            if (a)
              if (a.paused) {
                let s = a.play();
                r(i),
                  s &&
                    typeof s.catch == "function" &&
                    s.catch(() => {
                      t(i);
                    });
              } else a.pause(), t(i);
          });
      });
    })();
  });
  var Fi = u(() => {
    window.tram = (function (e) {
      function t(l, p) {
        var _ = new U.Bare();
        return _.init(l, p);
      }
      function r(l) {
        return l.replace(/[A-Z]/g, function (p) {
          return "-" + p.toLowerCase();
        });
      }
      function n(l) {
        var p = parseInt(l.slice(1), 16),
          _ = (p >> 16) & 255,
          T = (p >> 8) & 255,
          g = 255 & p;
        return [_, T, g];
      }
      function o(l, p, _) {
        return (
          "#" + ((1 << 24) | (l << 16) | (p << 8) | _).toString(16).slice(1)
        );
      }
      function i() {}
      function a(l, p) {
        f("Type warning: Expected: [" + l + "] Got: [" + typeof p + "] " + p);
      }
      function s(l, p, _) {
        f("Units do not match [" + l + "]: " + p + ", " + _);
      }
      function c(l, p, _) {
        if ((p !== void 0 && (_ = p), l === void 0)) return _;
        var T = _;
        return (
          Lt.test(l) || !ht.test(l)
            ? (T = parseInt(l, 10))
            : ht.test(l) && (T = 1e3 * parseFloat(l)),
          0 > T && (T = 0),
          T === T ? T : _
        );
      }
      function f(l) {
        pe.debug && window && window.console.warn(l);
      }
      function E(l) {
        for (var p = -1, _ = l ? l.length : 0, T = []; ++p < _; ) {
          var g = l[p];
          g && T.push(g);
        }
        return T;
      }
      var v = (function (l, p, _) {
          function T(ne) {
            return typeof ne == "object";
          }
          function g(ne) {
            return typeof ne == "function";
          }
          function O() {}
          function z(ne, _e) {
            function W() {
              var De = new ue();
              return g(De.init) && De.init.apply(De, arguments), De;
            }
            function ue() {}
            _e === _ && ((_e = ne), (ne = Object)), (W.Bare = ue);
            var fe,
              Se = (O[l] = ne[l]),
              it = (ue[l] = W[l] = new O());
            return (
              (it.constructor = W),
              (W.mixin = function (De) {
                return (ue[l] = W[l] = z(W, De)[l]), W;
              }),
              (W.open = function (De) {
                if (
                  ((fe = {}),
                  g(De) ? (fe = De.call(W, it, Se, W, ne)) : T(De) && (fe = De),
                  T(fe))
                )
                  for (var br in fe) p.call(fe, br) && (it[br] = fe[br]);
                return g(it.init) || (it.init = ne), W;
              }),
              W.open(_e)
            );
          }
          return z;
        })("prototype", {}.hasOwnProperty),
        h = {
          ease: [
            "ease",
            function (l, p, _, T) {
              var g = (l /= T) * l,
                O = g * l;
              return (
                p +
                _ * (-2.75 * O * g + 11 * g * g + -15.5 * O + 8 * g + 0.25 * l)
              );
            },
          ],
          "ease-in": [
            "ease-in",
            function (l, p, _, T) {
              var g = (l /= T) * l,
                O = g * l;
              return p + _ * (-1 * O * g + 3 * g * g + -3 * O + 2 * g);
            },
          ],
          "ease-out": [
            "ease-out",
            function (l, p, _, T) {
              var g = (l /= T) * l,
                O = g * l;
              return (
                p +
                _ * (0.3 * O * g + -1.6 * g * g + 2.2 * O + -1.8 * g + 1.9 * l)
              );
            },
          ],
          "ease-in-out": [
            "ease-in-out",
            function (l, p, _, T) {
              var g = (l /= T) * l,
                O = g * l;
              return p + _ * (2 * O * g + -5 * g * g + 2 * O + 2 * g);
            },
          ],
          linear: [
            "linear",
            function (l, p, _, T) {
              return (_ * l) / T + p;
            },
          ],
          "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function (l, p, _, T) {
              return _ * (l /= T) * l + p;
            },
          ],
          "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function (l, p, _, T) {
              return -_ * (l /= T) * (l - 2) + p;
            },
          ],
          "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function (l, p, _, T) {
              return (l /= T / 2) < 1
                ? (_ / 2) * l * l + p
                : (-_ / 2) * (--l * (l - 2) - 1) + p;
            },
          ],
          "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function (l, p, _, T) {
              return _ * (l /= T) * l * l + p;
            },
          ],
          "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function (l, p, _, T) {
              return _ * ((l = l / T - 1) * l * l + 1) + p;
            },
          ],
          "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function (l, p, _, T) {
              return (l /= T / 2) < 1
                ? (_ / 2) * l * l * l + p
                : (_ / 2) * ((l -= 2) * l * l + 2) + p;
            },
          ],
          "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function (l, p, _, T) {
              return _ * (l /= T) * l * l * l + p;
            },
          ],
          "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function (l, p, _, T) {
              return -_ * ((l = l / T - 1) * l * l * l - 1) + p;
            },
          ],
          "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function (l, p, _, T) {
              return (l /= T / 2) < 1
                ? (_ / 2) * l * l * l * l + p
                : (-_ / 2) * ((l -= 2) * l * l * l - 2) + p;
            },
          ],
          "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function (l, p, _, T) {
              return _ * (l /= T) * l * l * l * l + p;
            },
          ],
          "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function (l, p, _, T) {
              return _ * ((l = l / T - 1) * l * l * l * l + 1) + p;
            },
          ],
          "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function (l, p, _, T) {
              return (l /= T / 2) < 1
                ? (_ / 2) * l * l * l * l * l + p
                : (_ / 2) * ((l -= 2) * l * l * l * l + 2) + p;
            },
          ],
          "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function (l, p, _, T) {
              return -_ * Math.cos((l / T) * (Math.PI / 2)) + _ + p;
            },
          ],
          "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function (l, p, _, T) {
              return _ * Math.sin((l / T) * (Math.PI / 2)) + p;
            },
          ],
          "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function (l, p, _, T) {
              return (-_ / 2) * (Math.cos((Math.PI * l) / T) - 1) + p;
            },
          ],
          "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function (l, p, _, T) {
              return l === 0 ? p : _ * Math.pow(2, 10 * (l / T - 1)) + p;
            },
          ],
          "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function (l, p, _, T) {
              return l === T
                ? p + _
                : _ * (-Math.pow(2, (-10 * l) / T) + 1) + p;
            },
          ],
          "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function (l, p, _, T) {
              return l === 0
                ? p
                : l === T
                ? p + _
                : (l /= T / 2) < 1
                ? (_ / 2) * Math.pow(2, 10 * (l - 1)) + p
                : (_ / 2) * (-Math.pow(2, -10 * --l) + 2) + p;
            },
          ],
          "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function (l, p, _, T) {
              return -_ * (Math.sqrt(1 - (l /= T) * l) - 1) + p;
            },
          ],
          "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function (l, p, _, T) {
              return _ * Math.sqrt(1 - (l = l / T - 1) * l) + p;
            },
          ],
          "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function (l, p, _, T) {
              return (l /= T / 2) < 1
                ? (-_ / 2) * (Math.sqrt(1 - l * l) - 1) + p
                : (_ / 2) * (Math.sqrt(1 - (l -= 2) * l) + 1) + p;
            },
          ],
          "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function (l, p, _, T, g) {
              return (
                g === void 0 && (g = 1.70158),
                _ * (l /= T) * l * ((g + 1) * l - g) + p
              );
            },
          ],
          "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function (l, p, _, T, g) {
              return (
                g === void 0 && (g = 1.70158),
                _ * ((l = l / T - 1) * l * ((g + 1) * l + g) + 1) + p
              );
            },
          ],
          "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function (l, p, _, T, g) {
              return (
                g === void 0 && (g = 1.70158),
                (l /= T / 2) < 1
                  ? (_ / 2) * l * l * (((g *= 1.525) + 1) * l - g) + p
                  : (_ / 2) *
                      ((l -= 2) * l * (((g *= 1.525) + 1) * l + g) + 2) +
                    p
              );
            },
          ],
        },
        y = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)",
        },
        R = document,
        S = window,
        C = "bkwld-tram",
        A = /[\-\.0-9]/g,
        w = /[A-Z]/,
        m = "number",
        x = /^(rgb|#)/,
        L = /(em|cm|mm|in|pt|pc|px)$/,
        N = /(em|cm|mm|in|pt|pc|px|%)$/,
        X = /(deg|rad|turn)$/,
        k = "unitless",
        Y = /(all|none) 0s ease 0s/,
        se = /^(width|height)$/,
        te = " ",
        M = R.createElement("a"),
        I = ["Webkit", "Moz", "O", "ms"],
        P = ["-webkit-", "-moz-", "-o-", "-ms-"],
        D = function (l) {
          if (l in M.style) return { dom: l, css: l };
          var p,
            _,
            T = "",
            g = l.split("-");
          for (p = 0; p < g.length; p++)
            T += g[p].charAt(0).toUpperCase() + g[p].slice(1);
          for (p = 0; p < I.length; p++)
            if (((_ = I[p] + T), _ in M.style))
              return { dom: _, css: P[p] + l };
        },
        G = (t.support = {
          bind: Function.prototype.bind,
          transform: D("transform"),
          transition: D("transition"),
          backface: D("backface-visibility"),
          timing: D("transition-timing-function"),
        });
      if (G.transition) {
        var Q = G.timing.dom;
        if (((M.style[Q] = h["ease-in-back"][0]), !M.style[Q]))
          for (var re in y) h[re][0] = y[re];
      }
      var q = (t.frame = (function () {
          var l =
            S.requestAnimationFrame ||
            S.webkitRequestAnimationFrame ||
            S.mozRequestAnimationFrame ||
            S.oRequestAnimationFrame ||
            S.msRequestAnimationFrame;
          return l && G.bind
            ? l.bind(S)
            : function (p) {
                S.setTimeout(p, 16);
              };
        })()),
        H = (t.now = (function () {
          var l = S.performance,
            p = l && (l.now || l.webkitNow || l.msNow || l.mozNow);
          return p && G.bind
            ? p.bind(l)
            : Date.now ||
                function () {
                  return +new Date();
                };
        })()),
        j = v(function (l) {
          function p(J, de) {
            var Te = E(("" + J).split(te)),
              ve = Te[0];
            de = de || {};
            var Fe = B[ve];
            if (!Fe) return f("Unsupported property: " + ve);
            if (!de.weak || !this.props[ve]) {
              var ze = Fe[0],
                Ve = this.props[ve];
              return (
                Ve || (Ve = this.props[ve] = new ze.Bare()),
                Ve.init(this.$el, Te, Fe, de),
                Ve
              );
            }
          }
          function _(J, de, Te) {
            if (J) {
              var ve = typeof J;
              if (
                (de ||
                  (this.timer && this.timer.destroy(),
                  (this.queue = []),
                  (this.active = !1)),
                ve == "number" && de)
              )
                return (
                  (this.timer = new ge({
                    duration: J,
                    context: this,
                    complete: O,
                  })),
                  void (this.active = !0)
                );
              if (ve == "string" && de) {
                switch (J) {
                  case "hide":
                    W.call(this);
                    break;
                  case "stop":
                    z.call(this);
                    break;
                  case "redraw":
                    ue.call(this);
                    break;
                  default:
                    p.call(this, J, Te && Te[1]);
                }
                return O.call(this);
              }
              if (ve == "function") return void J.call(this, this);
              if (ve == "object") {
                var Fe = 0;
                it.call(
                  this,
                  J,
                  function (Ae, dI) {
                    Ae.span > Fe && (Fe = Ae.span), Ae.stop(), Ae.animate(dI);
                  },
                  function (Ae) {
                    "wait" in Ae && (Fe = c(Ae.wait, 0));
                  }
                ),
                  Se.call(this),
                  Fe > 0 &&
                    ((this.timer = new ge({ duration: Fe, context: this })),
                    (this.active = !0),
                    de && (this.timer.complete = O));
                var ze = this,
                  Ve = !1,
                  sn = {};
                q(function () {
                  it.call(ze, J, function (Ae) {
                    Ae.active && ((Ve = !0), (sn[Ae.name] = Ae.nextStyle));
                  }),
                    Ve && ze.$el.css(sn);
                });
              }
            }
          }
          function T(J) {
            (J = c(J, 0)),
              this.active
                ? this.queue.push({ options: J })
                : ((this.timer = new ge({
                    duration: J,
                    context: this,
                    complete: O,
                  })),
                  (this.active = !0));
          }
          function g(J) {
            return this.active
              ? (this.queue.push({ options: J, args: arguments }),
                void (this.timer.complete = O))
              : f(
                  "No active transition timer. Use start() or wait() before then()."
                );
          }
          function O() {
            if (
              (this.timer && this.timer.destroy(),
              (this.active = !1),
              this.queue.length)
            ) {
              var J = this.queue.shift();
              _.call(this, J.options, !0, J.args);
            }
          }
          function z(J) {
            this.timer && this.timer.destroy(),
              (this.queue = []),
              (this.active = !1);
            var de;
            typeof J == "string"
              ? ((de = {}), (de[J] = 1))
              : (de = typeof J == "object" && J != null ? J : this.props),
              it.call(this, de, De),
              Se.call(this);
          }
          function ne(J) {
            z.call(this, J), it.call(this, J, br, lI);
          }
          function _e(J) {
            typeof J != "string" && (J = "block"), (this.el.style.display = J);
          }
          function W() {
            z.call(this), (this.el.style.display = "none");
          }
          function ue() {
            this.el.offsetHeight;
          }
          function fe() {
            z.call(this), e.removeData(this.el, C), (this.$el = this.el = null);
          }
          function Se() {
            var J,
              de,
              Te = [];
            this.upstream && Te.push(this.upstream);
            for (J in this.props)
              (de = this.props[J]), de.active && Te.push(de.string);
            (Te = Te.join(",")),
              this.style !== Te &&
                ((this.style = Te), (this.el.style[G.transition.dom] = Te));
          }
          function it(J, de, Te) {
            var ve,
              Fe,
              ze,
              Ve,
              sn = de !== De,
              Ae = {};
            for (ve in J)
              (ze = J[ve]),
                ve in ye
                  ? (Ae.transform || (Ae.transform = {}),
                    (Ae.transform[ve] = ze))
                  : (w.test(ve) && (ve = r(ve)),
                    ve in B ? (Ae[ve] = ze) : (Ve || (Ve = {}), (Ve[ve] = ze)));
            for (ve in Ae) {
              if (((ze = Ae[ve]), (Fe = this.props[ve]), !Fe)) {
                if (!sn) continue;
                Fe = p.call(this, ve);
              }
              de.call(this, Fe, ze);
            }
            Te && Ve && Te.call(this, Ve);
          }
          function De(J) {
            J.stop();
          }
          function br(J, de) {
            J.set(de);
          }
          function lI(J) {
            this.$el.css(J);
          }
          function Ke(J, de) {
            l[J] = function () {
              return this.children
                ? fI.call(this, de, arguments)
                : (this.el && de.apply(this, arguments), this);
            };
          }
          function fI(J, de) {
            var Te,
              ve = this.children.length;
            for (Te = 0; ve > Te; Te++) J.apply(this.children[Te], de);
            return this;
          }
          (l.init = function (J) {
            if (
              ((this.$el = e(J)),
              (this.el = this.$el[0]),
              (this.props = {}),
              (this.queue = []),
              (this.style = ""),
              (this.active = !1),
              pe.keepInherited && !pe.fallback)
            ) {
              var de = V(this.el, "transition");
              de && !Y.test(de) && (this.upstream = de);
            }
            G.backface &&
              pe.hideBackface &&
              d(this.el, G.backface.css, "hidden");
          }),
            Ke("add", p),
            Ke("start", _),
            Ke("wait", T),
            Ke("then", g),
            Ke("next", O),
            Ke("stop", z),
            Ke("set", ne),
            Ke("show", _e),
            Ke("hide", W),
            Ke("redraw", ue),
            Ke("destroy", fe);
        }),
        U = v(j, function (l) {
          function p(_, T) {
            var g = e.data(_, C) || e.data(_, C, new j.Bare());
            return g.el || g.init(_), T ? g.start(T) : g;
          }
          l.init = function (_, T) {
            var g = e(_);
            if (!g.length) return this;
            if (g.length === 1) return p(g[0], T);
            var O = [];
            return (
              g.each(function (z, ne) {
                O.push(p(ne, T));
              }),
              (this.children = O),
              this
            );
          };
        }),
        F = v(function (l) {
          function p() {
            var O = this.get();
            this.update("auto");
            var z = this.get();
            return this.update(O), z;
          }
          function _(O, z, ne) {
            return z !== void 0 && (ne = z), O in h ? O : ne;
          }
          function T(O) {
            var z = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(O);
            return (z ? o(z[1], z[2], z[3]) : O).replace(
              /#(\w)(\w)(\w)$/,
              "#$1$1$2$2$3$3"
            );
          }
          var g = { duration: 500, ease: "ease", delay: 0 };
          (l.init = function (O, z, ne, _e) {
            (this.$el = O), (this.el = O[0]);
            var W = z[0];
            ne[2] && (W = ne[2]),
              K[W] && (W = K[W]),
              (this.name = W),
              (this.type = ne[1]),
              (this.duration = c(z[1], this.duration, g.duration)),
              (this.ease = _(z[2], this.ease, g.ease)),
              (this.delay = c(z[3], this.delay, g.delay)),
              (this.span = this.duration + this.delay),
              (this.active = !1),
              (this.nextStyle = null),
              (this.auto = se.test(this.name)),
              (this.unit = _e.unit || this.unit || pe.defaultUnit),
              (this.angle = _e.angle || this.angle || pe.defaultAngle),
              pe.fallback || _e.fallback
                ? (this.animate = this.fallback)
                : ((this.animate = this.transition),
                  (this.string =
                    this.name +
                    te +
                    this.duration +
                    "ms" +
                    (this.ease != "ease" ? te + h[this.ease][0] : "") +
                    (this.delay ? te + this.delay + "ms" : "")));
          }),
            (l.set = function (O) {
              (O = this.convert(O, this.type)), this.update(O), this.redraw();
            }),
            (l.transition = function (O) {
              (this.active = !0),
                (O = this.convert(O, this.type)),
                this.auto &&
                  (this.el.style[this.name] == "auto" &&
                    (this.update(this.get()), this.redraw()),
                  O == "auto" && (O = p.call(this))),
                (this.nextStyle = O);
            }),
            (l.fallback = function (O) {
              var z =
                this.el.style[this.name] || this.convert(this.get(), this.type);
              (O = this.convert(O, this.type)),
                this.auto &&
                  (z == "auto" && (z = this.convert(this.get(), this.type)),
                  O == "auto" && (O = p.call(this))),
                (this.tween = new ee({
                  from: z,
                  to: O,
                  duration: this.duration,
                  delay: this.delay,
                  ease: this.ease,
                  update: this.update,
                  context: this,
                }));
            }),
            (l.get = function () {
              return V(this.el, this.name);
            }),
            (l.update = function (O) {
              d(this.el, this.name, O);
            }),
            (l.stop = function () {
              (this.active || this.nextStyle) &&
                ((this.active = !1),
                (this.nextStyle = null),
                d(this.el, this.name, this.get()));
              var O = this.tween;
              O && O.context && O.destroy();
            }),
            (l.convert = function (O, z) {
              if (O == "auto" && this.auto) return O;
              var ne,
                _e = typeof O == "number",
                W = typeof O == "string";
              switch (z) {
                case m:
                  if (_e) return O;
                  if (W && O.replace(A, "") === "") return +O;
                  ne = "number(unitless)";
                  break;
                case x:
                  if (W) {
                    if (O === "" && this.original) return this.original;
                    if (z.test(O))
                      return O.charAt(0) == "#" && O.length == 7 ? O : T(O);
                  }
                  ne = "hex or rgb string";
                  break;
                case L:
                  if (_e) return O + this.unit;
                  if (W && z.test(O)) return O;
                  ne = "number(px) or string(unit)";
                  break;
                case N:
                  if (_e) return O + this.unit;
                  if (W && z.test(O)) return O;
                  ne = "number(px) or string(unit or %)";
                  break;
                case X:
                  if (_e) return O + this.angle;
                  if (W && z.test(O)) return O;
                  ne = "number(deg) or string(angle)";
                  break;
                case k:
                  if (_e || (W && N.test(O))) return O;
                  ne = "number(unitless) or string(unit or %)";
              }
              return a(ne, O), O;
            }),
            (l.redraw = function () {
              this.el.offsetHeight;
            });
        }),
        Z = v(F, function (l, p) {
          l.init = function () {
            p.init.apply(this, arguments),
              this.original || (this.original = this.convert(this.get(), x));
          };
        }),
        ce = v(F, function (l, p) {
          (l.init = function () {
            p.init.apply(this, arguments), (this.animate = this.fallback);
          }),
            (l.get = function () {
              return this.$el[this.name]();
            }),
            (l.update = function (_) {
              this.$el[this.name](_);
            });
        }),
        le = v(F, function (l, p) {
          function _(T, g) {
            var O, z, ne, _e, W;
            for (O in T)
              (_e = ye[O]),
                (ne = _e[0]),
                (z = _e[1] || O),
                (W = this.convert(T[O], ne)),
                g.call(this, z, W, ne);
          }
          (l.init = function () {
            p.init.apply(this, arguments),
              this.current ||
                ((this.current = {}),
                ye.perspective &&
                  pe.perspective &&
                  ((this.current.perspective = pe.perspective),
                  d(this.el, this.name, this.style(this.current)),
                  this.redraw()));
          }),
            (l.set = function (T) {
              _.call(this, T, function (g, O) {
                this.current[g] = O;
              }),
                d(this.el, this.name, this.style(this.current)),
                this.redraw();
            }),
            (l.transition = function (T) {
              var g = this.values(T);
              this.tween = new Et({
                current: this.current,
                values: g,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
              });
              var O,
                z = {};
              for (O in this.current) z[O] = O in g ? g[O] : this.current[O];
              (this.active = !0), (this.nextStyle = this.style(z));
            }),
            (l.fallback = function (T) {
              var g = this.values(T);
              this.tween = new Et({
                current: this.current,
                values: g,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this,
              });
            }),
            (l.update = function () {
              d(this.el, this.name, this.style(this.current));
            }),
            (l.style = function (T) {
              var g,
                O = "";
              for (g in T) O += g + "(" + T[g] + ") ";
              return O;
            }),
            (l.values = function (T) {
              var g,
                O = {};
              return (
                _.call(this, T, function (z, ne, _e) {
                  (O[z] = ne),
                    this.current[z] === void 0 &&
                      ((g = 0),
                      ~z.indexOf("scale") && (g = 1),
                      (this.current[z] = this.convert(g, _e)));
                }),
                O
              );
            });
        }),
        ee = v(function (l) {
          function p(W) {
            ne.push(W) === 1 && q(_);
          }
          function _() {
            var W,
              ue,
              fe,
              Se = ne.length;
            if (Se)
              for (q(_), ue = H(), W = Se; W--; )
                (fe = ne[W]), fe && fe.render(ue);
          }
          function T(W) {
            var ue,
              fe = e.inArray(W, ne);
            fe >= 0 &&
              ((ue = ne.slice(fe + 1)),
              (ne.length = fe),
              ue.length && (ne = ne.concat(ue)));
          }
          function g(W) {
            return Math.round(W * _e) / _e;
          }
          function O(W, ue, fe) {
            return o(
              W[0] + fe * (ue[0] - W[0]),
              W[1] + fe * (ue[1] - W[1]),
              W[2] + fe * (ue[2] - W[2])
            );
          }
          var z = { ease: h.ease[1], from: 0, to: 1 };
          (l.init = function (W) {
            (this.duration = W.duration || 0), (this.delay = W.delay || 0);
            var ue = W.ease || z.ease;
            h[ue] && (ue = h[ue][1]),
              typeof ue != "function" && (ue = z.ease),
              (this.ease = ue),
              (this.update = W.update || i),
              (this.complete = W.complete || i),
              (this.context = W.context || this),
              (this.name = W.name);
            var fe = W.from,
              Se = W.to;
            fe === void 0 && (fe = z.from),
              Se === void 0 && (Se = z.to),
              (this.unit = W.unit || ""),
              typeof fe == "number" && typeof Se == "number"
                ? ((this.begin = fe), (this.change = Se - fe))
                : this.format(Se, fe),
              (this.value = this.begin + this.unit),
              (this.start = H()),
              W.autoplay !== !1 && this.play();
          }),
            (l.play = function () {
              this.active ||
                (this.start || (this.start = H()), (this.active = !0), p(this));
            }),
            (l.stop = function () {
              this.active && ((this.active = !1), T(this));
            }),
            (l.render = function (W) {
              var ue,
                fe = W - this.start;
              if (this.delay) {
                if (fe <= this.delay) return;
                fe -= this.delay;
              }
              if (fe < this.duration) {
                var Se = this.ease(fe, 0, 1, this.duration);
                return (
                  (ue = this.startRGB
                    ? O(this.startRGB, this.endRGB, Se)
                    : g(this.begin + Se * this.change)),
                  (this.value = ue + this.unit),
                  void this.update.call(this.context, this.value)
                );
              }
              (ue = this.endHex || this.begin + this.change),
                (this.value = ue + this.unit),
                this.update.call(this.context, this.value),
                this.complete.call(this.context),
                this.destroy();
            }),
            (l.format = function (W, ue) {
              if (((ue += ""), (W += ""), W.charAt(0) == "#"))
                return (
                  (this.startRGB = n(ue)),
                  (this.endRGB = n(W)),
                  (this.endHex = W),
                  (this.begin = 0),
                  void (this.change = 1)
                );
              if (!this.unit) {
                var fe = ue.replace(A, ""),
                  Se = W.replace(A, "");
                fe !== Se && s("tween", ue, W), (this.unit = fe);
              }
              (ue = parseFloat(ue)),
                (W = parseFloat(W)),
                (this.begin = this.value = ue),
                (this.change = W - ue);
            }),
            (l.destroy = function () {
              this.stop(),
                (this.context = null),
                (this.ease = this.update = this.complete = i);
            });
          var ne = [],
            _e = 1e3;
        }),
        ge = v(ee, function (l) {
          (l.init = function (p) {
            (this.duration = p.duration || 0),
              (this.complete = p.complete || i),
              (this.context = p.context),
              this.play();
          }),
            (l.render = function (p) {
              var _ = p - this.start;
              _ < this.duration ||
                (this.complete.call(this.context), this.destroy());
            });
        }),
        Et = v(ee, function (l, p) {
          (l.init = function (_) {
            (this.context = _.context),
              (this.update = _.update),
              (this.tweens = []),
              (this.current = _.current);
            var T, g;
            for (T in _.values)
              (g = _.values[T]),
                this.current[T] !== g &&
                  this.tweens.push(
                    new ee({
                      name: T,
                      from: this.current[T],
                      to: g,
                      duration: _.duration,
                      delay: _.delay,
                      ease: _.ease,
                      autoplay: !1,
                    })
                  );
            this.play();
          }),
            (l.render = function (_) {
              var T,
                g,
                O = this.tweens.length,
                z = !1;
              for (T = O; T--; )
                (g = this.tweens[T]),
                  g.context &&
                    (g.render(_), (this.current[g.name] = g.value), (z = !0));
              return z
                ? void (this.update && this.update.call(this.context))
                : this.destroy();
            }),
            (l.destroy = function () {
              if ((p.destroy.call(this), this.tweens)) {
                var _,
                  T = this.tweens.length;
                for (_ = T; _--; ) this.tweens[_].destroy();
                (this.tweens = null), (this.current = null);
              }
            });
        }),
        pe = (t.config = {
          debug: !1,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: !1,
          hideBackface: !1,
          perspective: "",
          fallback: !G.transition,
          agentTests: [],
        });
      (t.fallback = function (l) {
        if (!G.transition) return (pe.fallback = !0);
        pe.agentTests.push("(" + l + ")");
        var p = new RegExp(pe.agentTests.join("|"), "i");
        pe.fallback = p.test(navigator.userAgent);
      }),
        t.fallback("6.0.[2-5] Safari"),
        (t.tween = function (l) {
          return new ee(l);
        }),
        (t.delay = function (l, p, _) {
          return new ge({ complete: p, duration: l, context: _ });
        }),
        (e.fn.tram = function (l) {
          return t.call(null, this, l);
        });
      var d = e.style,
        V = e.css,
        K = { transform: G.transform && G.transform.css },
        B = {
          color: [Z, x],
          background: [Z, x, "background-color"],
          "outline-color": [Z, x],
          "border-color": [Z, x],
          "border-top-color": [Z, x],
          "border-right-color": [Z, x],
          "border-bottom-color": [Z, x],
          "border-left-color": [Z, x],
          "border-width": [F, L],
          "border-top-width": [F, L],
          "border-right-width": [F, L],
          "border-bottom-width": [F, L],
          "border-left-width": [F, L],
          "border-spacing": [F, L],
          "letter-spacing": [F, L],
          margin: [F, L],
          "margin-top": [F, L],
          "margin-right": [F, L],
          "margin-bottom": [F, L],
          "margin-left": [F, L],
          padding: [F, L],
          "padding-top": [F, L],
          "padding-right": [F, L],
          "padding-bottom": [F, L],
          "padding-left": [F, L],
          "outline-width": [F, L],
          opacity: [F, m],
          top: [F, N],
          right: [F, N],
          bottom: [F, N],
          left: [F, N],
          "font-size": [F, N],
          "text-indent": [F, N],
          "word-spacing": [F, N],
          width: [F, N],
          "min-width": [F, N],
          "max-width": [F, N],
          height: [F, N],
          "min-height": [F, N],
          "max-height": [F, N],
          "line-height": [F, k],
          "scroll-top": [ce, m, "scrollTop"],
          "scroll-left": [ce, m, "scrollLeft"],
        },
        ye = {};
      G.transform &&
        ((B.transform = [le]),
        (ye = {
          x: [N, "translateX"],
          y: [N, "translateY"],
          rotate: [X],
          rotateX: [X],
          rotateY: [X],
          scale: [m],
          scaleX: [m],
          scaleY: [m],
          skew: [X],
          skewX: [X],
          skewY: [X],
        })),
        G.transform &&
          G.backface &&
          ((ye.z = [N, "translateZ"]),
          (ye.rotateZ = [X]),
          (ye.scaleZ = [m]),
          (ye.perspective = [L]));
      var Lt = /ms/,
        ht = /s|\./;
      return (e.tram = t);
    })(window.jQuery);
  });
  var Os = u((bW, Ts) => {
    var pI = window.$,
      vI = Fi() && pI.tram;
    Ts.exports = (function () {
      var e = {};
      e.VERSION = "1.6.0-Webflow";
      var t = {},
        r = Array.prototype,
        n = Object.prototype,
        o = Function.prototype,
        i = r.push,
        a = r.slice,
        s = r.concat,
        c = n.toString,
        f = n.hasOwnProperty,
        E = r.forEach,
        v = r.map,
        h = r.reduce,
        y = r.reduceRight,
        R = r.filter,
        S = r.every,
        C = r.some,
        A = r.indexOf,
        w = r.lastIndexOf,
        m = Array.isArray,
        x = Object.keys,
        L = o.bind,
        N =
          (e.each =
          e.forEach =
            function (I, P, D) {
              if (I == null) return I;
              if (E && I.forEach === E) I.forEach(P, D);
              else if (I.length === +I.length) {
                for (var G = 0, Q = I.length; G < Q; G++)
                  if (P.call(D, I[G], G, I) === t) return;
              } else
                for (var re = e.keys(I), G = 0, Q = re.length; G < Q; G++)
                  if (P.call(D, I[re[G]], re[G], I) === t) return;
              return I;
            });
      (e.map = e.collect =
        function (I, P, D) {
          var G = [];
          return I == null
            ? G
            : v && I.map === v
            ? I.map(P, D)
            : (N(I, function (Q, re, q) {
                G.push(P.call(D, Q, re, q));
              }),
              G);
        }),
        (e.find = e.detect =
          function (I, P, D) {
            var G;
            return (
              X(I, function (Q, re, q) {
                if (P.call(D, Q, re, q)) return (G = Q), !0;
              }),
              G
            );
          }),
        (e.filter = e.select =
          function (I, P, D) {
            var G = [];
            return I == null
              ? G
              : R && I.filter === R
              ? I.filter(P, D)
              : (N(I, function (Q, re, q) {
                  P.call(D, Q, re, q) && G.push(Q);
                }),
                G);
          });
      var X =
        (e.some =
        e.any =
          function (I, P, D) {
            P || (P = e.identity);
            var G = !1;
            return I == null
              ? G
              : C && I.some === C
              ? I.some(P, D)
              : (N(I, function (Q, re, q) {
                  if (G || (G = P.call(D, Q, re, q))) return t;
                }),
                !!G);
          });
      (e.contains = e.include =
        function (I, P) {
          return I == null
            ? !1
            : A && I.indexOf === A
            ? I.indexOf(P) != -1
            : X(I, function (D) {
                return D === P;
              });
        }),
        (e.delay = function (I, P) {
          var D = a.call(arguments, 2);
          return setTimeout(function () {
            return I.apply(null, D);
          }, P);
        }),
        (e.defer = function (I) {
          return e.delay.apply(e, [I, 1].concat(a.call(arguments, 1)));
        }),
        (e.throttle = function (I) {
          var P, D, G;
          return function () {
            P ||
              ((P = !0),
              (D = arguments),
              (G = this),
              vI.frame(function () {
                (P = !1), I.apply(G, D);
              }));
          };
        }),
        (e.debounce = function (I, P, D) {
          var G,
            Q,
            re,
            q,
            H,
            j = function () {
              var U = e.now() - q;
              U < P
                ? (G = setTimeout(j, P - U))
                : ((G = null), D || ((H = I.apply(re, Q)), (re = Q = null)));
            };
          return function () {
            (re = this), (Q = arguments), (q = e.now());
            var U = D && !G;
            return (
              G || (G = setTimeout(j, P)),
              U && ((H = I.apply(re, Q)), (re = Q = null)),
              H
            );
          };
        }),
        (e.defaults = function (I) {
          if (!e.isObject(I)) return I;
          for (var P = 1, D = arguments.length; P < D; P++) {
            var G = arguments[P];
            for (var Q in G) I[Q] === void 0 && (I[Q] = G[Q]);
          }
          return I;
        }),
        (e.keys = function (I) {
          if (!e.isObject(I)) return [];
          if (x) return x(I);
          var P = [];
          for (var D in I) e.has(I, D) && P.push(D);
          return P;
        }),
        (e.has = function (I, P) {
          return f.call(I, P);
        }),
        (e.isObject = function (I) {
          return I === Object(I);
        }),
        (e.now =
          Date.now ||
          function () {
            return new Date().getTime();
          }),
        (e.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g,
        });
      var k = /(.)^/,
        Y = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029",
        },
        se = /\\|'|\r|\n|\u2028|\u2029/g,
        te = function (I) {
          return "\\" + Y[I];
        },
        M = /^\s*(\w|\$)+\s*$/;
      return (
        (e.template = function (I, P, D) {
          !P && D && (P = D), (P = e.defaults({}, P, e.templateSettings));
          var G = RegExp(
              [
                (P.escape || k).source,
                (P.interpolate || k).source,
                (P.evaluate || k).source,
              ].join("|") + "|$",
              "g"
            ),
            Q = 0,
            re = "__p+='";
          I.replace(G, function (U, F, Z, ce, le) {
            return (
              (re += I.slice(Q, le).replace(se, te)),
              (Q = le + U.length),
              F
                ? (re +=
                    `'+
((__t=(` +
                    F +
                    `))==null?'':_.escape(__t))+
'`)
                : Z
                ? (re +=
                    `'+
((__t=(` +
                    Z +
                    `))==null?'':__t)+
'`)
                : ce &&
                  (re +=
                    `';
` +
                    ce +
                    `
__p+='`),
              U
            );
          }),
            (re += `';
`);
          var q = P.variable;
          if (q) {
            if (!M.test(q))
              throw new Error("variable is not a bare identifier: " + q);
          } else
            (re =
              `with(obj||{}){
` +
              re +
              `}
`),
              (q = "obj");
          re =
            `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` +
            re +
            `return __p;
`;
          var H;
          try {
            H = new Function(P.variable || "obj", "_", re);
          } catch (U) {
            throw ((U.source = re), U);
          }
          var j = function (U) {
            return H.call(this, U, e);
          };
          return (
            (j.source =
              "function(" +
              q +
              `){
` +
              re +
              "}"),
            j
          );
        }),
        e
      );
    })();
  });
  var at = u((SW, qs) => {
    var Ee = {},
      Kt = {},
      zt = [],
      Xi = window.Webflow || [],
      Tt = window.jQuery,
      Qe = Tt(window),
      EI = Tt(document),
      ot = Tt.isFunction,
      Ye = (Ee._ = Os()),
      Ss = (Ee.tram = Fi() && Tt.tram),
      cn = !1,
      Ui = !1;
    Ss.config.hideBackface = !1;
    Ss.config.keepInherited = !0;
    Ee.define = function (e, t, r) {
      Kt[e] && ws(Kt[e]);
      var n = (Kt[e] = t(Tt, Ye, r) || {});
      return As(n), n;
    };
    Ee.require = function (e) {
      return Kt[e];
    };
    function As(e) {
      Ee.env() &&
        (ot(e.design) && Qe.on("__wf_design", e.design),
        ot(e.preview) && Qe.on("__wf_preview", e.preview)),
        ot(e.destroy) && Qe.on("__wf_destroy", e.destroy),
        e.ready && ot(e.ready) && hI(e);
    }
    function hI(e) {
      if (cn) {
        e.ready();
        return;
      }
      Ye.contains(zt, e.ready) || zt.push(e.ready);
    }
    function ws(e) {
      ot(e.design) && Qe.off("__wf_design", e.design),
        ot(e.preview) && Qe.off("__wf_preview", e.preview),
        ot(e.destroy) && Qe.off("__wf_destroy", e.destroy),
        e.ready && ot(e.ready) && gI(e);
    }
    function gI(e) {
      zt = Ye.filter(zt, function (t) {
        return t !== e.ready;
      });
    }
    Ee.push = function (e) {
      if (cn) {
        ot(e) && e();
        return;
      }
      Xi.push(e);
    };
    Ee.env = function (e) {
      var t = window.__wf_design,
        r = typeof t < "u";
      if (!e) return r;
      if (e === "design") return r && t;
      if (e === "preview") return r && !t;
      if (e === "slug") return r && window.__wf_slug;
      if (e === "editor") return window.WebflowEditor;
      if (e === "test") return window.__wf_test;
      if (e === "frame") return window !== window.top;
    };
    var un = navigator.userAgent.toLowerCase(),
      Rs = (Ee.env.touch =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
      _I = (Ee.env.chrome =
        /chrome/.test(un) &&
        /Google/.test(navigator.vendor) &&
        parseInt(un.match(/chrome\/(\d+)\./)[1], 10)),
      yI = (Ee.env.ios = /(ipod|iphone|ipad)/.test(un));
    Ee.env.safari = /safari/.test(un) && !_I && !yI;
    var Gi;
    Rs &&
      EI.on("touchstart mousedown", function (e) {
        Gi = e.target;
      });
    Ee.validClick = Rs
      ? function (e) {
          return e === Gi || Tt.contains(e, Gi);
        }
      : function () {
          return !0;
        };
    var Cs = "resize.webflow orientationchange.webflow load.webflow",
      II = "scroll.webflow " + Cs;
    Ee.resize = Vi(Qe, Cs);
    Ee.scroll = Vi(Qe, II);
    Ee.redraw = Vi();
    function Vi(e, t) {
      var r = [],
        n = {};
      return (
        (n.up = Ye.throttle(function (o) {
          Ye.each(r, function (i) {
            i(o);
          });
        })),
        e && t && e.on(t, n.up),
        (n.on = function (o) {
          typeof o == "function" && (Ye.contains(r, o) || r.push(o));
        }),
        (n.off = function (o) {
          if (!arguments.length) {
            r = [];
            return;
          }
          r = Ye.filter(r, function (i) {
            return i !== o;
          });
        }),
        n
      );
    }
    Ee.location = function (e) {
      window.location = e;
    };
    Ee.env() && (Ee.location = function () {});
    Ee.ready = function () {
      (cn = !0), Ui ? mI() : Ye.each(zt, bs), Ye.each(Xi, bs), Ee.resize.up();
    };
    function bs(e) {
      ot(e) && e();
    }
    function mI() {
      (Ui = !1), Ye.each(Kt, As);
    }
    var xt;
    Ee.load = function (e) {
      xt.then(e);
    };
    function Ns() {
      xt && (xt.reject(), Qe.off("load", xt.resolve)),
        (xt = new Tt.Deferred()),
        Qe.on("load", xt.resolve);
    }
    Ee.destroy = function (e) {
      (e = e || {}),
        (Ui = !0),
        Qe.triggerHandler("__wf_destroy"),
        e.domready != null && (cn = e.domready),
        Ye.each(Kt, ws),
        Ee.resize.off(),
        Ee.scroll.off(),
        Ee.redraw.off(),
        (zt = []),
        (Xi = []),
        xt.state() === "pending" && Ns();
    };
    Tt(Ee.ready);
    Ns();
    qs.exports = window.Webflow = Ee;
  });
  var xs = u((AW, Ls) => {
    var Ps = at();
    Ps.define(
      "brand",
      (Ls.exports = function (e) {
        var t = {},
          r = document,
          n = e("html"),
          o = e("body"),
          i = ".w-webflow-badge",
          a = window.location,
          s = /PhantomJS/i.test(navigator.userAgent),
          c =
            "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange",
          f;
        t.ready = function () {
          var y = n.attr("data-wf-status"),
            R = n.attr("data-wf-domain") || "";
          /\.webflow\.io$/i.test(R) && a.hostname !== R && (y = !0),
            y &&
              !s &&
              ((f = f || v()),
              h(),
              setTimeout(h, 500),
              e(r).off(c, E).on(c, E));
        };
        function E() {
          var y =
            r.fullScreen ||
            r.mozFullScreen ||
            r.webkitIsFullScreen ||
            r.msFullscreenElement ||
            !!r.webkitFullscreenElement;
          e(f).attr("style", y ? "display: none !important;" : "");
        }
        function v() {
          var y = e('<a class="w-webflow-badge"></a>').attr(
              "href",
              "https://webflow.com?utm_campaign=brandjs"
            ),
            R = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon.f67cd735e3.svg"
              )
              .attr("alt", "")
              .css({ marginRight: "8px", width: "16px" }),
            S = e("<img>")
              .attr(
                "src",
                "https://d1otoma47x30pg.cloudfront.net/img/webflow-badge-text.6faa6a38cd.svg"
              )
              .attr("alt", "Made in Webflow");
          return y.append(R, S), y[0];
        }
        function h() {
          var y = o.children(i),
            R = y.length && y.get(0) === f,
            S = Ps.env("editor");
          if (R) {
            S && y.remove();
            return;
          }
          y.length && y.remove(), S || o.append(f);
        }
        return t;
      })
    );
  });
  var Ds = u((wW, Ms) => {
    var TI = at();
    TI.define(
      "focus-visible",
      (Ms.exports = function () {
        function e(r) {
          var n = !0,
            o = !1,
            i = null,
            a = {
              text: !0,
              search: !0,
              url: !0,
              tel: !0,
              email: !0,
              password: !0,
              number: !0,
              date: !0,
              month: !0,
              week: !0,
              time: !0,
              datetime: !0,
              "datetime-local": !0,
            };
          function s(m) {
            return !!(
              m &&
              m !== document &&
              m.nodeName !== "HTML" &&
              m.nodeName !== "BODY" &&
              "classList" in m &&
              "contains" in m.classList
            );
          }
          function c(m) {
            var x = m.type,
              L = m.tagName;
            return !!(
              (L === "INPUT" && a[x] && !m.readOnly) ||
              (L === "TEXTAREA" && !m.readOnly) ||
              m.isContentEditable
            );
          }
          function f(m) {
            m.getAttribute("data-wf-focus-visible") ||
              m.setAttribute("data-wf-focus-visible", "true");
          }
          function E(m) {
            m.getAttribute("data-wf-focus-visible") &&
              m.removeAttribute("data-wf-focus-visible");
          }
          function v(m) {
            m.metaKey ||
              m.altKey ||
              m.ctrlKey ||
              (s(r.activeElement) && f(r.activeElement), (n = !0));
          }
          function h() {
            n = !1;
          }
          function y(m) {
            s(m.target) && (n || c(m.target)) && f(m.target);
          }
          function R(m) {
            s(m.target) &&
              m.target.hasAttribute("data-wf-focus-visible") &&
              ((o = !0),
              window.clearTimeout(i),
              (i = window.setTimeout(function () {
                o = !1;
              }, 100)),
              E(m.target));
          }
          function S() {
            document.visibilityState === "hidden" && (o && (n = !0), C());
          }
          function C() {
            document.addEventListener("mousemove", w),
              document.addEventListener("mousedown", w),
              document.addEventListener("mouseup", w),
              document.addEventListener("pointermove", w),
              document.addEventListener("pointerdown", w),
              document.addEventListener("pointerup", w),
              document.addEventListener("touchmove", w),
              document.addEventListener("touchstart", w),
              document.addEventListener("touchend", w);
          }
          function A() {
            document.removeEventListener("mousemove", w),
              document.removeEventListener("mousedown", w),
              document.removeEventListener("mouseup", w),
              document.removeEventListener("pointermove", w),
              document.removeEventListener("pointerdown", w),
              document.removeEventListener("pointerup", w),
              document.removeEventListener("touchmove", w),
              document.removeEventListener("touchstart", w),
              document.removeEventListener("touchend", w);
          }
          function w(m) {
            (m.target.nodeName && m.target.nodeName.toLowerCase() === "html") ||
              ((n = !1), A());
          }
          document.addEventListener("keydown", v, !0),
            document.addEventListener("mousedown", h, !0),
            document.addEventListener("pointerdown", h, !0),
            document.addEventListener("touchstart", h, !0),
            document.addEventListener("visibilitychange", S, !0),
            C(),
            r.addEventListener("focus", y, !0),
            r.addEventListener("blur", R, !0);
        }
        function t() {
          if (typeof document < "u")
            try {
              document.querySelector(":focus-visible");
            } catch {
              e(document);
            }
        }
        return { ready: t };
      })
    );
  });
  var Xs = u((RW, Gs) => {
    var Fs = at();
    Fs.define(
      "focus",
      (Gs.exports = function () {
        var e = [],
          t = !1;
        function r(a) {
          t &&
            (a.preventDefault(),
            a.stopPropagation(),
            a.stopImmediatePropagation(),
            e.unshift(a));
        }
        function n(a) {
          var s = a.target,
            c = s.tagName;
          return (
            (/^a$/i.test(c) && s.href != null) ||
            (/^(button|textarea)$/i.test(c) && s.disabled !== !0) ||
            (/^input$/i.test(c) &&
              /^(button|reset|submit|radio|checkbox)$/i.test(s.type) &&
              !s.disabled) ||
            (!/^(button|input|textarea|select|a)$/i.test(c) &&
              !Number.isNaN(Number.parseFloat(s.tabIndex))) ||
            /^audio$/i.test(c) ||
            (/^video$/i.test(c) && s.controls === !0)
          );
        }
        function o(a) {
          n(a) &&
            ((t = !0),
            setTimeout(() => {
              for (t = !1, a.target.focus(); e.length > 0; ) {
                var s = e.pop();
                s.target.dispatchEvent(new MouseEvent(s.type, s));
              }
            }, 0));
        }
        function i() {
          typeof document < "u" &&
            document.body.hasAttribute("data-wf-focus-within") &&
            Fs.env.safari &&
            (document.addEventListener("mousedown", o, !0),
            document.addEventListener("mouseup", r, !0),
            document.addEventListener("click", r, !0));
        }
        return { ready: i };
      })
    );
  });
  var Ws = u((CW, Vs) => {
    "use strict";
    var Wi = window.jQuery,
      st = {},
      ln = [],
      Us = ".w-ix",
      fn = {
        reset: function (e, t) {
          t.__wf_intro = null;
        },
        intro: function (e, t) {
          t.__wf_intro ||
            ((t.__wf_intro = !0), Wi(t).triggerHandler(st.types.INTRO));
        },
        outro: function (e, t) {
          t.__wf_intro &&
            ((t.__wf_intro = null), Wi(t).triggerHandler(st.types.OUTRO));
        },
      };
    st.triggers = {};
    st.types = { INTRO: "w-ix-intro" + Us, OUTRO: "w-ix-outro" + Us };
    st.init = function () {
      for (var e = ln.length, t = 0; t < e; t++) {
        var r = ln[t];
        r[0](0, r[1]);
      }
      (ln = []), Wi.extend(st.triggers, fn);
    };
    st.async = function () {
      for (var e in fn) {
        var t = fn[e];
        fn.hasOwnProperty(e) &&
          (st.triggers[e] = function (r, n) {
            ln.push([t, n]);
          });
      }
    };
    st.async();
    Vs.exports = st;
  });
  var Hi = u((NW, js) => {
    "use strict";
    var Bi = Ws();
    function Bs(e, t) {
      var r = document.createEvent("CustomEvent");
      r.initCustomEvent(t, !0, !0, null), e.dispatchEvent(r);
    }
    var OI = window.jQuery,
      dn = {},
      Hs = ".w-ix",
      bI = {
        reset: function (e, t) {
          Bi.triggers.reset(e, t);
        },
        intro: function (e, t) {
          Bi.triggers.intro(e, t), Bs(t, "COMPONENT_ACTIVE");
        },
        outro: function (e, t) {
          Bi.triggers.outro(e, t), Bs(t, "COMPONENT_INACTIVE");
        },
      };
    dn.triggers = {};
    dn.types = { INTRO: "w-ix-intro" + Hs, OUTRO: "w-ix-outro" + Hs };
    OI.extend(dn.triggers, bI);
    js.exports = dn;
  });
  var ks = u((qW, gt) => {
    function ji(e) {
      return (
        (gt.exports = ji =
          typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  typeof Symbol == "function" &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        (gt.exports.__esModule = !0),
        (gt.exports.default = gt.exports),
        ji(e)
      );
    }
    (gt.exports = ji),
      (gt.exports.__esModule = !0),
      (gt.exports.default = gt.exports);
  });
  var Mt = u((PW, Sr) => {
    var SI = ks().default;
    function Ks(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        r = new WeakMap();
      return (Ks = function (o) {
        return o ? r : t;
      })(e);
    }
    function AI(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (SI(e) !== "object" && typeof e != "function"))
        return { default: e };
      var r = Ks(t);
      if (r && r.has(e)) return r.get(e);
      var n = {},
        o = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var i in e)
        if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
          var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(n, i, a)
            : (n[i] = e[i]);
        }
      return (n.default = e), r && r.set(e, n), n;
    }
    (Sr.exports = AI),
      (Sr.exports.__esModule = !0),
      (Sr.exports.default = Sr.exports);
  });
  var $e = u((LW, Ar) => {
    function wI(e) {
      return e && e.__esModule ? e : { default: e };
    }
    (Ar.exports = wI),
      (Ar.exports.__esModule = !0),
      (Ar.exports.default = Ar.exports);
  });
  var me = u((xW, zs) => {
    var pn = function (e) {
      return e && e.Math == Math && e;
    };
    zs.exports =
      pn(typeof globalThis == "object" && globalThis) ||
      pn(typeof window == "object" && window) ||
      pn(typeof self == "object" && self) ||
      pn(typeof global == "object" && global) ||
      (function () {
        return this;
      })() ||
      Function("return this")();
  });
  var Yt = u((MW, Ys) => {
    Ys.exports = function (e) {
      try {
        return !!e();
      } catch {
        return !0;
      }
    };
  });
  var Dt = u((DW, Qs) => {
    var RI = Yt();
    Qs.exports = !RI(function () {
      return (
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1] != 7
      );
    });
  });
  var vn = u((FW, $s) => {
    var wr = Function.prototype.call;
    $s.exports = wr.bind
      ? wr.bind(wr)
      : function () {
          return wr.apply(wr, arguments);
        };
  });
  var tu = u((eu) => {
    "use strict";
    var Zs = {}.propertyIsEnumerable,
      Js = Object.getOwnPropertyDescriptor,
      CI = Js && !Zs.call({ 1: 2 }, 1);
    eu.f = CI
      ? function (t) {
          var r = Js(this, t);
          return !!r && r.enumerable;
        }
      : Zs;
  });
  var ki = u((XW, ru) => {
    ru.exports = function (e, t) {
      return {
        enumerable: !(e & 1),
        configurable: !(e & 2),
        writable: !(e & 4),
        value: t,
      };
    };
  });
  var Ze = u((UW, iu) => {
    var nu = Function.prototype,
      Ki = nu.bind,
      zi = nu.call,
      NI = Ki && Ki.bind(zi);
    iu.exports = Ki
      ? function (e) {
          return e && NI(zi, e);
        }
      : function (e) {
          return (
            e &&
            function () {
              return zi.apply(e, arguments);
            }
          );
        };
  });
  var su = u((VW, au) => {
    var ou = Ze(),
      qI = ou({}.toString),
      PI = ou("".slice);
    au.exports = function (e) {
      return PI(qI(e), 8, -1);
    };
  });
  var cu = u((WW, uu) => {
    var LI = me(),
      xI = Ze(),
      MI = Yt(),
      DI = su(),
      Yi = LI.Object,
      FI = xI("".split);
    uu.exports = MI(function () {
      return !Yi("z").propertyIsEnumerable(0);
    })
      ? function (e) {
          return DI(e) == "String" ? FI(e, "") : Yi(e);
        }
      : Yi;
  });
  var Qi = u((BW, lu) => {
    var GI = me(),
      XI = GI.TypeError;
    lu.exports = function (e) {
      if (e == null) throw XI("Can't call method on " + e);
      return e;
    };
  });
  var Rr = u((HW, fu) => {
    var UI = cu(),
      VI = Qi();
    fu.exports = function (e) {
      return UI(VI(e));
    };
  });
  var ut = u((jW, du) => {
    du.exports = function (e) {
      return typeof e == "function";
    };
  });
  var Qt = u((kW, pu) => {
    var WI = ut();
    pu.exports = function (e) {
      return typeof e == "object" ? e !== null : WI(e);
    };
  });
  var Cr = u((KW, vu) => {
    var $i = me(),
      BI = ut(),
      HI = function (e) {
        return BI(e) ? e : void 0;
      };
    vu.exports = function (e, t) {
      return arguments.length < 2 ? HI($i[e]) : $i[e] && $i[e][t];
    };
  });
  var hu = u((zW, Eu) => {
    var jI = Ze();
    Eu.exports = jI({}.isPrototypeOf);
  });
  var _u = u((YW, gu) => {
    var kI = Cr();
    gu.exports = kI("navigator", "userAgent") || "";
  });
  var Su = u((QW, bu) => {
    var Ou = me(),
      Zi = _u(),
      yu = Ou.process,
      Iu = Ou.Deno,
      mu = (yu && yu.versions) || (Iu && Iu.version),
      Tu = mu && mu.v8,
      Je,
      En;
    Tu &&
      ((Je = Tu.split(".")),
      (En = Je[0] > 0 && Je[0] < 4 ? 1 : +(Je[0] + Je[1])));
    !En &&
      Zi &&
      ((Je = Zi.match(/Edge\/(\d+)/)),
      (!Je || Je[1] >= 74) &&
        ((Je = Zi.match(/Chrome\/(\d+)/)), Je && (En = +Je[1])));
    bu.exports = En;
  });
  var Ji = u(($W, wu) => {
    var Au = Su(),
      KI = Yt();
    wu.exports =
      !!Object.getOwnPropertySymbols &&
      !KI(function () {
        var e = Symbol();
        return (
          !String(e) ||
          !(Object(e) instanceof Symbol) ||
          (!Symbol.sham && Au && Au < 41)
        );
      });
  });
  var eo = u((ZW, Ru) => {
    var zI = Ji();
    Ru.exports = zI && !Symbol.sham && typeof Symbol.iterator == "symbol";
  });
  var to = u((JW, Cu) => {
    var YI = me(),
      QI = Cr(),
      $I = ut(),
      ZI = hu(),
      JI = eo(),
      em = YI.Object;
    Cu.exports = JI
      ? function (e) {
          return typeof e == "symbol";
        }
      : function (e) {
          var t = QI("Symbol");
          return $I(t) && ZI(t.prototype, em(e));
        };
  });
  var qu = u((eB, Nu) => {
    var tm = me(),
      rm = tm.String;
    Nu.exports = function (e) {
      try {
        return rm(e);
      } catch {
        return "Object";
      }
    };
  });
  var Lu = u((tB, Pu) => {
    var nm = me(),
      im = ut(),
      om = qu(),
      am = nm.TypeError;
    Pu.exports = function (e) {
      if (im(e)) return e;
      throw am(om(e) + " is not a function");
    };
  });
  var Mu = u((rB, xu) => {
    var sm = Lu();
    xu.exports = function (e, t) {
      var r = e[t];
      return r == null ? void 0 : sm(r);
    };
  });
  var Fu = u((nB, Du) => {
    var um = me(),
      ro = vn(),
      no = ut(),
      io = Qt(),
      cm = um.TypeError;
    Du.exports = function (e, t) {
      var r, n;
      if (
        (t === "string" && no((r = e.toString)) && !io((n = ro(r, e)))) ||
        (no((r = e.valueOf)) && !io((n = ro(r, e)))) ||
        (t !== "string" && no((r = e.toString)) && !io((n = ro(r, e))))
      )
        return n;
      throw cm("Can't convert object to primitive value");
    };
  });
  var Xu = u((iB, Gu) => {
    Gu.exports = !1;
  });
  var hn = u((oB, Vu) => {
    var Uu = me(),
      lm = Object.defineProperty;
    Vu.exports = function (e, t) {
      try {
        lm(Uu, e, { value: t, configurable: !0, writable: !0 });
      } catch {
        Uu[e] = t;
      }
      return t;
    };
  });
  var gn = u((aB, Bu) => {
    var fm = me(),
      dm = hn(),
      Wu = "__core-js_shared__",
      pm = fm[Wu] || dm(Wu, {});
    Bu.exports = pm;
  });
  var oo = u((sB, ju) => {
    var vm = Xu(),
      Hu = gn();
    (ju.exports = function (e, t) {
      return Hu[e] || (Hu[e] = t !== void 0 ? t : {});
    })("versions", []).push({
      version: "3.19.0",
      mode: vm ? "pure" : "global",
      copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)",
    });
  });
  var Ku = u((uB, ku) => {
    var Em = me(),
      hm = Qi(),
      gm = Em.Object;
    ku.exports = function (e) {
      return gm(hm(e));
    };
  });
  var Ot = u((cB, zu) => {
    var _m = Ze(),
      ym = Ku(),
      Im = _m({}.hasOwnProperty);
    zu.exports =
      Object.hasOwn ||
      function (t, r) {
        return Im(ym(t), r);
      };
  });
  var ao = u((lB, Yu) => {
    var mm = Ze(),
      Tm = 0,
      Om = Math.random(),
      bm = mm((1).toString);
    Yu.exports = function (e) {
      return "Symbol(" + (e === void 0 ? "" : e) + ")_" + bm(++Tm + Om, 36);
    };
  });
  var so = u((fB, ec) => {
    var Sm = me(),
      Am = oo(),
      Qu = Ot(),
      wm = ao(),
      $u = Ji(),
      Ju = eo(),
      $t = Am("wks"),
      Ft = Sm.Symbol,
      Zu = Ft && Ft.for,
      Rm = Ju ? Ft : (Ft && Ft.withoutSetter) || wm;
    ec.exports = function (e) {
      if (!Qu($t, e) || !($u || typeof $t[e] == "string")) {
        var t = "Symbol." + e;
        $u && Qu(Ft, e)
          ? ($t[e] = Ft[e])
          : Ju && Zu
          ? ($t[e] = Zu(t))
          : ($t[e] = Rm(t));
      }
      return $t[e];
    };
  });
  var ic = u((dB, nc) => {
    var Cm = me(),
      Nm = vn(),
      tc = Qt(),
      rc = to(),
      qm = Mu(),
      Pm = Fu(),
      Lm = so(),
      xm = Cm.TypeError,
      Mm = Lm("toPrimitive");
    nc.exports = function (e, t) {
      if (!tc(e) || rc(e)) return e;
      var r = qm(e, Mm),
        n;
      if (r) {
        if (
          (t === void 0 && (t = "default"), (n = Nm(r, e, t)), !tc(n) || rc(n))
        )
          return n;
        throw xm("Can't convert object to primitive value");
      }
      return t === void 0 && (t = "number"), Pm(e, t);
    };
  });
  var uo = u((pB, oc) => {
    var Dm = ic(),
      Fm = to();
    oc.exports = function (e) {
      var t = Dm(e, "string");
      return Fm(t) ? t : t + "";
    };
  });
  var lo = u((vB, sc) => {
    var Gm = me(),
      ac = Qt(),
      co = Gm.document,
      Xm = ac(co) && ac(co.createElement);
    sc.exports = function (e) {
      return Xm ? co.createElement(e) : {};
    };
  });
  var fo = u((EB, uc) => {
    var Um = Dt(),
      Vm = Yt(),
      Wm = lo();
    uc.exports =
      !Um &&
      !Vm(function () {
        return (
          Object.defineProperty(Wm("div"), "a", {
            get: function () {
              return 7;
            },
          }).a != 7
        );
      });
  });
  var po = u((lc) => {
    var Bm = Dt(),
      Hm = vn(),
      jm = tu(),
      km = ki(),
      Km = Rr(),
      zm = uo(),
      Ym = Ot(),
      Qm = fo(),
      cc = Object.getOwnPropertyDescriptor;
    lc.f = Bm
      ? cc
      : function (t, r) {
          if (((t = Km(t)), (r = zm(r)), Qm))
            try {
              return cc(t, r);
            } catch {}
          if (Ym(t, r)) return km(!Hm(jm.f, t, r), t[r]);
        };
  });
  var Nr = u((gB, dc) => {
    var fc = me(),
      $m = Qt(),
      Zm = fc.String,
      Jm = fc.TypeError;
    dc.exports = function (e) {
      if ($m(e)) return e;
      throw Jm(Zm(e) + " is not an object");
    };
  });
  var qr = u((Ec) => {
    var eT = me(),
      tT = Dt(),
      rT = fo(),
      pc = Nr(),
      nT = uo(),
      iT = eT.TypeError,
      vc = Object.defineProperty;
    Ec.f = tT
      ? vc
      : function (t, r, n) {
          if ((pc(t), (r = nT(r)), pc(n), rT))
            try {
              return vc(t, r, n);
            } catch {}
          if ("get" in n || "set" in n) throw iT("Accessors not supported");
          return "value" in n && (t[r] = n.value), t;
        };
  });
  var _n = u((yB, hc) => {
    var oT = Dt(),
      aT = qr(),
      sT = ki();
    hc.exports = oT
      ? function (e, t, r) {
          return aT.f(e, t, sT(1, r));
        }
      : function (e, t, r) {
          return (e[t] = r), e;
        };
  });
  var Eo = u((IB, gc) => {
    var uT = Ze(),
      cT = ut(),
      vo = gn(),
      lT = uT(Function.toString);
    cT(vo.inspectSource) ||
      (vo.inspectSource = function (e) {
        return lT(e);
      });
    gc.exports = vo.inspectSource;
  });
  var Ic = u((mB, yc) => {
    var fT = me(),
      dT = ut(),
      pT = Eo(),
      _c = fT.WeakMap;
    yc.exports = dT(_c) && /native code/.test(pT(_c));
  });
  var ho = u((TB, Tc) => {
    var vT = oo(),
      ET = ao(),
      mc = vT("keys");
    Tc.exports = function (e) {
      return mc[e] || (mc[e] = ET(e));
    };
  });
  var yn = u((OB, Oc) => {
    Oc.exports = {};
  });
  var Cc = u((bB, Rc) => {
    var hT = Ic(),
      wc = me(),
      go = Ze(),
      gT = Qt(),
      _T = _n(),
      _o = Ot(),
      yo = gn(),
      yT = ho(),
      IT = yn(),
      bc = "Object already initialized",
      mo = wc.TypeError,
      mT = wc.WeakMap,
      In,
      Pr,
      mn,
      TT = function (e) {
        return mn(e) ? Pr(e) : In(e, {});
      },
      OT = function (e) {
        return function (t) {
          var r;
          if (!gT(t) || (r = Pr(t)).type !== e)
            throw mo("Incompatible receiver, " + e + " required");
          return r;
        };
      };
    hT || yo.state
      ? ((bt = yo.state || (yo.state = new mT())),
        (Sc = go(bt.get)),
        (Io = go(bt.has)),
        (Ac = go(bt.set)),
        (In = function (e, t) {
          if (Io(bt, e)) throw new mo(bc);
          return (t.facade = e), Ac(bt, e, t), t;
        }),
        (Pr = function (e) {
          return Sc(bt, e) || {};
        }),
        (mn = function (e) {
          return Io(bt, e);
        }))
      : ((Gt = yT("state")),
        (IT[Gt] = !0),
        (In = function (e, t) {
          if (_o(e, Gt)) throw new mo(bc);
          return (t.facade = e), _T(e, Gt, t), t;
        }),
        (Pr = function (e) {
          return _o(e, Gt) ? e[Gt] : {};
        }),
        (mn = function (e) {
          return _o(e, Gt);
        }));
    var bt, Sc, Io, Ac, Gt;
    Rc.exports = { set: In, get: Pr, has: mn, enforce: TT, getterFor: OT };
  });
  var Pc = u((SB, qc) => {
    var To = Dt(),
      bT = Ot(),
      Nc = Function.prototype,
      ST = To && Object.getOwnPropertyDescriptor,
      Oo = bT(Nc, "name"),
      AT = Oo && function () {}.name === "something",
      wT = Oo && (!To || (To && ST(Nc, "name").configurable));
    qc.exports = { EXISTS: Oo, PROPER: AT, CONFIGURABLE: wT };
  });
  var Fc = u((AB, Dc) => {
    var RT = me(),
      Lc = ut(),
      CT = Ot(),
      xc = _n(),
      NT = hn(),
      qT = Eo(),
      Mc = Cc(),
      PT = Pc().CONFIGURABLE,
      LT = Mc.get,
      xT = Mc.enforce,
      MT = String(String).split("String");
    (Dc.exports = function (e, t, r, n) {
      var o = n ? !!n.unsafe : !1,
        i = n ? !!n.enumerable : !1,
        a = n ? !!n.noTargetGet : !1,
        s = n && n.name !== void 0 ? n.name : t,
        c;
      if (
        (Lc(r) &&
          (String(s).slice(0, 7) === "Symbol(" &&
            (s = "[" + String(s).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
          (!CT(r, "name") || (PT && r.name !== s)) && xc(r, "name", s),
          (c = xT(r)),
          c.source || (c.source = MT.join(typeof s == "string" ? s : ""))),
        e === RT)
      ) {
        i ? (e[t] = r) : NT(t, r);
        return;
      } else o ? !a && e[t] && (i = !0) : delete e[t];
      i ? (e[t] = r) : xc(e, t, r);
    })(Function.prototype, "toString", function () {
      return (Lc(this) && LT(this).source) || qT(this);
    });
  });
  var bo = u((wB, Gc) => {
    var DT = Math.ceil,
      FT = Math.floor;
    Gc.exports = function (e) {
      var t = +e;
      return t !== t || t === 0 ? 0 : (t > 0 ? FT : DT)(t);
    };
  });
  var Uc = u((RB, Xc) => {
    var GT = bo(),
      XT = Math.max,
      UT = Math.min;
    Xc.exports = function (e, t) {
      var r = GT(e);
      return r < 0 ? XT(r + t, 0) : UT(r, t);
    };
  });
  var Wc = u((CB, Vc) => {
    var VT = bo(),
      WT = Math.min;
    Vc.exports = function (e) {
      return e > 0 ? WT(VT(e), 9007199254740991) : 0;
    };
  });
  var Hc = u((NB, Bc) => {
    var BT = Wc();
    Bc.exports = function (e) {
      return BT(e.length);
    };
  });
  var So = u((qB, kc) => {
    var HT = Rr(),
      jT = Uc(),
      kT = Hc(),
      jc = function (e) {
        return function (t, r, n) {
          var o = HT(t),
            i = kT(o),
            a = jT(n, i),
            s;
          if (e && r != r) {
            for (; i > a; ) if (((s = o[a++]), s != s)) return !0;
          } else
            for (; i > a; a++)
              if ((e || a in o) && o[a] === r) return e || a || 0;
          return !e && -1;
        };
      };
    kc.exports = { includes: jc(!0), indexOf: jc(!1) };
  });
  var wo = u((PB, zc) => {
    var KT = Ze(),
      Ao = Ot(),
      zT = Rr(),
      YT = So().indexOf,
      QT = yn(),
      Kc = KT([].push);
    zc.exports = function (e, t) {
      var r = zT(e),
        n = 0,
        o = [],
        i;
      for (i in r) !Ao(QT, i) && Ao(r, i) && Kc(o, i);
      for (; t.length > n; ) Ao(r, (i = t[n++])) && (~YT(o, i) || Kc(o, i));
      return o;
    };
  });
  var Tn = u((LB, Yc) => {
    Yc.exports = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ];
  });
  var $c = u((Qc) => {
    var $T = wo(),
      ZT = Tn(),
      JT = ZT.concat("length", "prototype");
    Qc.f =
      Object.getOwnPropertyNames ||
      function (t) {
        return $T(t, JT);
      };
  });
  var Jc = u((Zc) => {
    Zc.f = Object.getOwnPropertySymbols;
  });
  var tl = u((DB, el) => {
    var eO = Cr(),
      tO = Ze(),
      rO = $c(),
      nO = Jc(),
      iO = Nr(),
      oO = tO([].concat);
    el.exports =
      eO("Reflect", "ownKeys") ||
      function (t) {
        var r = rO.f(iO(t)),
          n = nO.f;
        return n ? oO(r, n(t)) : r;
      };
  });
  var nl = u((FB, rl) => {
    var aO = Ot(),
      sO = tl(),
      uO = po(),
      cO = qr();
    rl.exports = function (e, t) {
      for (var r = sO(t), n = cO.f, o = uO.f, i = 0; i < r.length; i++) {
        var a = r[i];
        aO(e, a) || n(e, a, o(t, a));
      }
    };
  });
  var ol = u((GB, il) => {
    var lO = Yt(),
      fO = ut(),
      dO = /#|\.prototype\./,
      Lr = function (e, t) {
        var r = vO[pO(e)];
        return r == hO ? !0 : r == EO ? !1 : fO(t) ? lO(t) : !!t;
      },
      pO = (Lr.normalize = function (e) {
        return String(e).replace(dO, ".").toLowerCase();
      }),
      vO = (Lr.data = {}),
      EO = (Lr.NATIVE = "N"),
      hO = (Lr.POLYFILL = "P");
    il.exports = Lr;
  });
  var sl = u((XB, al) => {
    var Ro = me(),
      gO = po().f,
      _O = _n(),
      yO = Fc(),
      IO = hn(),
      mO = nl(),
      TO = ol();
    al.exports = function (e, t) {
      var r = e.target,
        n = e.global,
        o = e.stat,
        i,
        a,
        s,
        c,
        f,
        E;
      if (
        (n
          ? (a = Ro)
          : o
          ? (a = Ro[r] || IO(r, {}))
          : (a = (Ro[r] || {}).prototype),
        a)
      )
        for (s in t) {
          if (
            ((f = t[s]),
            e.noTargetGet ? ((E = gO(a, s)), (c = E && E.value)) : (c = a[s]),
            (i = TO(n ? s : r + (o ? "." : "#") + s, e.forced)),
            !i && c !== void 0)
          ) {
            if (typeof f == typeof c) continue;
            mO(f, c);
          }
          (e.sham || (c && c.sham)) && _O(f, "sham", !0), yO(a, s, f, e);
        }
    };
  });
  var cl = u((UB, ul) => {
    var OO = wo(),
      bO = Tn();
    ul.exports =
      Object.keys ||
      function (t) {
        return OO(t, bO);
      };
  });
  var fl = u((VB, ll) => {
    var SO = Dt(),
      AO = qr(),
      wO = Nr(),
      RO = Rr(),
      CO = cl();
    ll.exports = SO
      ? Object.defineProperties
      : function (t, r) {
          wO(t);
          for (var n = RO(r), o = CO(r), i = o.length, a = 0, s; i > a; )
            AO.f(t, (s = o[a++]), n[s]);
          return t;
        };
  });
  var pl = u((WB, dl) => {
    var NO = Cr();
    dl.exports = NO("document", "documentElement");
  });
  var ml = u((BB, Il) => {
    var qO = Nr(),
      PO = fl(),
      vl = Tn(),
      LO = yn(),
      xO = pl(),
      MO = lo(),
      DO = ho(),
      El = ">",
      hl = "<",
      No = "prototype",
      qo = "script",
      _l = DO("IE_PROTO"),
      Co = function () {},
      yl = function (e) {
        return hl + qo + El + e + hl + "/" + qo + El;
      },
      gl = function (e) {
        e.write(yl("")), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      FO = function () {
        var e = MO("iframe"),
          t = "java" + qo + ":",
          r;
        return (
          (e.style.display = "none"),
          xO.appendChild(e),
          (e.src = String(t)),
          (r = e.contentWindow.document),
          r.open(),
          r.write(yl("document.F=Object")),
          r.close(),
          r.F
        );
      },
      On,
      bn = function () {
        try {
          On = new ActiveXObject("htmlfile");
        } catch {}
        bn =
          typeof document < "u"
            ? document.domain && On
              ? gl(On)
              : FO()
            : gl(On);
        for (var e = vl.length; e--; ) delete bn[No][vl[e]];
        return bn();
      };
    LO[_l] = !0;
    Il.exports =
      Object.create ||
      function (t, r) {
        var n;
        return (
          t !== null
            ? ((Co[No] = qO(t)), (n = new Co()), (Co[No] = null), (n[_l] = t))
            : (n = bn()),
          r === void 0 ? n : PO(n, r)
        );
      };
  });
  var Ol = u((HB, Tl) => {
    var GO = so(),
      XO = ml(),
      UO = qr(),
      Po = GO("unscopables"),
      Lo = Array.prototype;
    Lo[Po] == null && UO.f(Lo, Po, { configurable: !0, value: XO(null) });
    Tl.exports = function (e) {
      Lo[Po][e] = !0;
    };
  });
  var bl = u(() => {
    "use strict";
    var VO = sl(),
      WO = So().includes,
      BO = Ol();
    VO(
      { target: "Array", proto: !0 },
      {
        includes: function (t) {
          return WO(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
    BO("includes");
  });
  var Al = u((KB, Sl) => {
    var HO = me(),
      jO = Ze();
    Sl.exports = function (e, t) {
      return jO(HO[e].prototype[t]);
    };
  });
  var Rl = u((zB, wl) => {
    bl();
    var kO = Al();
    wl.exports = kO("Array", "includes");
  });
  var Nl = u((YB, Cl) => {
    var KO = Rl();
    Cl.exports = KO;
  });
  var Pl = u((QB, ql) => {
    var zO = Nl();
    ql.exports = zO;
  });
  var xo = u(($B, Ll) => {
    var YO =
      typeof global == "object" && global && global.Object === Object && global;
    Ll.exports = YO;
  });
  var et = u((ZB, xl) => {
    var QO = xo(),
      $O = typeof self == "object" && self && self.Object === Object && self,
      ZO = QO || $O || Function("return this")();
    xl.exports = ZO;
  });
  var Zt = u((JB, Ml) => {
    var JO = et(),
      eb = JO.Symbol;
    Ml.exports = eb;
  });
  var Xl = u((eH, Gl) => {
    var Dl = Zt(),
      Fl = Object.prototype,
      tb = Fl.hasOwnProperty,
      rb = Fl.toString,
      xr = Dl ? Dl.toStringTag : void 0;
    function nb(e) {
      var t = tb.call(e, xr),
        r = e[xr];
      try {
        e[xr] = void 0;
        var n = !0;
      } catch {}
      var o = rb.call(e);
      return n && (t ? (e[xr] = r) : delete e[xr]), o;
    }
    Gl.exports = nb;
  });
  var Vl = u((tH, Ul) => {
    var ib = Object.prototype,
      ob = ib.toString;
    function ab(e) {
      return ob.call(e);
    }
    Ul.exports = ab;
  });
  var St = u((rH, Hl) => {
    var Wl = Zt(),
      sb = Xl(),
      ub = Vl(),
      cb = "[object Null]",
      lb = "[object Undefined]",
      Bl = Wl ? Wl.toStringTag : void 0;
    function fb(e) {
      return e == null
        ? e === void 0
          ? lb
          : cb
        : Bl && Bl in Object(e)
        ? sb(e)
        : ub(e);
    }
    Hl.exports = fb;
  });
  var Mo = u((nH, jl) => {
    function db(e, t) {
      return function (r) {
        return e(t(r));
      };
    }
    jl.exports = db;
  });
  var Do = u((iH, kl) => {
    var pb = Mo(),
      vb = pb(Object.getPrototypeOf, Object);
    kl.exports = vb;
  });
  var _t = u((oH, Kl) => {
    function Eb(e) {
      return e != null && typeof e == "object";
    }
    Kl.exports = Eb;
  });
  var Fo = u((aH, Yl) => {
    var hb = St(),
      gb = Do(),
      _b = _t(),
      yb = "[object Object]",
      Ib = Function.prototype,
      mb = Object.prototype,
      zl = Ib.toString,
      Tb = mb.hasOwnProperty,
      Ob = zl.call(Object);
    function bb(e) {
      if (!_b(e) || hb(e) != yb) return !1;
      var t = gb(e);
      if (t === null) return !0;
      var r = Tb.call(t, "constructor") && t.constructor;
      return typeof r == "function" && r instanceof r && zl.call(r) == Ob;
    }
    Yl.exports = bb;
  });
  var Ql = u((Go) => {
    "use strict";
    Object.defineProperty(Go, "__esModule", { value: !0 });
    Go.default = Sb;
    function Sb(e) {
      var t,
        r = e.Symbol;
      return (
        typeof r == "function"
          ? r.observable
            ? (t = r.observable)
            : ((t = r("observable")), (r.observable = t))
          : (t = "@@observable"),
        t
      );
    }
  });
  var $l = u((Uo, Xo) => {
    "use strict";
    Object.defineProperty(Uo, "__esModule", { value: !0 });
    var Ab = Ql(),
      wb = Rb(Ab);
    function Rb(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Jt;
    typeof self < "u"
      ? (Jt = self)
      : typeof window < "u"
      ? (Jt = window)
      : typeof global < "u"
      ? (Jt = global)
      : typeof Xo < "u"
      ? (Jt = Xo)
      : (Jt = Function("return this")());
    var Cb = (0, wb.default)(Jt);
    Uo.default = Cb;
  });
  var Vo = u((Mr) => {
    "use strict";
    Mr.__esModule = !0;
    Mr.ActionTypes = void 0;
    Mr.default = tf;
    var Nb = Fo(),
      qb = ef(Nb),
      Pb = $l(),
      Zl = ef(Pb);
    function ef(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Jl = (Mr.ActionTypes = { INIT: "@@redux/INIT" });
    function tf(e, t, r) {
      var n;
      if (
        (typeof t == "function" && typeof r > "u" && ((r = t), (t = void 0)),
        typeof r < "u")
      ) {
        if (typeof r != "function")
          throw new Error("Expected the enhancer to be a function.");
        return r(tf)(e, t);
      }
      if (typeof e != "function")
        throw new Error("Expected the reducer to be a function.");
      var o = e,
        i = t,
        a = [],
        s = a,
        c = !1;
      function f() {
        s === a && (s = a.slice());
      }
      function E() {
        return i;
      }
      function v(S) {
        if (typeof S != "function")
          throw new Error("Expected listener to be a function.");
        var C = !0;
        return (
          f(),
          s.push(S),
          function () {
            if (C) {
              (C = !1), f();
              var w = s.indexOf(S);
              s.splice(w, 1);
            }
          }
        );
      }
      function h(S) {
        if (!(0, qb.default)(S))
          throw new Error(
            "Actions must be plain objects. Use custom middleware for async actions."
          );
        if (typeof S.type > "u")
          throw new Error(
            'Actions may not have an undefined "type" property. Have you misspelled a constant?'
          );
        if (c) throw new Error("Reducers may not dispatch actions.");
        try {
          (c = !0), (i = o(i, S));
        } finally {
          c = !1;
        }
        for (var C = (a = s), A = 0; A < C.length; A++) C[A]();
        return S;
      }
      function y(S) {
        if (typeof S != "function")
          throw new Error("Expected the nextReducer to be a function.");
        (o = S), h({ type: Jl.INIT });
      }
      function R() {
        var S,
          C = v;
        return (
          (S = {
            subscribe: function (w) {
              if (typeof w != "object")
                throw new TypeError("Expected the observer to be an object.");
              function m() {
                w.next && w.next(E());
              }
              m();
              var x = C(m);
              return { unsubscribe: x };
            },
          }),
          (S[Zl.default] = function () {
            return this;
          }),
          S
        );
      }
      return (
        h({ type: Jl.INIT }),
        (n = { dispatch: h, subscribe: v, getState: E, replaceReducer: y }),
        (n[Zl.default] = R),
        n
      );
    }
  });
  var Bo = u((Wo) => {
    "use strict";
    Wo.__esModule = !0;
    Wo.default = Lb;
    function Lb(e) {
      typeof console < "u" &&
        typeof console.error == "function" &&
        console.error(e);
      try {
        throw new Error(e);
      } catch {}
    }
  });
  var of = u((Ho) => {
    "use strict";
    Ho.__esModule = !0;
    Ho.default = Gb;
    var rf = Vo(),
      xb = Fo(),
      lH = nf(xb),
      Mb = Bo(),
      fH = nf(Mb);
    function nf(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Db(e, t) {
      var r = t && t.type,
        n = (r && '"' + r.toString() + '"') || "an action";
      return (
        "Given action " +
        n +
        ', reducer "' +
        e +
        '" returned undefined. To ignore an action, you must explicitly return the previous state.'
      );
    }
    function Fb(e) {
      Object.keys(e).forEach(function (t) {
        var r = e[t],
          n = r(void 0, { type: rf.ActionTypes.INIT });
        if (typeof n > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.'
          );
        var o =
          "@@redux/PROBE_UNKNOWN_ACTION_" +
          Math.random().toString(36).substring(7).split("").join(".");
        if (typeof r(void 0, { type: o }) > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined when probed with a random type. ' +
              ("Don't try to handle " +
                rf.ActionTypes.INIT +
                ' or other actions in "redux/*" ') +
              "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined."
          );
      });
    }
    function Gb(e) {
      for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
        var o = t[n];
        typeof e[o] == "function" && (r[o] = e[o]);
      }
      var i = Object.keys(r);
      if (!1) var a;
      var s;
      try {
        Fb(r);
      } catch (c) {
        s = c;
      }
      return function () {
        var f =
            arguments.length <= 0 || arguments[0] === void 0
              ? {}
              : arguments[0],
          E = arguments[1];
        if (s) throw s;
        if (!1) var v;
        for (var h = !1, y = {}, R = 0; R < i.length; R++) {
          var S = i[R],
            C = r[S],
            A = f[S],
            w = C(A, E);
          if (typeof w > "u") {
            var m = Db(S, E);
            throw new Error(m);
          }
          (y[S] = w), (h = h || w !== A);
        }
        return h ? y : f;
      };
    }
  });
  var sf = u((jo) => {
    "use strict";
    jo.__esModule = !0;
    jo.default = Xb;
    function af(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }
    function Xb(e, t) {
      if (typeof e == "function") return af(e, t);
      if (typeof e != "object" || e === null)
        throw new Error(
          "bindActionCreators expected an object or a function, instead received " +
            (e === null ? "null" : typeof e) +
            '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?'
        );
      for (var r = Object.keys(e), n = {}, o = 0; o < r.length; o++) {
        var i = r[o],
          a = e[i];
        typeof a == "function" && (n[i] = af(a, t));
      }
      return n;
    }
  });
  var Ko = u((ko) => {
    "use strict";
    ko.__esModule = !0;
    ko.default = Ub;
    function Ub() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      if (t.length === 0)
        return function (i) {
          return i;
        };
      if (t.length === 1) return t[0];
      var n = t[t.length - 1],
        o = t.slice(0, -1);
      return function () {
        return o.reduceRight(function (i, a) {
          return a(i);
        }, n.apply(void 0, arguments));
      };
    }
  });
  var uf = u((zo) => {
    "use strict";
    zo.__esModule = !0;
    var Vb =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    zo.default = jb;
    var Wb = Ko(),
      Bb = Hb(Wb);
    function Hb(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function jb() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return function (n) {
        return function (o, i, a) {
          var s = n(o, i, a),
            c = s.dispatch,
            f = [],
            E = {
              getState: s.getState,
              dispatch: function (h) {
                return c(h);
              },
            };
          return (
            (f = t.map(function (v) {
              return v(E);
            })),
            (c = Bb.default.apply(void 0, f)(s.dispatch)),
            Vb({}, s, { dispatch: c })
          );
        };
      };
    }
  });
  var Yo = u((je) => {
    "use strict";
    je.__esModule = !0;
    je.compose =
      je.applyMiddleware =
      je.bindActionCreators =
      je.combineReducers =
      je.createStore =
        void 0;
    var kb = Vo(),
      Kb = er(kb),
      zb = of(),
      Yb = er(zb),
      Qb = sf(),
      $b = er(Qb),
      Zb = uf(),
      Jb = er(Zb),
      eS = Ko(),
      tS = er(eS),
      rS = Bo(),
      hH = er(rS);
    function er(e) {
      return e && e.__esModule ? e : { default: e };
    }
    je.createStore = Kb.default;
    je.combineReducers = Yb.default;
    je.bindActionCreators = $b.default;
    je.applyMiddleware = Jb.default;
    je.compose = tS.default;
  });
  var cf = u((Ne) => {
    "use strict";
    Object.defineProperty(Ne, "__esModule", { value: !0 });
    Ne.QuickEffectIds =
      Ne.QuickEffectDirectionConsts =
      Ne.EventTypeConsts =
      Ne.EventLimitAffectedElements =
      Ne.EventContinuousMouseAxes =
      Ne.EventBasedOn =
      Ne.EventAppliesTo =
        void 0;
    var nS = {
      NAVBAR_OPEN: "NAVBAR_OPEN",
      NAVBAR_CLOSE: "NAVBAR_CLOSE",
      TAB_ACTIVE: "TAB_ACTIVE",
      TAB_INACTIVE: "TAB_INACTIVE",
      SLIDER_ACTIVE: "SLIDER_ACTIVE",
      SLIDER_INACTIVE: "SLIDER_INACTIVE",
      DROPDOWN_OPEN: "DROPDOWN_OPEN",
      DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
      MOUSE_CLICK: "MOUSE_CLICK",
      MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
      MOUSE_DOWN: "MOUSE_DOWN",
      MOUSE_UP: "MOUSE_UP",
      MOUSE_OVER: "MOUSE_OVER",
      MOUSE_OUT: "MOUSE_OUT",
      MOUSE_MOVE: "MOUSE_MOVE",
      MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
      SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
      SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
      SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
      ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
      ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
      PAGE_START: "PAGE_START",
      PAGE_FINISH: "PAGE_FINISH",
      PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
      PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
      PAGE_SCROLL: "PAGE_SCROLL",
    };
    Ne.EventTypeConsts = nS;
    var iS = { ELEMENT: "ELEMENT", CLASS: "CLASS", PAGE: "PAGE" };
    Ne.EventAppliesTo = iS;
    var oS = { ELEMENT: "ELEMENT", VIEWPORT: "VIEWPORT" };
    Ne.EventBasedOn = oS;
    var aS = { X_AXIS: "X_AXIS", Y_AXIS: "Y_AXIS" };
    Ne.EventContinuousMouseAxes = aS;
    var sS = {
      CHILDREN: "CHILDREN",
      SIBLINGS: "SIBLINGS",
      IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN",
    };
    Ne.EventLimitAffectedElements = sS;
    var uS = {
      FADE_EFFECT: "FADE_EFFECT",
      SLIDE_EFFECT: "SLIDE_EFFECT",
      GROW_EFFECT: "GROW_EFFECT",
      SHRINK_EFFECT: "SHRINK_EFFECT",
      SPIN_EFFECT: "SPIN_EFFECT",
      FLY_EFFECT: "FLY_EFFECT",
      POP_EFFECT: "POP_EFFECT",
      FLIP_EFFECT: "FLIP_EFFECT",
      JIGGLE_EFFECT: "JIGGLE_EFFECT",
      PULSE_EFFECT: "PULSE_EFFECT",
      DROP_EFFECT: "DROP_EFFECT",
      BLINK_EFFECT: "BLINK_EFFECT",
      BOUNCE_EFFECT: "BOUNCE_EFFECT",
      FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
      FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
      RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
      JELLO_EFFECT: "JELLO_EFFECT",
      GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
      SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
      PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT",
    };
    Ne.QuickEffectIds = uS;
    var cS = {
      LEFT: "LEFT",
      RIGHT: "RIGHT",
      BOTTOM: "BOTTOM",
      TOP: "TOP",
      BOTTOM_LEFT: "BOTTOM_LEFT",
      BOTTOM_RIGHT: "BOTTOM_RIGHT",
      TOP_RIGHT: "TOP_RIGHT",
      TOP_LEFT: "TOP_LEFT",
      CLOCKWISE: "CLOCKWISE",
      COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE",
    };
    Ne.QuickEffectDirectionConsts = cS;
  });
  var Qo = u((tr) => {
    "use strict";
    Object.defineProperty(tr, "__esModule", { value: !0 });
    tr.ActionTypeConsts = tr.ActionAppliesTo = void 0;
    var lS = {
      TRANSFORM_MOVE: "TRANSFORM_MOVE",
      TRANSFORM_SCALE: "TRANSFORM_SCALE",
      TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
      TRANSFORM_SKEW: "TRANSFORM_SKEW",
      STYLE_OPACITY: "STYLE_OPACITY",
      STYLE_SIZE: "STYLE_SIZE",
      STYLE_FILTER: "STYLE_FILTER",
      STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
      STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
      STYLE_BORDER: "STYLE_BORDER",
      STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
      OBJECT_VALUE: "OBJECT_VALUE",
      PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
      PLUGIN_SPLINE: "PLUGIN_SPLINE",
      GENERAL_DISPLAY: "GENERAL_DISPLAY",
      GENERAL_START_ACTION: "GENERAL_START_ACTION",
      GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
      GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
      GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
      GENERAL_LOOP: "GENERAL_LOOP",
      STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW",
    };
    tr.ActionTypeConsts = lS;
    var fS = {
      ELEMENT: "ELEMENT",
      ELEMENT_CLASS: "ELEMENT_CLASS",
      TRIGGER_ELEMENT: "TRIGGER_ELEMENT",
    };
    tr.ActionAppliesTo = fS;
  });
  var lf = u((Sn) => {
    "use strict";
    Object.defineProperty(Sn, "__esModule", { value: !0 });
    Sn.InteractionTypeConsts = void 0;
    var dS = {
      MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
      MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
      MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
      SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
      SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
      MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
      PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
      PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
      PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
      NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
      DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
      ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
      TAB_INTERACTION: "TAB_INTERACTION",
      SLIDER_INTERACTION: "SLIDER_INTERACTION",
    };
    Sn.InteractionTypeConsts = dS;
  });
  var ff = u((An) => {
    "use strict";
    Object.defineProperty(An, "__esModule", { value: !0 });
    An.ReducedMotionTypes = void 0;
    var pS = Qo(),
      {
        TRANSFORM_MOVE: vS,
        TRANSFORM_SCALE: ES,
        TRANSFORM_ROTATE: hS,
        TRANSFORM_SKEW: gS,
        STYLE_SIZE: _S,
        STYLE_FILTER: yS,
        STYLE_FONT_VARIATION: IS,
      } = pS.ActionTypeConsts,
      mS = {
        [vS]: !0,
        [ES]: !0,
        [hS]: !0,
        [gS]: !0,
        [_S]: !0,
        [yS]: !0,
        [IS]: !0,
      };
    An.ReducedMotionTypes = mS;
  });
  var df = u((oe) => {
    "use strict";
    Object.defineProperty(oe, "__esModule", { value: !0 });
    oe.IX2_VIEWPORT_WIDTH_CHANGED =
      oe.IX2_TEST_FRAME_RENDERED =
      oe.IX2_STOP_REQUESTED =
      oe.IX2_SESSION_STOPPED =
      oe.IX2_SESSION_STARTED =
      oe.IX2_SESSION_INITIALIZED =
      oe.IX2_RAW_DATA_IMPORTED =
      oe.IX2_PREVIEW_REQUESTED =
      oe.IX2_PLAYBACK_REQUESTED =
      oe.IX2_PARAMETER_CHANGED =
      oe.IX2_MEDIA_QUERIES_DEFINED =
      oe.IX2_INSTANCE_STARTED =
      oe.IX2_INSTANCE_REMOVED =
      oe.IX2_INSTANCE_ADDED =
      oe.IX2_EVENT_STATE_CHANGED =
      oe.IX2_EVENT_LISTENER_ADDED =
      oe.IX2_ELEMENT_STATE_CHANGED =
      oe.IX2_CLEAR_REQUESTED =
      oe.IX2_ANIMATION_FRAME_CHANGED =
      oe.IX2_ACTION_LIST_PLAYBACK_CHANGED =
        void 0;
    var TS = "IX2_RAW_DATA_IMPORTED";
    oe.IX2_RAW_DATA_IMPORTED = TS;
    var OS = "IX2_SESSION_INITIALIZED";
    oe.IX2_SESSION_INITIALIZED = OS;
    var bS = "IX2_SESSION_STARTED";
    oe.IX2_SESSION_STARTED = bS;
    var SS = "IX2_SESSION_STOPPED";
    oe.IX2_SESSION_STOPPED = SS;
    var AS = "IX2_PREVIEW_REQUESTED";
    oe.IX2_PREVIEW_REQUESTED = AS;
    var wS = "IX2_PLAYBACK_REQUESTED";
    oe.IX2_PLAYBACK_REQUESTED = wS;
    var RS = "IX2_STOP_REQUESTED";
    oe.IX2_STOP_REQUESTED = RS;
    var CS = "IX2_CLEAR_REQUESTED";
    oe.IX2_CLEAR_REQUESTED = CS;
    var NS = "IX2_EVENT_LISTENER_ADDED";
    oe.IX2_EVENT_LISTENER_ADDED = NS;
    var qS = "IX2_EVENT_STATE_CHANGED";
    oe.IX2_EVENT_STATE_CHANGED = qS;
    var PS = "IX2_ANIMATION_FRAME_CHANGED";
    oe.IX2_ANIMATION_FRAME_CHANGED = PS;
    var LS = "IX2_PARAMETER_CHANGED";
    oe.IX2_PARAMETER_CHANGED = LS;
    var xS = "IX2_INSTANCE_ADDED";
    oe.IX2_INSTANCE_ADDED = xS;
    var MS = "IX2_INSTANCE_STARTED";
    oe.IX2_INSTANCE_STARTED = MS;
    var DS = "IX2_INSTANCE_REMOVED";
    oe.IX2_INSTANCE_REMOVED = DS;
    var FS = "IX2_ELEMENT_STATE_CHANGED";
    oe.IX2_ELEMENT_STATE_CHANGED = FS;
    var GS = "IX2_ACTION_LIST_PLAYBACK_CHANGED";
    oe.IX2_ACTION_LIST_PLAYBACK_CHANGED = GS;
    var XS = "IX2_VIEWPORT_WIDTH_CHANGED";
    oe.IX2_VIEWPORT_WIDTH_CHANGED = XS;
    var US = "IX2_MEDIA_QUERIES_DEFINED";
    oe.IX2_MEDIA_QUERIES_DEFINED = US;
    var VS = "IX2_TEST_FRAME_RENDERED";
    oe.IX2_TEST_FRAME_RENDERED = VS;
  });
  var pf = u((b) => {
    "use strict";
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.W_MOD_JS =
      b.W_MOD_IX =
      b.WILL_CHANGE =
      b.WIDTH =
      b.WF_PAGE =
      b.TRANSLATE_Z =
      b.TRANSLATE_Y =
      b.TRANSLATE_X =
      b.TRANSLATE_3D =
      b.TRANSFORM =
      b.SKEW_Y =
      b.SKEW_X =
      b.SKEW =
      b.SIBLINGS =
      b.SCALE_Z =
      b.SCALE_Y =
      b.SCALE_X =
      b.SCALE_3D =
      b.ROTATE_Z =
      b.ROTATE_Y =
      b.ROTATE_X =
      b.RENDER_TRANSFORM =
      b.RENDER_STYLE =
      b.RENDER_PLUGIN =
      b.RENDER_GENERAL =
      b.PRESERVE_3D =
      b.PLAIN_OBJECT =
      b.PARENT =
      b.OPACITY =
      b.IX2_ID_DELIMITER =
      b.IMMEDIATE_CHILDREN =
      b.HTML_ELEMENT =
      b.HEIGHT =
      b.FONT_VARIATION_SETTINGS =
      b.FLEX =
      b.FILTER =
      b.DISPLAY =
      b.CONFIG_Z_VALUE =
      b.CONFIG_Z_UNIT =
      b.CONFIG_Y_VALUE =
      b.CONFIG_Y_UNIT =
      b.CONFIG_X_VALUE =
      b.CONFIG_X_UNIT =
      b.CONFIG_VALUE =
      b.CONFIG_UNIT =
      b.COMMA_DELIMITER =
      b.COLOR =
      b.COLON_DELIMITER =
      b.CHILDREN =
      b.BOUNDARY_SELECTOR =
      b.BORDER_COLOR =
      b.BAR_DELIMITER =
      b.BACKGROUND_COLOR =
      b.BACKGROUND =
      b.AUTO =
      b.ABSTRACT_NODE =
        void 0;
    var WS = "|";
    b.IX2_ID_DELIMITER = WS;
    var BS = "data-wf-page";
    b.WF_PAGE = BS;
    var HS = "w-mod-js";
    b.W_MOD_JS = HS;
    var jS = "w-mod-ix";
    b.W_MOD_IX = jS;
    var kS = ".w-dyn-item";
    b.BOUNDARY_SELECTOR = kS;
    var KS = "xValue";
    b.CONFIG_X_VALUE = KS;
    var zS = "yValue";
    b.CONFIG_Y_VALUE = zS;
    var YS = "zValue";
    b.CONFIG_Z_VALUE = YS;
    var QS = "value";
    b.CONFIG_VALUE = QS;
    var $S = "xUnit";
    b.CONFIG_X_UNIT = $S;
    var ZS = "yUnit";
    b.CONFIG_Y_UNIT = ZS;
    var JS = "zUnit";
    b.CONFIG_Z_UNIT = JS;
    var eA = "unit";
    b.CONFIG_UNIT = eA;
    var tA = "transform";
    b.TRANSFORM = tA;
    var rA = "translateX";
    b.TRANSLATE_X = rA;
    var nA = "translateY";
    b.TRANSLATE_Y = nA;
    var iA = "translateZ";
    b.TRANSLATE_Z = iA;
    var oA = "translate3d";
    b.TRANSLATE_3D = oA;
    var aA = "scaleX";
    b.SCALE_X = aA;
    var sA = "scaleY";
    b.SCALE_Y = sA;
    var uA = "scaleZ";
    b.SCALE_Z = uA;
    var cA = "scale3d";
    b.SCALE_3D = cA;
    var lA = "rotateX";
    b.ROTATE_X = lA;
    var fA = "rotateY";
    b.ROTATE_Y = fA;
    var dA = "rotateZ";
    b.ROTATE_Z = dA;
    var pA = "skew";
    b.SKEW = pA;
    var vA = "skewX";
    b.SKEW_X = vA;
    var EA = "skewY";
    b.SKEW_Y = EA;
    var hA = "opacity";
    b.OPACITY = hA;
    var gA = "filter";
    b.FILTER = gA;
    var _A = "font-variation-settings";
    b.FONT_VARIATION_SETTINGS = _A;
    var yA = "width";
    b.WIDTH = yA;
    var IA = "height";
    b.HEIGHT = IA;
    var mA = "backgroundColor";
    b.BACKGROUND_COLOR = mA;
    var TA = "background";
    b.BACKGROUND = TA;
    var OA = "borderColor";
    b.BORDER_COLOR = OA;
    var bA = "color";
    b.COLOR = bA;
    var SA = "display";
    b.DISPLAY = SA;
    var AA = "flex";
    b.FLEX = AA;
    var wA = "willChange";
    b.WILL_CHANGE = wA;
    var RA = "AUTO";
    b.AUTO = RA;
    var CA = ",";
    b.COMMA_DELIMITER = CA;
    var NA = ":";
    b.COLON_DELIMITER = NA;
    var qA = "|";
    b.BAR_DELIMITER = qA;
    var PA = "CHILDREN";
    b.CHILDREN = PA;
    var LA = "IMMEDIATE_CHILDREN";
    b.IMMEDIATE_CHILDREN = LA;
    var xA = "SIBLINGS";
    b.SIBLINGS = xA;
    var MA = "PARENT";
    b.PARENT = MA;
    var DA = "preserve-3d";
    b.PRESERVE_3D = DA;
    var FA = "HTML_ELEMENT";
    b.HTML_ELEMENT = FA;
    var GA = "PLAIN_OBJECT";
    b.PLAIN_OBJECT = GA;
    var XA = "ABSTRACT_NODE";
    b.ABSTRACT_NODE = XA;
    var UA = "RENDER_TRANSFORM";
    b.RENDER_TRANSFORM = UA;
    var VA = "RENDER_GENERAL";
    b.RENDER_GENERAL = VA;
    var WA = "RENDER_STYLE";
    b.RENDER_STYLE = WA;
    var BA = "RENDER_PLUGIN";
    b.RENDER_PLUGIN = BA;
  });
  var We = u((we) => {
    "use strict";
    var vf = Mt().default;
    Object.defineProperty(we, "__esModule", { value: !0 });
    var wn = { IX2EngineActionTypes: !0, IX2EngineConstants: !0 };
    we.IX2EngineConstants = we.IX2EngineActionTypes = void 0;
    var $o = cf();
    Object.keys($o).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(wn, e) ||
        (e in we && we[e] === $o[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return $o[e];
          },
        });
    });
    var Zo = Qo();
    Object.keys(Zo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(wn, e) ||
        (e in we && we[e] === Zo[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return Zo[e];
          },
        });
    });
    var Jo = lf();
    Object.keys(Jo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(wn, e) ||
        (e in we && we[e] === Jo[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return Jo[e];
          },
        });
    });
    var ea = ff();
    Object.keys(ea).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(wn, e) ||
        (e in we && we[e] === ea[e]) ||
        Object.defineProperty(we, e, {
          enumerable: !0,
          get: function () {
            return ea[e];
          },
        });
    });
    var HA = vf(df());
    we.IX2EngineActionTypes = HA;
    var jA = vf(pf());
    we.IX2EngineConstants = jA;
  });
  var Ef = u((Rn) => {
    "use strict";
    Object.defineProperty(Rn, "__esModule", { value: !0 });
    Rn.ixData = void 0;
    var kA = We(),
      { IX2_RAW_DATA_IMPORTED: KA } = kA.IX2EngineActionTypes,
      zA = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case KA:
            return t.payload.ixData || Object.freeze({});
          default:
            return e;
        }
      };
    Rn.ixData = zA;
  });
  var rr = u((AH, yt) => {
    function ta() {
      return (
        (yt.exports = ta =
          Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = arguments[t];
                  for (var n in r)
                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
              }),
        (yt.exports.__esModule = !0),
        (yt.exports.default = yt.exports),
        ta.apply(this, arguments)
      );
    }
    (yt.exports = ta),
      (yt.exports.__esModule = !0),
      (yt.exports.default = yt.exports);
  });
  var nr = u((Oe) => {
    "use strict";
    Object.defineProperty(Oe, "__esModule", { value: !0 });
    var YA =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
    Oe.clone = Nn;
    Oe.addLast = _f;
    Oe.addFirst = yf;
    Oe.removeLast = If;
    Oe.removeFirst = mf;
    Oe.insert = Tf;
    Oe.removeAt = Of;
    Oe.replaceAt = bf;
    Oe.getIn = qn;
    Oe.set = Pn;
    Oe.setIn = Ln;
    Oe.update = Af;
    Oe.updateIn = wf;
    Oe.merge = Rf;
    Oe.mergeDeep = Cf;
    Oe.mergeIn = Nf;
    Oe.omit = qf;
    Oe.addDefaults = Pf;
    var hf = "INVALID_ARGS";
    function gf(e) {
      throw new Error(e);
    }
    function ra(e) {
      var t = Object.keys(e);
      return Object.getOwnPropertySymbols
        ? t.concat(Object.getOwnPropertySymbols(e))
        : t;
    }
    var QA = {}.hasOwnProperty;
    function Nn(e) {
      if (Array.isArray(e)) return e.slice();
      for (var t = ra(e), r = {}, n = 0; n < t.length; n++) {
        var o = t[n];
        r[o] = e[o];
      }
      return r;
    }
    function Be(e, t, r) {
      var n = r;
      n == null && gf(hf);
      for (
        var o = !1, i = arguments.length, a = Array(i > 3 ? i - 3 : 0), s = 3;
        s < i;
        s++
      )
        a[s - 3] = arguments[s];
      for (var c = 0; c < a.length; c++) {
        var f = a[c];
        if (f != null) {
          var E = ra(f);
          if (E.length)
            for (var v = 0; v <= E.length; v++) {
              var h = E[v];
              if (!(e && n[h] !== void 0)) {
                var y = f[h];
                t && Cn(n[h]) && Cn(y) && (y = Be(e, t, n[h], y)),
                  !(y === void 0 || y === n[h]) &&
                    (o || ((o = !0), (n = Nn(n))), (n[h] = y));
              }
            }
        }
      }
      return n;
    }
    function Cn(e) {
      var t = typeof e > "u" ? "undefined" : YA(e);
      return e != null && (t === "object" || t === "function");
    }
    function _f(e, t) {
      return Array.isArray(t) ? e.concat(t) : e.concat([t]);
    }
    function yf(e, t) {
      return Array.isArray(t) ? t.concat(e) : [t].concat(e);
    }
    function If(e) {
      return e.length ? e.slice(0, e.length - 1) : e;
    }
    function mf(e) {
      return e.length ? e.slice(1) : e;
    }
    function Tf(e, t, r) {
      return e
        .slice(0, t)
        .concat(Array.isArray(r) ? r : [r])
        .concat(e.slice(t));
    }
    function Of(e, t) {
      return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    }
    function bf(e, t, r) {
      if (e[t] === r) return e;
      for (var n = e.length, o = Array(n), i = 0; i < n; i++) o[i] = e[i];
      return (o[t] = r), o;
    }
    function qn(e, t) {
      if ((!Array.isArray(t) && gf(hf), e != null)) {
        for (var r = e, n = 0; n < t.length; n++) {
          var o = t[n];
          if (((r = r?.[o]), r === void 0)) return r;
        }
        return r;
      }
    }
    function Pn(e, t, r) {
      var n = typeof t == "number" ? [] : {},
        o = e ?? n;
      if (o[t] === r) return o;
      var i = Nn(o);
      return (i[t] = r), i;
    }
    function Sf(e, t, r, n) {
      var o = void 0,
        i = t[n];
      if (n === t.length - 1) o = r;
      else {
        var a =
          Cn(e) && Cn(e[i]) ? e[i] : typeof t[n + 1] == "number" ? [] : {};
        o = Sf(a, t, r, n + 1);
      }
      return Pn(e, i, o);
    }
    function Ln(e, t, r) {
      return t.length ? Sf(e, t, r, 0) : r;
    }
    function Af(e, t, r) {
      var n = e?.[t],
        o = r(n);
      return Pn(e, t, o);
    }
    function wf(e, t, r) {
      var n = qn(e, t),
        o = r(n);
      return Ln(e, t, o);
    }
    function Rf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !1, !1, e, t, r, n, o, i].concat(s))
        : Be(!1, !1, e, t, r, n, o, i);
    }
    function Cf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !1, !0, e, t, r, n, o, i].concat(s))
        : Be(!1, !0, e, t, r, n, o, i);
    }
    function Nf(e, t, r, n, o, i, a) {
      var s = qn(e, t);
      s == null && (s = {});
      for (
        var c = void 0,
          f = arguments.length,
          E = Array(f > 7 ? f - 7 : 0),
          v = 7;
        v < f;
        v++
      )
        E[v - 7] = arguments[v];
      return (
        E.length
          ? (c = Be.call.apply(Be, [null, !1, !1, s, r, n, o, i, a].concat(E)))
          : (c = Be(!1, !1, s, r, n, o, i, a)),
        Ln(e, t, c)
      );
    }
    function qf(e, t) {
      for (var r = Array.isArray(t) ? t : [t], n = !1, o = 0; o < r.length; o++)
        if (QA.call(e, r[o])) {
          n = !0;
          break;
        }
      if (!n) return e;
      for (var i = {}, a = ra(e), s = 0; s < a.length; s++) {
        var c = a[s];
        r.indexOf(c) >= 0 || (i[c] = e[c]);
      }
      return i;
    }
    function Pf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Be.call.apply(Be, [null, !0, !1, e, t, r, n, o, i].concat(s))
        : Be(!0, !1, e, t, r, n, o, i);
    }
    var $A = {
      clone: Nn,
      addLast: _f,
      addFirst: yf,
      removeLast: If,
      removeFirst: mf,
      insert: Tf,
      removeAt: Of,
      replaceAt: bf,
      getIn: qn,
      set: Pn,
      setIn: Ln,
      update: Af,
      updateIn: wf,
      merge: Rf,
      mergeDeep: Cf,
      mergeIn: Nf,
      omit: qf,
      addDefaults: Pf,
    };
    Oe.default = $A;
  });
  var xf = u((xn) => {
    "use strict";
    var ZA = $e().default;
    Object.defineProperty(xn, "__esModule", { value: !0 });
    xn.ixRequest = void 0;
    var JA = ZA(rr()),
      e0 = We(),
      t0 = nr(),
      {
        IX2_PREVIEW_REQUESTED: r0,
        IX2_PLAYBACK_REQUESTED: n0,
        IX2_STOP_REQUESTED: i0,
        IX2_CLEAR_REQUESTED: o0,
      } = e0.IX2EngineActionTypes,
      a0 = { preview: {}, playback: {}, stop: {}, clear: {} },
      Lf = Object.create(null, {
        [r0]: { value: "preview" },
        [n0]: { value: "playback" },
        [i0]: { value: "stop" },
        [o0]: { value: "clear" },
      }),
      s0 = (e = a0, t) => {
        if (t.type in Lf) {
          let r = [Lf[t.type]];
          return (0, t0.setIn)(e, [r], (0, JA.default)({}, t.payload));
        }
        return e;
      };
    xn.ixRequest = s0;
  });
  var Df = u((Mn) => {
    "use strict";
    Object.defineProperty(Mn, "__esModule", { value: !0 });
    Mn.ixSession = void 0;
    var u0 = We(),
      ct = nr(),
      {
        IX2_SESSION_INITIALIZED: c0,
        IX2_SESSION_STARTED: l0,
        IX2_TEST_FRAME_RENDERED: f0,
        IX2_SESSION_STOPPED: d0,
        IX2_EVENT_LISTENER_ADDED: p0,
        IX2_EVENT_STATE_CHANGED: v0,
        IX2_ANIMATION_FRAME_CHANGED: E0,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: h0,
        IX2_VIEWPORT_WIDTH_CHANGED: g0,
        IX2_MEDIA_QUERIES_DEFINED: _0,
      } = u0.IX2EngineActionTypes,
      Mf = {
        active: !1,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: !1,
        hasDefinedMediaQueries: !1,
        reducedMotion: !1,
      },
      y0 = 20,
      I0 = (e = Mf, t) => {
        switch (t.type) {
          case c0: {
            let { hasBoundaryNodes: r, reducedMotion: n } = t.payload;
            return (0, ct.merge)(e, { hasBoundaryNodes: r, reducedMotion: n });
          }
          case l0:
            return (0, ct.set)(e, "active", !0);
          case f0: {
            let {
              payload: { step: r = y0 },
            } = t;
            return (0, ct.set)(e, "tick", e.tick + r);
          }
          case d0:
            return Mf;
          case E0: {
            let {
              payload: { now: r },
            } = t;
            return (0, ct.set)(e, "tick", r);
          }
          case p0: {
            let r = (0, ct.addLast)(e.eventListeners, t.payload);
            return (0, ct.set)(e, "eventListeners", r);
          }
          case v0: {
            let { stateKey: r, newState: n } = t.payload;
            return (0, ct.setIn)(e, ["eventState", r], n);
          }
          case h0: {
            let { actionListId: r, isPlaying: n } = t.payload;
            return (0, ct.setIn)(e, ["playbackState", r], n);
          }
          case g0: {
            let { width: r, mediaQueries: n } = t.payload,
              o = n.length,
              i = null;
            for (let a = 0; a < o; a++) {
              let { key: s, min: c, max: f } = n[a];
              if (r >= c && r <= f) {
                i = s;
                break;
              }
            }
            return (0, ct.merge)(e, { viewportWidth: r, mediaQueryKey: i });
          }
          case _0:
            return (0, ct.set)(e, "hasDefinedMediaQueries", !0);
          default:
            return e;
        }
      };
    Mn.ixSession = I0;
  });
  var Gf = u((NH, Ff) => {
    function m0() {
      (this.__data__ = []), (this.size = 0);
    }
    Ff.exports = m0;
  });
  var Dn = u((qH, Xf) => {
    function T0(e, t) {
      return e === t || (e !== e && t !== t);
    }
    Xf.exports = T0;
  });
  var Dr = u((PH, Uf) => {
    var O0 = Dn();
    function b0(e, t) {
      for (var r = e.length; r--; ) if (O0(e[r][0], t)) return r;
      return -1;
    }
    Uf.exports = b0;
  });
  var Wf = u((LH, Vf) => {
    var S0 = Dr(),
      A0 = Array.prototype,
      w0 = A0.splice;
    function R0(e) {
      var t = this.__data__,
        r = S0(t, e);
      if (r < 0) return !1;
      var n = t.length - 1;
      return r == n ? t.pop() : w0.call(t, r, 1), --this.size, !0;
    }
    Vf.exports = R0;
  });
  var Hf = u((xH, Bf) => {
    var C0 = Dr();
    function N0(e) {
      var t = this.__data__,
        r = C0(t, e);
      return r < 0 ? void 0 : t[r][1];
    }
    Bf.exports = N0;
  });
  var kf = u((MH, jf) => {
    var q0 = Dr();
    function P0(e) {
      return q0(this.__data__, e) > -1;
    }
    jf.exports = P0;
  });
  var zf = u((DH, Kf) => {
    var L0 = Dr();
    function x0(e, t) {
      var r = this.__data__,
        n = L0(r, e);
      return n < 0 ? (++this.size, r.push([e, t])) : (r[n][1] = t), this;
    }
    Kf.exports = x0;
  });
  var Fr = u((FH, Yf) => {
    var M0 = Gf(),
      D0 = Wf(),
      F0 = Hf(),
      G0 = kf(),
      X0 = zf();
    function ir(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    ir.prototype.clear = M0;
    ir.prototype.delete = D0;
    ir.prototype.get = F0;
    ir.prototype.has = G0;
    ir.prototype.set = X0;
    Yf.exports = ir;
  });
  var $f = u((GH, Qf) => {
    var U0 = Fr();
    function V0() {
      (this.__data__ = new U0()), (this.size = 0);
    }
    Qf.exports = V0;
  });
  var Jf = u((XH, Zf) => {
    function W0(e) {
      var t = this.__data__,
        r = t.delete(e);
      return (this.size = t.size), r;
    }
    Zf.exports = W0;
  });
  var td = u((UH, ed) => {
    function B0(e) {
      return this.__data__.get(e);
    }
    ed.exports = B0;
  });
  var nd = u((VH, rd) => {
    function H0(e) {
      return this.__data__.has(e);
    }
    rd.exports = H0;
  });
  var lt = u((WH, id) => {
    function j0(e) {
      var t = typeof e;
      return e != null && (t == "object" || t == "function");
    }
    id.exports = j0;
  });
  var na = u((BH, od) => {
    var k0 = St(),
      K0 = lt(),
      z0 = "[object AsyncFunction]",
      Y0 = "[object Function]",
      Q0 = "[object GeneratorFunction]",
      $0 = "[object Proxy]";
    function Z0(e) {
      if (!K0(e)) return !1;
      var t = k0(e);
      return t == Y0 || t == Q0 || t == z0 || t == $0;
    }
    od.exports = Z0;
  });
  var sd = u((HH, ad) => {
    var J0 = et(),
      ew = J0["__core-js_shared__"];
    ad.exports = ew;
  });
  var ld = u((jH, cd) => {
    var ia = sd(),
      ud = (function () {
        var e = /[^.]+$/.exec((ia && ia.keys && ia.keys.IE_PROTO) || "");
        return e ? "Symbol(src)_1." + e : "";
      })();
    function tw(e) {
      return !!ud && ud in e;
    }
    cd.exports = tw;
  });
  var oa = u((kH, fd) => {
    var rw = Function.prototype,
      nw = rw.toString;
    function iw(e) {
      if (e != null) {
        try {
          return nw.call(e);
        } catch {}
        try {
          return e + "";
        } catch {}
      }
      return "";
    }
    fd.exports = iw;
  });
  var pd = u((KH, dd) => {
    var ow = na(),
      aw = ld(),
      sw = lt(),
      uw = oa(),
      cw = /[\\^$.*+?()[\]{}|]/g,
      lw = /^\[object .+?Constructor\]$/,
      fw = Function.prototype,
      dw = Object.prototype,
      pw = fw.toString,
      vw = dw.hasOwnProperty,
      Ew = RegExp(
        "^" +
          pw
            .call(vw)
            .replace(cw, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );
    function hw(e) {
      if (!sw(e) || aw(e)) return !1;
      var t = ow(e) ? Ew : lw;
      return t.test(uw(e));
    }
    dd.exports = hw;
  });
  var Ed = u((zH, vd) => {
    function gw(e, t) {
      return e?.[t];
    }
    vd.exports = gw;
  });
  var At = u((YH, hd) => {
    var _w = pd(),
      yw = Ed();
    function Iw(e, t) {
      var r = yw(e, t);
      return _w(r) ? r : void 0;
    }
    hd.exports = Iw;
  });
  var Fn = u((QH, gd) => {
    var mw = At(),
      Tw = et(),
      Ow = mw(Tw, "Map");
    gd.exports = Ow;
  });
  var Gr = u(($H, _d) => {
    var bw = At(),
      Sw = bw(Object, "create");
    _d.exports = Sw;
  });
  var md = u((ZH, Id) => {
    var yd = Gr();
    function Aw() {
      (this.__data__ = yd ? yd(null) : {}), (this.size = 0);
    }
    Id.exports = Aw;
  });
  var Od = u((JH, Td) => {
    function ww(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    Td.exports = ww;
  });
  var Sd = u((ej, bd) => {
    var Rw = Gr(),
      Cw = "__lodash_hash_undefined__",
      Nw = Object.prototype,
      qw = Nw.hasOwnProperty;
    function Pw(e) {
      var t = this.__data__;
      if (Rw) {
        var r = t[e];
        return r === Cw ? void 0 : r;
      }
      return qw.call(t, e) ? t[e] : void 0;
    }
    bd.exports = Pw;
  });
  var wd = u((tj, Ad) => {
    var Lw = Gr(),
      xw = Object.prototype,
      Mw = xw.hasOwnProperty;
    function Dw(e) {
      var t = this.__data__;
      return Lw ? t[e] !== void 0 : Mw.call(t, e);
    }
    Ad.exports = Dw;
  });
  var Cd = u((rj, Rd) => {
    var Fw = Gr(),
      Gw = "__lodash_hash_undefined__";
    function Xw(e, t) {
      var r = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (r[e] = Fw && t === void 0 ? Gw : t),
        this
      );
    }
    Rd.exports = Xw;
  });
  var qd = u((nj, Nd) => {
    var Uw = md(),
      Vw = Od(),
      Ww = Sd(),
      Bw = wd(),
      Hw = Cd();
    function or(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    or.prototype.clear = Uw;
    or.prototype.delete = Vw;
    or.prototype.get = Ww;
    or.prototype.has = Bw;
    or.prototype.set = Hw;
    Nd.exports = or;
  });
  var xd = u((ij, Ld) => {
    var Pd = qd(),
      jw = Fr(),
      kw = Fn();
    function Kw() {
      (this.size = 0),
        (this.__data__ = {
          hash: new Pd(),
          map: new (kw || jw)(),
          string: new Pd(),
        });
    }
    Ld.exports = Kw;
  });
  var Dd = u((oj, Md) => {
    function zw(e) {
      var t = typeof e;
      return t == "string" || t == "number" || t == "symbol" || t == "boolean"
        ? e !== "__proto__"
        : e === null;
    }
    Md.exports = zw;
  });
  var Xr = u((aj, Fd) => {
    var Yw = Dd();
    function Qw(e, t) {
      var r = e.__data__;
      return Yw(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
    }
    Fd.exports = Qw;
  });
  var Xd = u((sj, Gd) => {
    var $w = Xr();
    function Zw(e) {
      var t = $w(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    Gd.exports = Zw;
  });
  var Vd = u((uj, Ud) => {
    var Jw = Xr();
    function eR(e) {
      return Jw(this, e).get(e);
    }
    Ud.exports = eR;
  });
  var Bd = u((cj, Wd) => {
    var tR = Xr();
    function rR(e) {
      return tR(this, e).has(e);
    }
    Wd.exports = rR;
  });
  var jd = u((lj, Hd) => {
    var nR = Xr();
    function iR(e, t) {
      var r = nR(this, e),
        n = r.size;
      return r.set(e, t), (this.size += r.size == n ? 0 : 1), this;
    }
    Hd.exports = iR;
  });
  var Gn = u((fj, kd) => {
    var oR = xd(),
      aR = Xd(),
      sR = Vd(),
      uR = Bd(),
      cR = jd();
    function ar(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    ar.prototype.clear = oR;
    ar.prototype.delete = aR;
    ar.prototype.get = sR;
    ar.prototype.has = uR;
    ar.prototype.set = cR;
    kd.exports = ar;
  });
  var zd = u((dj, Kd) => {
    var lR = Fr(),
      fR = Fn(),
      dR = Gn(),
      pR = 200;
    function vR(e, t) {
      var r = this.__data__;
      if (r instanceof lR) {
        var n = r.__data__;
        if (!fR || n.length < pR - 1)
          return n.push([e, t]), (this.size = ++r.size), this;
        r = this.__data__ = new dR(n);
      }
      return r.set(e, t), (this.size = r.size), this;
    }
    Kd.exports = vR;
  });
  var aa = u((pj, Yd) => {
    var ER = Fr(),
      hR = $f(),
      gR = Jf(),
      _R = td(),
      yR = nd(),
      IR = zd();
    function sr(e) {
      var t = (this.__data__ = new ER(e));
      this.size = t.size;
    }
    sr.prototype.clear = hR;
    sr.prototype.delete = gR;
    sr.prototype.get = _R;
    sr.prototype.has = yR;
    sr.prototype.set = IR;
    Yd.exports = sr;
  });
  var $d = u((vj, Qd) => {
    var mR = "__lodash_hash_undefined__";
    function TR(e) {
      return this.__data__.set(e, mR), this;
    }
    Qd.exports = TR;
  });
  var Jd = u((Ej, Zd) => {
    function OR(e) {
      return this.__data__.has(e);
    }
    Zd.exports = OR;
  });
  var tp = u((hj, ep) => {
    var bR = Gn(),
      SR = $d(),
      AR = Jd();
    function Xn(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.__data__ = new bR(); ++t < r; ) this.add(e[t]);
    }
    Xn.prototype.add = Xn.prototype.push = SR;
    Xn.prototype.has = AR;
    ep.exports = Xn;
  });
  var np = u((gj, rp) => {
    function wR(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
        if (t(e[r], r, e)) return !0;
      return !1;
    }
    rp.exports = wR;
  });
  var op = u((_j, ip) => {
    function RR(e, t) {
      return e.has(t);
    }
    ip.exports = RR;
  });
  var sa = u((yj, ap) => {
    var CR = tp(),
      NR = np(),
      qR = op(),
      PR = 1,
      LR = 2;
    function xR(e, t, r, n, o, i) {
      var a = r & PR,
        s = e.length,
        c = t.length;
      if (s != c && !(a && c > s)) return !1;
      var f = i.get(e),
        E = i.get(t);
      if (f && E) return f == t && E == e;
      var v = -1,
        h = !0,
        y = r & LR ? new CR() : void 0;
      for (i.set(e, t), i.set(t, e); ++v < s; ) {
        var R = e[v],
          S = t[v];
        if (n) var C = a ? n(S, R, v, t, e, i) : n(R, S, v, e, t, i);
        if (C !== void 0) {
          if (C) continue;
          h = !1;
          break;
        }
        if (y) {
          if (
            !NR(t, function (A, w) {
              if (!qR(y, w) && (R === A || o(R, A, r, n, i))) return y.push(w);
            })
          ) {
            h = !1;
            break;
          }
        } else if (!(R === S || o(R, S, r, n, i))) {
          h = !1;
          break;
        }
      }
      return i.delete(e), i.delete(t), h;
    }
    ap.exports = xR;
  });
  var up = u((Ij, sp) => {
    var MR = et(),
      DR = MR.Uint8Array;
    sp.exports = DR;
  });
  var lp = u((mj, cp) => {
    function FR(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n, o) {
          r[++t] = [o, n];
        }),
        r
      );
    }
    cp.exports = FR;
  });
  var dp = u((Tj, fp) => {
    function GR(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n) {
          r[++t] = n;
        }),
        r
      );
    }
    fp.exports = GR;
  });
  var gp = u((Oj, hp) => {
    var pp = Zt(),
      vp = up(),
      XR = Dn(),
      UR = sa(),
      VR = lp(),
      WR = dp(),
      BR = 1,
      HR = 2,
      jR = "[object Boolean]",
      kR = "[object Date]",
      KR = "[object Error]",
      zR = "[object Map]",
      YR = "[object Number]",
      QR = "[object RegExp]",
      $R = "[object Set]",
      ZR = "[object String]",
      JR = "[object Symbol]",
      eC = "[object ArrayBuffer]",
      tC = "[object DataView]",
      Ep = pp ? pp.prototype : void 0,
      ua = Ep ? Ep.valueOf : void 0;
    function rC(e, t, r, n, o, i, a) {
      switch (r) {
        case tC:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case eC:
          return !(e.byteLength != t.byteLength || !i(new vp(e), new vp(t)));
        case jR:
        case kR:
        case YR:
          return XR(+e, +t);
        case KR:
          return e.name == t.name && e.message == t.message;
        case QR:
        case ZR:
          return e == t + "";
        case zR:
          var s = VR;
        case $R:
          var c = n & BR;
          if ((s || (s = WR), e.size != t.size && !c)) return !1;
          var f = a.get(e);
          if (f) return f == t;
          (n |= HR), a.set(e, t);
          var E = UR(s(e), s(t), n, o, i, a);
          return a.delete(e), E;
        case JR:
          if (ua) return ua.call(e) == ua.call(t);
      }
      return !1;
    }
    hp.exports = rC;
  });
  var Un = u((bj, _p) => {
    function nC(e, t) {
      for (var r = -1, n = t.length, o = e.length; ++r < n; ) e[o + r] = t[r];
      return e;
    }
    _p.exports = nC;
  });
  var qe = u((Sj, yp) => {
    var iC = Array.isArray;
    yp.exports = iC;
  });
  var ca = u((Aj, Ip) => {
    var oC = Un(),
      aC = qe();
    function sC(e, t, r) {
      var n = t(e);
      return aC(e) ? n : oC(n, r(e));
    }
    Ip.exports = sC;
  });
  var Tp = u((wj, mp) => {
    function uC(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
        var a = e[r];
        t(a, r, e) && (i[o++] = a);
      }
      return i;
    }
    mp.exports = uC;
  });
  var la = u((Rj, Op) => {
    function cC() {
      return [];
    }
    Op.exports = cC;
  });
  var fa = u((Cj, Sp) => {
    var lC = Tp(),
      fC = la(),
      dC = Object.prototype,
      pC = dC.propertyIsEnumerable,
      bp = Object.getOwnPropertySymbols,
      vC = bp
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                lC(bp(e), function (t) {
                  return pC.call(e, t);
                }));
          }
        : fC;
    Sp.exports = vC;
  });
  var wp = u((Nj, Ap) => {
    function EC(e, t) {
      for (var r = -1, n = Array(e); ++r < e; ) n[r] = t(r);
      return n;
    }
    Ap.exports = EC;
  });
  var Cp = u((qj, Rp) => {
    var hC = St(),
      gC = _t(),
      _C = "[object Arguments]";
    function yC(e) {
      return gC(e) && hC(e) == _C;
    }
    Rp.exports = yC;
  });
  var Ur = u((Pj, Pp) => {
    var Np = Cp(),
      IC = _t(),
      qp = Object.prototype,
      mC = qp.hasOwnProperty,
      TC = qp.propertyIsEnumerable,
      OC = Np(
        (function () {
          return arguments;
        })()
      )
        ? Np
        : function (e) {
            return IC(e) && mC.call(e, "callee") && !TC.call(e, "callee");
          };
    Pp.exports = OC;
  });
  var xp = u((Lj, Lp) => {
    function bC() {
      return !1;
    }
    Lp.exports = bC;
  });
  var Vn = u((Vr, ur) => {
    var SC = et(),
      AC = xp(),
      Fp = typeof Vr == "object" && Vr && !Vr.nodeType && Vr,
      Mp = Fp && typeof ur == "object" && ur && !ur.nodeType && ur,
      wC = Mp && Mp.exports === Fp,
      Dp = wC ? SC.Buffer : void 0,
      RC = Dp ? Dp.isBuffer : void 0,
      CC = RC || AC;
    ur.exports = CC;
  });
  var Wn = u((xj, Gp) => {
    var NC = 9007199254740991,
      qC = /^(?:0|[1-9]\d*)$/;
    function PC(e, t) {
      var r = typeof e;
      return (
        (t = t ?? NC),
        !!t &&
          (r == "number" || (r != "symbol" && qC.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
      );
    }
    Gp.exports = PC;
  });
  var Bn = u((Mj, Xp) => {
    var LC = 9007199254740991;
    function xC(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= LC;
    }
    Xp.exports = xC;
  });
  var Vp = u((Dj, Up) => {
    var MC = St(),
      DC = Bn(),
      FC = _t(),
      GC = "[object Arguments]",
      XC = "[object Array]",
      UC = "[object Boolean]",
      VC = "[object Date]",
      WC = "[object Error]",
      BC = "[object Function]",
      HC = "[object Map]",
      jC = "[object Number]",
      kC = "[object Object]",
      KC = "[object RegExp]",
      zC = "[object Set]",
      YC = "[object String]",
      QC = "[object WeakMap]",
      $C = "[object ArrayBuffer]",
      ZC = "[object DataView]",
      JC = "[object Float32Array]",
      eN = "[object Float64Array]",
      tN = "[object Int8Array]",
      rN = "[object Int16Array]",
      nN = "[object Int32Array]",
      iN = "[object Uint8Array]",
      oN = "[object Uint8ClampedArray]",
      aN = "[object Uint16Array]",
      sN = "[object Uint32Array]",
      Ie = {};
    Ie[JC] =
      Ie[eN] =
      Ie[tN] =
      Ie[rN] =
      Ie[nN] =
      Ie[iN] =
      Ie[oN] =
      Ie[aN] =
      Ie[sN] =
        !0;
    Ie[GC] =
      Ie[XC] =
      Ie[$C] =
      Ie[UC] =
      Ie[ZC] =
      Ie[VC] =
      Ie[WC] =
      Ie[BC] =
      Ie[HC] =
      Ie[jC] =
      Ie[kC] =
      Ie[KC] =
      Ie[zC] =
      Ie[YC] =
      Ie[QC] =
        !1;
    function uN(e) {
      return FC(e) && DC(e.length) && !!Ie[MC(e)];
    }
    Up.exports = uN;
  });
  var Bp = u((Fj, Wp) => {
    function cN(e) {
      return function (t) {
        return e(t);
      };
    }
    Wp.exports = cN;
  });
  var jp = u((Wr, cr) => {
    var lN = xo(),
      Hp = typeof Wr == "object" && Wr && !Wr.nodeType && Wr,
      Br = Hp && typeof cr == "object" && cr && !cr.nodeType && cr,
      fN = Br && Br.exports === Hp,
      da = fN && lN.process,
      dN = (function () {
        try {
          var e = Br && Br.require && Br.require("util").types;
          return e || (da && da.binding && da.binding("util"));
        } catch {}
      })();
    cr.exports = dN;
  });
  var Hn = u((Gj, zp) => {
    var pN = Vp(),
      vN = Bp(),
      kp = jp(),
      Kp = kp && kp.isTypedArray,
      EN = Kp ? vN(Kp) : pN;
    zp.exports = EN;
  });
  var pa = u((Xj, Yp) => {
    var hN = wp(),
      gN = Ur(),
      _N = qe(),
      yN = Vn(),
      IN = Wn(),
      mN = Hn(),
      TN = Object.prototype,
      ON = TN.hasOwnProperty;
    function bN(e, t) {
      var r = _N(e),
        n = !r && gN(e),
        o = !r && !n && yN(e),
        i = !r && !n && !o && mN(e),
        a = r || n || o || i,
        s = a ? hN(e.length, String) : [],
        c = s.length;
      for (var f in e)
        (t || ON.call(e, f)) &&
          !(
            a &&
            (f == "length" ||
              (o && (f == "offset" || f == "parent")) ||
              (i &&
                (f == "buffer" || f == "byteLength" || f == "byteOffset")) ||
              IN(f, c))
          ) &&
          s.push(f);
      return s;
    }
    Yp.exports = bN;
  });
  var jn = u((Uj, Qp) => {
    var SN = Object.prototype;
    function AN(e) {
      var t = e && e.constructor,
        r = (typeof t == "function" && t.prototype) || SN;
      return e === r;
    }
    Qp.exports = AN;
  });
  var Zp = u((Vj, $p) => {
    var wN = Mo(),
      RN = wN(Object.keys, Object);
    $p.exports = RN;
  });
  var kn = u((Wj, Jp) => {
    var CN = jn(),
      NN = Zp(),
      qN = Object.prototype,
      PN = qN.hasOwnProperty;
    function LN(e) {
      if (!CN(e)) return NN(e);
      var t = [];
      for (var r in Object(e)) PN.call(e, r) && r != "constructor" && t.push(r);
      return t;
    }
    Jp.exports = LN;
  });
  var Xt = u((Bj, ev) => {
    var xN = na(),
      MN = Bn();
    function DN(e) {
      return e != null && MN(e.length) && !xN(e);
    }
    ev.exports = DN;
  });
  var Hr = u((Hj, tv) => {
    var FN = pa(),
      GN = kn(),
      XN = Xt();
    function UN(e) {
      return XN(e) ? FN(e) : GN(e);
    }
    tv.exports = UN;
  });
  var nv = u((jj, rv) => {
    var VN = ca(),
      WN = fa(),
      BN = Hr();
    function HN(e) {
      return VN(e, BN, WN);
    }
    rv.exports = HN;
  });
  var av = u((kj, ov) => {
    var iv = nv(),
      jN = 1,
      kN = Object.prototype,
      KN = kN.hasOwnProperty;
    function zN(e, t, r, n, o, i) {
      var a = r & jN,
        s = iv(e),
        c = s.length,
        f = iv(t),
        E = f.length;
      if (c != E && !a) return !1;
      for (var v = c; v--; ) {
        var h = s[v];
        if (!(a ? h in t : KN.call(t, h))) return !1;
      }
      var y = i.get(e),
        R = i.get(t);
      if (y && R) return y == t && R == e;
      var S = !0;
      i.set(e, t), i.set(t, e);
      for (var C = a; ++v < c; ) {
        h = s[v];
        var A = e[h],
          w = t[h];
        if (n) var m = a ? n(w, A, h, t, e, i) : n(A, w, h, e, t, i);
        if (!(m === void 0 ? A === w || o(A, w, r, n, i) : m)) {
          S = !1;
          break;
        }
        C || (C = h == "constructor");
      }
      if (S && !C) {
        var x = e.constructor,
          L = t.constructor;
        x != L &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            typeof x == "function" &&
            x instanceof x &&
            typeof L == "function" &&
            L instanceof L
          ) &&
          (S = !1);
      }
      return i.delete(e), i.delete(t), S;
    }
    ov.exports = zN;
  });
  var uv = u((Kj, sv) => {
    var YN = At(),
      QN = et(),
      $N = YN(QN, "DataView");
    sv.exports = $N;
  });
  var lv = u((zj, cv) => {
    var ZN = At(),
      JN = et(),
      eq = ZN(JN, "Promise");
    cv.exports = eq;
  });
  var dv = u((Yj, fv) => {
    var tq = At(),
      rq = et(),
      nq = tq(rq, "Set");
    fv.exports = nq;
  });
  var va = u((Qj, pv) => {
    var iq = At(),
      oq = et(),
      aq = iq(oq, "WeakMap");
    pv.exports = aq;
  });
  var Kn = u(($j, Iv) => {
    var Ea = uv(),
      ha = Fn(),
      ga = lv(),
      _a = dv(),
      ya = va(),
      yv = St(),
      lr = oa(),
      vv = "[object Map]",
      sq = "[object Object]",
      Ev = "[object Promise]",
      hv = "[object Set]",
      gv = "[object WeakMap]",
      _v = "[object DataView]",
      uq = lr(Ea),
      cq = lr(ha),
      lq = lr(ga),
      fq = lr(_a),
      dq = lr(ya),
      Ut = yv;
    ((Ea && Ut(new Ea(new ArrayBuffer(1))) != _v) ||
      (ha && Ut(new ha()) != vv) ||
      (ga && Ut(ga.resolve()) != Ev) ||
      (_a && Ut(new _a()) != hv) ||
      (ya && Ut(new ya()) != gv)) &&
      (Ut = function (e) {
        var t = yv(e),
          r = t == sq ? e.constructor : void 0,
          n = r ? lr(r) : "";
        if (n)
          switch (n) {
            case uq:
              return _v;
            case cq:
              return vv;
            case lq:
              return Ev;
            case fq:
              return hv;
            case dq:
              return gv;
          }
        return t;
      });
    Iv.exports = Ut;
  });
  var Rv = u((Zj, wv) => {
    var Ia = aa(),
      pq = sa(),
      vq = gp(),
      Eq = av(),
      mv = Kn(),
      Tv = qe(),
      Ov = Vn(),
      hq = Hn(),
      gq = 1,
      bv = "[object Arguments]",
      Sv = "[object Array]",
      zn = "[object Object]",
      _q = Object.prototype,
      Av = _q.hasOwnProperty;
    function yq(e, t, r, n, o, i) {
      var a = Tv(e),
        s = Tv(t),
        c = a ? Sv : mv(e),
        f = s ? Sv : mv(t);
      (c = c == bv ? zn : c), (f = f == bv ? zn : f);
      var E = c == zn,
        v = f == zn,
        h = c == f;
      if (h && Ov(e)) {
        if (!Ov(t)) return !1;
        (a = !0), (E = !1);
      }
      if (h && !E)
        return (
          i || (i = new Ia()),
          a || hq(e) ? pq(e, t, r, n, o, i) : vq(e, t, c, r, n, o, i)
        );
      if (!(r & gq)) {
        var y = E && Av.call(e, "__wrapped__"),
          R = v && Av.call(t, "__wrapped__");
        if (y || R) {
          var S = y ? e.value() : e,
            C = R ? t.value() : t;
          return i || (i = new Ia()), o(S, C, r, n, i);
        }
      }
      return h ? (i || (i = new Ia()), Eq(e, t, r, n, o, i)) : !1;
    }
    wv.exports = yq;
  });
  var ma = u((Jj, qv) => {
    var Iq = Rv(),
      Cv = _t();
    function Nv(e, t, r, n, o) {
      return e === t
        ? !0
        : e == null || t == null || (!Cv(e) && !Cv(t))
        ? e !== e && t !== t
        : Iq(e, t, r, n, Nv, o);
    }
    qv.exports = Nv;
  });
  var Lv = u((e5, Pv) => {
    var mq = aa(),
      Tq = ma(),
      Oq = 1,
      bq = 2;
    function Sq(e, t, r, n) {
      var o = r.length,
        i = o,
        a = !n;
      if (e == null) return !i;
      for (e = Object(e); o--; ) {
        var s = r[o];
        if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
      }
      for (; ++o < i; ) {
        s = r[o];
        var c = s[0],
          f = e[c],
          E = s[1];
        if (a && s[2]) {
          if (f === void 0 && !(c in e)) return !1;
        } else {
          var v = new mq();
          if (n) var h = n(f, E, c, e, t, v);
          if (!(h === void 0 ? Tq(E, f, Oq | bq, n, v) : h)) return !1;
        }
      }
      return !0;
    }
    Pv.exports = Sq;
  });
  var Ta = u((t5, xv) => {
    var Aq = lt();
    function wq(e) {
      return e === e && !Aq(e);
    }
    xv.exports = wq;
  });
  var Dv = u((r5, Mv) => {
    var Rq = Ta(),
      Cq = Hr();
    function Nq(e) {
      for (var t = Cq(e), r = t.length; r--; ) {
        var n = t[r],
          o = e[n];
        t[r] = [n, o, Rq(o)];
      }
      return t;
    }
    Mv.exports = Nq;
  });
  var Oa = u((n5, Fv) => {
    function qq(e, t) {
      return function (r) {
        return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
      };
    }
    Fv.exports = qq;
  });
  var Xv = u((i5, Gv) => {
    var Pq = Lv(),
      Lq = Dv(),
      xq = Oa();
    function Mq(e) {
      var t = Lq(e);
      return t.length == 1 && t[0][2]
        ? xq(t[0][0], t[0][1])
        : function (r) {
            return r === e || Pq(r, e, t);
          };
    }
    Gv.exports = Mq;
  });
  var jr = u((o5, Uv) => {
    var Dq = St(),
      Fq = _t(),
      Gq = "[object Symbol]";
    function Xq(e) {
      return typeof e == "symbol" || (Fq(e) && Dq(e) == Gq);
    }
    Uv.exports = Xq;
  });
  var Yn = u((a5, Vv) => {
    var Uq = qe(),
      Vq = jr(),
      Wq = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      Bq = /^\w*$/;
    function Hq(e, t) {
      if (Uq(e)) return !1;
      var r = typeof e;
      return r == "number" ||
        r == "symbol" ||
        r == "boolean" ||
        e == null ||
        Vq(e)
        ? !0
        : Bq.test(e) || !Wq.test(e) || (t != null && e in Object(t));
    }
    Vv.exports = Hq;
  });
  var Hv = u((s5, Bv) => {
    var Wv = Gn(),
      jq = "Expected a function";
    function ba(e, t) {
      if (typeof e != "function" || (t != null && typeof t != "function"))
        throw new TypeError(jq);
      var r = function () {
        var n = arguments,
          o = t ? t.apply(this, n) : n[0],
          i = r.cache;
        if (i.has(o)) return i.get(o);
        var a = e.apply(this, n);
        return (r.cache = i.set(o, a) || i), a;
      };
      return (r.cache = new (ba.Cache || Wv)()), r;
    }
    ba.Cache = Wv;
    Bv.exports = ba;
  });
  var kv = u((u5, jv) => {
    var kq = Hv(),
      Kq = 500;
    function zq(e) {
      var t = kq(e, function (n) {
          return r.size === Kq && r.clear(), n;
        }),
        r = t.cache;
      return t;
    }
    jv.exports = zq;
  });
  var zv = u((c5, Kv) => {
    var Yq = kv(),
      Qq =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      $q = /\\(\\)?/g,
      Zq = Yq(function (e) {
        var t = [];
        return (
          e.charCodeAt(0) === 46 && t.push(""),
          e.replace(Qq, function (r, n, o, i) {
            t.push(o ? i.replace($q, "$1") : n || r);
          }),
          t
        );
      });
    Kv.exports = Zq;
  });
  var Sa = u((l5, Yv) => {
    function Jq(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
        o[r] = t(e[r], r, e);
      return o;
    }
    Yv.exports = Jq;
  });
  var tE = u((f5, eE) => {
    var Qv = Zt(),
      eP = Sa(),
      tP = qe(),
      rP = jr(),
      nP = 1 / 0,
      $v = Qv ? Qv.prototype : void 0,
      Zv = $v ? $v.toString : void 0;
    function Jv(e) {
      if (typeof e == "string") return e;
      if (tP(e)) return eP(e, Jv) + "";
      if (rP(e)) return Zv ? Zv.call(e) : "";
      var t = e + "";
      return t == "0" && 1 / e == -nP ? "-0" : t;
    }
    eE.exports = Jv;
  });
  var nE = u((d5, rE) => {
    var iP = tE();
    function oP(e) {
      return e == null ? "" : iP(e);
    }
    rE.exports = oP;
  });
  var kr = u((p5, iE) => {
    var aP = qe(),
      sP = Yn(),
      uP = zv(),
      cP = nE();
    function lP(e, t) {
      return aP(e) ? e : sP(e, t) ? [e] : uP(cP(e));
    }
    iE.exports = lP;
  });
  var fr = u((v5, oE) => {
    var fP = jr(),
      dP = 1 / 0;
    function pP(e) {
      if (typeof e == "string" || fP(e)) return e;
      var t = e + "";
      return t == "0" && 1 / e == -dP ? "-0" : t;
    }
    oE.exports = pP;
  });
  var Qn = u((E5, aE) => {
    var vP = kr(),
      EP = fr();
    function hP(e, t) {
      t = vP(t, e);
      for (var r = 0, n = t.length; e != null && r < n; ) e = e[EP(t[r++])];
      return r && r == n ? e : void 0;
    }
    aE.exports = hP;
  });
  var $n = u((h5, sE) => {
    var gP = Qn();
    function _P(e, t, r) {
      var n = e == null ? void 0 : gP(e, t);
      return n === void 0 ? r : n;
    }
    sE.exports = _P;
  });
  var cE = u((g5, uE) => {
    function yP(e, t) {
      return e != null && t in Object(e);
    }
    uE.exports = yP;
  });
  var fE = u((_5, lE) => {
    var IP = kr(),
      mP = Ur(),
      TP = qe(),
      OP = Wn(),
      bP = Bn(),
      SP = fr();
    function AP(e, t, r) {
      t = IP(t, e);
      for (var n = -1, o = t.length, i = !1; ++n < o; ) {
        var a = SP(t[n]);
        if (!(i = e != null && r(e, a))) break;
        e = e[a];
      }
      return i || ++n != o
        ? i
        : ((o = e == null ? 0 : e.length),
          !!o && bP(o) && OP(a, o) && (TP(e) || mP(e)));
    }
    lE.exports = AP;
  });
  var pE = u((y5, dE) => {
    var wP = cE(),
      RP = fE();
    function CP(e, t) {
      return e != null && RP(e, t, wP);
    }
    dE.exports = CP;
  });
  var EE = u((I5, vE) => {
    var NP = ma(),
      qP = $n(),
      PP = pE(),
      LP = Yn(),
      xP = Ta(),
      MP = Oa(),
      DP = fr(),
      FP = 1,
      GP = 2;
    function XP(e, t) {
      return LP(e) && xP(t)
        ? MP(DP(e), t)
        : function (r) {
            var n = qP(r, e);
            return n === void 0 && n === t ? PP(r, e) : NP(t, n, FP | GP);
          };
    }
    vE.exports = XP;
  });
  var Zn = u((m5, hE) => {
    function UP(e) {
      return e;
    }
    hE.exports = UP;
  });
  var Aa = u((T5, gE) => {
    function VP(e) {
      return function (t) {
        return t?.[e];
      };
    }
    gE.exports = VP;
  });
  var yE = u((O5, _E) => {
    var WP = Qn();
    function BP(e) {
      return function (t) {
        return WP(t, e);
      };
    }
    _E.exports = BP;
  });
  var mE = u((b5, IE) => {
    var HP = Aa(),
      jP = yE(),
      kP = Yn(),
      KP = fr();
    function zP(e) {
      return kP(e) ? HP(KP(e)) : jP(e);
    }
    IE.exports = zP;
  });
  var wt = u((S5, TE) => {
    var YP = Xv(),
      QP = EE(),
      $P = Zn(),
      ZP = qe(),
      JP = mE();
    function eL(e) {
      return typeof e == "function"
        ? e
        : e == null
        ? $P
        : typeof e == "object"
        ? ZP(e)
          ? QP(e[0], e[1])
          : YP(e)
        : JP(e);
    }
    TE.exports = eL;
  });
  var wa = u((A5, OE) => {
    var tL = wt(),
      rL = Xt(),
      nL = Hr();
    function iL(e) {
      return function (t, r, n) {
        var o = Object(t);
        if (!rL(t)) {
          var i = tL(r, 3);
          (t = nL(t)),
            (r = function (s) {
              return i(o[s], s, o);
            });
        }
        var a = e(t, r, n);
        return a > -1 ? o[i ? t[a] : a] : void 0;
      };
    }
    OE.exports = iL;
  });
  var Ra = u((w5, bE) => {
    function oL(e, t, r, n) {
      for (var o = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o; )
        if (t(e[i], i, e)) return i;
      return -1;
    }
    bE.exports = oL;
  });
  var AE = u((R5, SE) => {
    var aL = /\s/;
    function sL(e) {
      for (var t = e.length; t-- && aL.test(e.charAt(t)); );
      return t;
    }
    SE.exports = sL;
  });
  var RE = u((C5, wE) => {
    var uL = AE(),
      cL = /^\s+/;
    function lL(e) {
      return e && e.slice(0, uL(e) + 1).replace(cL, "");
    }
    wE.exports = lL;
  });
  var Jn = u((N5, qE) => {
    var fL = RE(),
      CE = lt(),
      dL = jr(),
      NE = 0 / 0,
      pL = /^[-+]0x[0-9a-f]+$/i,
      vL = /^0b[01]+$/i,
      EL = /^0o[0-7]+$/i,
      hL = parseInt;
    function gL(e) {
      if (typeof e == "number") return e;
      if (dL(e)) return NE;
      if (CE(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = CE(t) ? t + "" : t;
      }
      if (typeof e != "string") return e === 0 ? e : +e;
      e = fL(e);
      var r = vL.test(e);
      return r || EL.test(e) ? hL(e.slice(2), r ? 2 : 8) : pL.test(e) ? NE : +e;
    }
    qE.exports = gL;
  });
  var xE = u((q5, LE) => {
    var _L = Jn(),
      PE = 1 / 0,
      yL = 17976931348623157e292;
    function IL(e) {
      if (!e) return e === 0 ? e : 0;
      if (((e = _L(e)), e === PE || e === -PE)) {
        var t = e < 0 ? -1 : 1;
        return t * yL;
      }
      return e === e ? e : 0;
    }
    LE.exports = IL;
  });
  var Ca = u((P5, ME) => {
    var mL = xE();
    function TL(e) {
      var t = mL(e),
        r = t % 1;
      return t === t ? (r ? t - r : t) : 0;
    }
    ME.exports = TL;
  });
  var FE = u((L5, DE) => {
    var OL = Ra(),
      bL = wt(),
      SL = Ca(),
      AL = Math.max;
    function wL(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var o = r == null ? 0 : SL(r);
      return o < 0 && (o = AL(n + o, 0)), OL(e, bL(t, 3), o);
    }
    DE.exports = wL;
  });
  var Na = u((x5, GE) => {
    var RL = wa(),
      CL = FE(),
      NL = RL(CL);
    GE.exports = NL;
  });
  var ti = u((Ge) => {
    "use strict";
    var qL = $e().default;
    Object.defineProperty(Ge, "__esModule", { value: !0 });
    Ge.withBrowser =
      Ge.TRANSFORM_STYLE_PREFIXED =
      Ge.TRANSFORM_PREFIXED =
      Ge.IS_BROWSER_ENV =
      Ge.FLEX_PREFIXED =
      Ge.ELEMENT_MATCHES =
        void 0;
    var PL = qL(Na()),
      UE = typeof window < "u";
    Ge.IS_BROWSER_ENV = UE;
    var ei = (e, t) => (UE ? e() : t);
    Ge.withBrowser = ei;
    var LL = ei(() =>
      (0, PL.default)(
        [
          "matches",
          "matchesSelector",
          "mozMatchesSelector",
          "msMatchesSelector",
          "oMatchesSelector",
          "webkitMatchesSelector",
        ],
        (e) => e in Element.prototype
      )
    );
    Ge.ELEMENT_MATCHES = LL;
    var xL = ei(() => {
      let e = document.createElement("i"),
        t = ["flex", "-webkit-flex", "-ms-flexbox", "-moz-box", "-webkit-box"],
        r = "";
      try {
        let { length: n } = t;
        for (let o = 0; o < n; o++) {
          let i = t[o];
          if (((e.style.display = i), e.style.display === i)) return i;
        }
        return r;
      } catch {
        return r;
      }
    }, "flex");
    Ge.FLEX_PREFIXED = xL;
    var VE = ei(() => {
      let e = document.createElement("i");
      if (e.style.transform == null) {
        let t = ["Webkit", "Moz", "ms"],
          r = "Transform",
          { length: n } = t;
        for (let o = 0; o < n; o++) {
          let i = t[o] + r;
          if (e.style[i] !== void 0) return i;
        }
      }
      return "transform";
    }, "transform");
    Ge.TRANSFORM_PREFIXED = VE;
    var XE = VE.split("transform")[0],
      ML = XE ? XE + "TransformStyle" : "transformStyle";
    Ge.TRANSFORM_STYLE_PREFIXED = ML;
  });
  var qa = u((D5, kE) => {
    var DL = 4,
      FL = 0.001,
      GL = 1e-7,
      XL = 10,
      Kr = 11,
      ri = 1 / (Kr - 1),
      UL = typeof Float32Array == "function";
    function WE(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function BE(e, t) {
      return 3 * t - 6 * e;
    }
    function HE(e) {
      return 3 * e;
    }
    function ni(e, t, r) {
      return ((WE(t, r) * e + BE(t, r)) * e + HE(t)) * e;
    }
    function jE(e, t, r) {
      return 3 * WE(t, r) * e * e + 2 * BE(t, r) * e + HE(t);
    }
    function VL(e, t, r, n, o) {
      var i,
        a,
        s = 0;
      do
        (a = t + (r - t) / 2), (i = ni(a, n, o) - e), i > 0 ? (r = a) : (t = a);
      while (Math.abs(i) > GL && ++s < XL);
      return a;
    }
    function WL(e, t, r, n) {
      for (var o = 0; o < DL; ++o) {
        var i = jE(t, r, n);
        if (i === 0) return t;
        var a = ni(t, r, n) - e;
        t -= a / i;
      }
      return t;
    }
    kE.exports = function (t, r, n, o) {
      if (!(0 <= t && t <= 1 && 0 <= n && n <= 1))
        throw new Error("bezier x values must be in [0, 1] range");
      var i = UL ? new Float32Array(Kr) : new Array(Kr);
      if (t !== r || n !== o)
        for (var a = 0; a < Kr; ++a) i[a] = ni(a * ri, t, n);
      function s(c) {
        for (var f = 0, E = 1, v = Kr - 1; E !== v && i[E] <= c; ++E) f += ri;
        --E;
        var h = (c - i[E]) / (i[E + 1] - i[E]),
          y = f + h * ri,
          R = jE(y, t, n);
        return R >= FL ? WL(c, y, t, n) : R === 0 ? y : VL(c, f, f + ri, t, n);
      }
      return function (f) {
        return t === r && n === o
          ? f
          : f === 0
          ? 0
          : f === 1
          ? 1
          : ni(s(f), r, o);
      };
    };
  });
  var Pa = u((ie) => {
    "use strict";
    var BL = $e().default;
    Object.defineProperty(ie, "__esModule", { value: !0 });
    ie.bounce = Sx;
    ie.bouncePast = Ax;
    ie.easeOut = ie.easeInOut = ie.easeIn = ie.ease = void 0;
    ie.inBack = hx;
    ie.inCirc = dx;
    ie.inCubic = $L;
    ie.inElastic = yx;
    ie.inExpo = cx;
    ie.inOutBack = _x;
    ie.inOutCirc = vx;
    ie.inOutCubic = JL;
    ie.inOutElastic = mx;
    ie.inOutExpo = fx;
    ie.inOutQuad = QL;
    ie.inOutQuart = rx;
    ie.inOutQuint = ox;
    ie.inOutSine = ux;
    ie.inQuad = zL;
    ie.inQuart = ex;
    ie.inQuint = nx;
    ie.inSine = ax;
    ie.outBack = gx;
    ie.outBounce = Ex;
    ie.outCirc = px;
    ie.outCubic = ZL;
    ie.outElastic = Ix;
    ie.outExpo = lx;
    ie.outQuad = YL;
    ie.outQuart = tx;
    ie.outQuint = ix;
    ie.outSine = sx;
    ie.swingFrom = Ox;
    ie.swingFromTo = Tx;
    ie.swingTo = bx;
    var ii = BL(qa()),
      It = 1.70158,
      HL = (0, ii.default)(0.25, 0.1, 0.25, 1);
    ie.ease = HL;
    var jL = (0, ii.default)(0.42, 0, 1, 1);
    ie.easeIn = jL;
    var kL = (0, ii.default)(0, 0, 0.58, 1);
    ie.easeOut = kL;
    var KL = (0, ii.default)(0.42, 0, 0.58, 1);
    ie.easeInOut = KL;
    function zL(e) {
      return Math.pow(e, 2);
    }
    function YL(e) {
      return -(Math.pow(e - 1, 2) - 1);
    }
    function QL(e) {
      return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
    }
    function $L(e) {
      return Math.pow(e, 3);
    }
    function ZL(e) {
      return Math.pow(e - 1, 3) + 1;
    }
    function JL(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 3)
        : 0.5 * (Math.pow(e - 2, 3) + 2);
    }
    function ex(e) {
      return Math.pow(e, 4);
    }
    function tx(e) {
      return -(Math.pow(e - 1, 4) - 1);
    }
    function rx(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 4)
        : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
    }
    function nx(e) {
      return Math.pow(e, 5);
    }
    function ix(e) {
      return Math.pow(e - 1, 5) + 1;
    }
    function ox(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 5)
        : 0.5 * (Math.pow(e - 2, 5) + 2);
    }
    function ax(e) {
      return -Math.cos(e * (Math.PI / 2)) + 1;
    }
    function sx(e) {
      return Math.sin(e * (Math.PI / 2));
    }
    function ux(e) {
      return -0.5 * (Math.cos(Math.PI * e) - 1);
    }
    function cx(e) {
      return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
    }
    function lx(e) {
      return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
    }
    function fx(e) {
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (e /= 0.5) < 1
        ? 0.5 * Math.pow(2, 10 * (e - 1))
        : 0.5 * (-Math.pow(2, -10 * --e) + 2);
    }
    function dx(e) {
      return -(Math.sqrt(1 - e * e) - 1);
    }
    function px(e) {
      return Math.sqrt(1 - Math.pow(e - 1, 2));
    }
    function vx(e) {
      return (e /= 0.5) < 1
        ? -0.5 * (Math.sqrt(1 - e * e) - 1)
        : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    }
    function Ex(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function hx(e) {
      let t = It;
      return e * e * ((t + 1) * e - t);
    }
    function gx(e) {
      let t = It;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function _x(e) {
      let t = It;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function yx(e) {
      let t = It,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          -(
            n *
            Math.pow(2, 10 * (e -= 1)) *
            Math.sin(((e - t) * (2 * Math.PI)) / r)
          ));
    }
    function Ix(e) {
      let t = It,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          n * Math.pow(2, -10 * e) * Math.sin(((e - t) * (2 * Math.PI)) / r) +
            1);
    }
    function mx(e) {
      let t = It,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : (e /= 1 / 2) === 2
        ? 1
        : (r || (r = 0.3 * 1.5),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          e < 1
            ? -0.5 *
              (n *
                Math.pow(2, 10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r))
            : n *
                Math.pow(2, -10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r) *
                0.5 +
              1);
    }
    function Tx(e) {
      let t = It;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function Ox(e) {
      let t = It;
      return e * e * ((t + 1) * e - t);
    }
    function bx(e) {
      let t = It;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function Sx(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function Ax(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
        : e < 2.5 / 2.75
        ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
        : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
    }
  });
  var xa = u((zr) => {
    "use strict";
    var wx = $e().default,
      Rx = Mt().default;
    Object.defineProperty(zr, "__esModule", { value: !0 });
    zr.applyEasing = qx;
    zr.createBezierEasing = Nx;
    zr.optimizeFloat = La;
    var KE = Rx(Pa()),
      Cx = wx(qa());
    function La(e, t = 5, r = 10) {
      let n = Math.pow(r, t),
        o = Number(Math.round(e * n) / n);
      return Math.abs(o) > 1e-4 ? o : 0;
    }
    function Nx(e) {
      return (0, Cx.default)(...e);
    }
    function qx(e, t, r) {
      return t === 0
        ? 0
        : t === 1
        ? 1
        : La(r ? (t > 0 ? r(t) : t) : t > 0 && e && KE[e] ? KE[e](t) : t);
    }
  });
  var $E = u((dr) => {
    "use strict";
    Object.defineProperty(dr, "__esModule", { value: !0 });
    dr.createElementState = QE;
    dr.ixElements = void 0;
    dr.mergeActionState = Ma;
    var oi = nr(),
      YE = We(),
      {
        HTML_ELEMENT: X5,
        PLAIN_OBJECT: Px,
        ABSTRACT_NODE: U5,
        CONFIG_X_VALUE: Lx,
        CONFIG_Y_VALUE: xx,
        CONFIG_Z_VALUE: Mx,
        CONFIG_VALUE: Dx,
        CONFIG_X_UNIT: Fx,
        CONFIG_Y_UNIT: Gx,
        CONFIG_Z_UNIT: Xx,
        CONFIG_UNIT: Ux,
      } = YE.IX2EngineConstants,
      {
        IX2_SESSION_STOPPED: Vx,
        IX2_INSTANCE_ADDED: Wx,
        IX2_ELEMENT_STATE_CHANGED: Bx,
      } = YE.IX2EngineActionTypes,
      zE = {},
      Hx = "refState",
      jx = (e = zE, t = {}) => {
        switch (t.type) {
          case Vx:
            return zE;
          case Wx: {
            let {
                elementId: r,
                element: n,
                origin: o,
                actionItem: i,
                refType: a,
              } = t.payload,
              { actionTypeId: s } = i,
              c = e;
            return (
              (0, oi.getIn)(c, [r, n]) !== n && (c = QE(c, n, a, r, i)),
              Ma(c, r, s, o, i)
            );
          }
          case Bx: {
            let {
              elementId: r,
              actionTypeId: n,
              current: o,
              actionItem: i,
            } = t.payload;
            return Ma(e, r, n, o, i);
          }
          default:
            return e;
        }
      };
    dr.ixElements = jx;
    function QE(e, t, r, n, o) {
      let i =
        r === Px ? (0, oi.getIn)(o, ["config", "target", "objectId"]) : null;
      return (0, oi.mergeIn)(e, [n], { id: n, ref: t, refId: i, refType: r });
    }
    function Ma(e, t, r, n, o) {
      let i = Kx(o),
        a = [t, Hx, r];
      return (0, oi.mergeIn)(e, a, n, i);
    }
    var kx = [
      [Lx, Fx],
      [xx, Gx],
      [Mx, Xx],
      [Dx, Ux],
    ];
    function Kx(e) {
      let { config: t } = e;
      return kx.reduce((r, n) => {
        let o = n[0],
          i = n[1],
          a = t[o],
          s = t[i];
        return a != null && s != null && (r[i] = s), r;
      }, {});
    }
  });
  var ZE = u((Pe) => {
    "use strict";
    Object.defineProperty(Pe, "__esModule", { value: !0 });
    Pe.renderPlugin =
      Pe.getPluginOrigin =
      Pe.getPluginDuration =
      Pe.getPluginDestination =
      Pe.getPluginConfig =
      Pe.createPluginInstance =
      Pe.clearPlugin =
        void 0;
    var zx = (e) => e.value;
    Pe.getPluginConfig = zx;
    var Yx = (e, t) => {
      if (t.config.duration !== "auto") return null;
      let r = parseFloat(e.getAttribute("data-duration"));
      return r > 0
        ? r * 1e3
        : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
    };
    Pe.getPluginDuration = Yx;
    var Qx = (e) => e || { value: 0 };
    Pe.getPluginOrigin = Qx;
    var $x = (e) => ({ value: e.value });
    Pe.getPluginDestination = $x;
    var Zx = (e) => {
      let t = window.Webflow.require("lottie").createInstance(e);
      return t.stop(), t.setSubframe(!0), t;
    };
    Pe.createPluginInstance = Zx;
    var Jx = (e, t, r) => {
      if (!e) return;
      let n = t[r.actionTypeId].value / 100;
      e.goToFrame(e.frames * n);
    };
    Pe.renderPlugin = Jx;
    var eM = (e) => {
      window.Webflow.require("lottie").createInstance(e).stop();
    };
    Pe.clearPlugin = eM;
  });
  var eh = u((Le) => {
    "use strict";
    Object.defineProperty(Le, "__esModule", { value: !0 });
    Le.renderPlugin =
      Le.getPluginOrigin =
      Le.getPluginDuration =
      Le.getPluginDestination =
      Le.getPluginConfig =
      Le.createPluginInstance =
      Le.clearPlugin =
        void 0;
    var tM = (e) => document.querySelector(`[data-w-id="${e}"]`),
      rM = () => window.Webflow.require("spline"),
      nM = (e, t) => e.filter((r) => !t.includes(r)),
      iM = (e, t) => e.value[t];
    Le.getPluginConfig = iM;
    var oM = () => null;
    Le.getPluginDuration = oM;
    var JE = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
      }),
      aM = (e, t) => {
        let r = t.config.value,
          n = Object.keys(r);
        if (e) {
          let i = Object.keys(e),
            a = nM(n, i);
          return a.length ? a.reduce((c, f) => ((c[f] = JE[f]), c), e) : e;
        }
        return n.reduce((i, a) => ((i[a] = JE[a]), i), {});
      };
    Le.getPluginOrigin = aM;
    var sM = (e) => e.value;
    Le.getPluginDestination = sM;
    var uM = (e, t) => {
      var r, n;
      let o =
        t == null ||
        (r = t.config) === null ||
        r === void 0 ||
        (n = r.target) === null ||
        n === void 0
          ? void 0
          : n.pluginElement;
      return o ? tM(o) : null;
    };
    Le.createPluginInstance = uM;
    var cM = (e, t, r) => {
      let n = rM().getInstance(e),
        o = r.config.target.objectId;
      if (!n || !o) return;
      let i = n.spline.findObjectById(o);
      if (!i) return;
      let { PLUGIN_SPLINE: a } = t;
      a.positionX != null && (i.position.x = a.positionX),
        a.positionY != null && (i.position.y = a.positionY),
        a.positionZ != null && (i.position.z = a.positionZ),
        a.rotationX != null && (i.rotation.x = a.rotationX),
        a.rotationY != null && (i.rotation.y = a.rotationY),
        a.rotationZ != null && (i.rotation.z = a.rotationZ),
        a.scaleX != null && (i.scale.x = a.scaleX),
        a.scaleY != null && (i.scale.y = a.scaleY),
        a.scaleZ != null && (i.scale.z = a.scaleZ);
    };
    Le.renderPlugin = cM;
    var lM = () => null;
    Le.clearPlugin = lM;
  });
  var ih = u((ai) => {
    "use strict";
    var nh = Mt().default,
      fM = $e().default;
    Object.defineProperty(ai, "__esModule", { value: !0 });
    ai.pluginMethodMap = void 0;
    var th = fM(rr()),
      rh = We(),
      dM = nh(ZE()),
      pM = nh(eh()),
      vM = new Map([
        [rh.ActionTypeConsts.PLUGIN_LOTTIE, (0, th.default)({}, dM)],
        [rh.ActionTypeConsts.PLUGIN_SPLINE, (0, th.default)({}, pM)],
      ]);
    ai.pluginMethodMap = vM;
  });
  var Da = u((Ce) => {
    "use strict";
    Object.defineProperty(Ce, "__esModule", { value: !0 });
    Ce.getPluginOrigin =
      Ce.getPluginDuration =
      Ce.getPluginDestination =
      Ce.getPluginConfig =
      Ce.createPluginInstance =
      Ce.clearPlugin =
        void 0;
    Ce.isPluginType = hM;
    Ce.renderPlugin = void 0;
    var EM = ti(),
      oh = ih();
    function hM(e) {
      return oh.pluginMethodMap.has(e);
    }
    var Vt = (e) => (t) => {
        if (!EM.IS_BROWSER_ENV) return () => null;
        let r = oh.pluginMethodMap.get(t);
        if (!r) throw new Error(`IX2 no plugin configured for: ${t}`);
        let n = r[e];
        if (!n) throw new Error(`IX2 invalid plugin method: ${e}`);
        return n;
      },
      gM = Vt("getPluginConfig");
    Ce.getPluginConfig = gM;
    var _M = Vt("getPluginOrigin");
    Ce.getPluginOrigin = _M;
    var yM = Vt("getPluginDuration");
    Ce.getPluginDuration = yM;
    var IM = Vt("getPluginDestination");
    Ce.getPluginDestination = IM;
    var mM = Vt("createPluginInstance");
    Ce.createPluginInstance = mM;
    var TM = Vt("renderPlugin");
    Ce.renderPlugin = TM;
    var OM = Vt("clearPlugin");
    Ce.clearPlugin = OM;
  });
  var sh = u((k5, ah) => {
    function bM(e, t) {
      return e == null || e !== e ? t : e;
    }
    ah.exports = bM;
  });
  var ch = u((K5, uh) => {
    function SM(e, t, r, n) {
      var o = -1,
        i = e == null ? 0 : e.length;
      for (n && i && (r = e[++o]); ++o < i; ) r = t(r, e[o], o, e);
      return r;
    }
    uh.exports = SM;
  });
  var fh = u((z5, lh) => {
    function AM(e) {
      return function (t, r, n) {
        for (var o = -1, i = Object(t), a = n(t), s = a.length; s--; ) {
          var c = a[e ? s : ++o];
          if (r(i[c], c, i) === !1) break;
        }
        return t;
      };
    }
    lh.exports = AM;
  });
  var ph = u((Y5, dh) => {
    var wM = fh(),
      RM = wM();
    dh.exports = RM;
  });
  var Fa = u((Q5, vh) => {
    var CM = ph(),
      NM = Hr();
    function qM(e, t) {
      return e && CM(e, t, NM);
    }
    vh.exports = qM;
  });
  var hh = u(($5, Eh) => {
    var PM = Xt();
    function LM(e, t) {
      return function (r, n) {
        if (r == null) return r;
        if (!PM(r)) return e(r, n);
        for (
          var o = r.length, i = t ? o : -1, a = Object(r);
          (t ? i-- : ++i < o) && n(a[i], i, a) !== !1;

        );
        return r;
      };
    }
    Eh.exports = LM;
  });
  var Ga = u((Z5, gh) => {
    var xM = Fa(),
      MM = hh(),
      DM = MM(xM);
    gh.exports = DM;
  });
  var yh = u((J5, _h) => {
    function FM(e, t, r, n, o) {
      return (
        o(e, function (i, a, s) {
          r = n ? ((n = !1), i) : t(r, i, a, s);
        }),
        r
      );
    }
    _h.exports = FM;
  });
  var mh = u((ek, Ih) => {
    var GM = ch(),
      XM = Ga(),
      UM = wt(),
      VM = yh(),
      WM = qe();
    function BM(e, t, r) {
      var n = WM(e) ? GM : VM,
        o = arguments.length < 3;
      return n(e, UM(t, 4), r, o, XM);
    }
    Ih.exports = BM;
  });
  var Oh = u((tk, Th) => {
    var HM = Ra(),
      jM = wt(),
      kM = Ca(),
      KM = Math.max,
      zM = Math.min;
    function YM(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var o = n - 1;
      return (
        r !== void 0 &&
          ((o = kM(r)), (o = r < 0 ? KM(n + o, 0) : zM(o, n - 1))),
        HM(e, jM(t, 3), o, !0)
      );
    }
    Th.exports = YM;
  });
  var Sh = u((rk, bh) => {
    var QM = wa(),
      $M = Oh(),
      ZM = QM($M);
    bh.exports = ZM;
  });
  var wh = u((si) => {
    "use strict";
    Object.defineProperty(si, "__esModule", { value: !0 });
    si.default = void 0;
    var JM = Object.prototype.hasOwnProperty;
    function Ah(e, t) {
      return e === t
        ? e !== 0 || t !== 0 || 1 / e === 1 / t
        : e !== e && t !== t;
    }
    function eD(e, t) {
      if (Ah(e, t)) return !0;
      if (
        typeof e != "object" ||
        e === null ||
        typeof t != "object" ||
        t === null
      )
        return !1;
      let r = Object.keys(e),
        n = Object.keys(t);
      if (r.length !== n.length) return !1;
      for (let o = 0; o < r.length; o++)
        if (!JM.call(t, r[o]) || !Ah(e[r[o]], t[r[o]])) return !1;
      return !0;
    }
    var tD = eD;
    si.default = tD;
  });
  var kh = u((he) => {
    "use strict";
    var fi = $e().default;
    Object.defineProperty(he, "__esModule", { value: !0 });
    he.cleanupHTMLElement = JD;
    he.clearAllStyles = ZD;
    he.clearObjectCache = yD;
    he.getActionListProgress = tF;
    he.getAffectedElements = ja;
    he.getComputedStyle = wD;
    he.getDestinationValues = xD;
    he.getElementId = OD;
    he.getInstanceId = mD;
    he.getInstanceOrigin = ND;
    he.getItemConfigByKey = void 0;
    he.getMaxDurationItemIndex = jh;
    he.getNamespacedParameterId = iF;
    he.getRenderType = Wh;
    he.getStyleProp = MD;
    he.mediaQueriesEqual = aF;
    he.observeStore = AD;
    he.reduceListToGroup = rF;
    he.reifyState = bD;
    he.renderHTMLElement = DD;
    Object.defineProperty(he, "shallowEqual", {
      enumerable: !0,
      get: function () {
        return Mh.default;
      },
    });
    he.shouldAllowMediaQuery = oF;
    he.shouldNamespaceEventParameter = nF;
    he.stringifyTarget = sF;
    var Rt = fi(sh()),
      Va = fi(mh()),
      Ua = fi(Sh()),
      Rh = nr(),
      Wt = We(),
      Mh = fi(wh()),
      rD = xa(),
      pt = Da(),
      Xe = ti(),
      {
        BACKGROUND: nD,
        TRANSFORM: iD,
        TRANSLATE_3D: oD,
        SCALE_3D: aD,
        ROTATE_X: sD,
        ROTATE_Y: uD,
        ROTATE_Z: cD,
        SKEW: lD,
        PRESERVE_3D: fD,
        FLEX: dD,
        OPACITY: ci,
        FILTER: Yr,
        FONT_VARIATION_SETTINGS: Qr,
        WIDTH: ft,
        HEIGHT: dt,
        BACKGROUND_COLOR: Dh,
        BORDER_COLOR: pD,
        COLOR: vD,
        CHILDREN: Ch,
        IMMEDIATE_CHILDREN: ED,
        SIBLINGS: Nh,
        PARENT: hD,
        DISPLAY: li,
        WILL_CHANGE: pr,
        AUTO: Ct,
        COMMA_DELIMITER: $r,
        COLON_DELIMITER: gD,
        BAR_DELIMITER: Xa,
        RENDER_TRANSFORM: Fh,
        RENDER_GENERAL: Wa,
        RENDER_STYLE: Ba,
        RENDER_PLUGIN: Gh,
      } = Wt.IX2EngineConstants,
      {
        TRANSFORM_MOVE: vr,
        TRANSFORM_SCALE: Er,
        TRANSFORM_ROTATE: hr,
        TRANSFORM_SKEW: Zr,
        STYLE_OPACITY: Xh,
        STYLE_FILTER: Jr,
        STYLE_FONT_VARIATION: en,
        STYLE_SIZE: gr,
        STYLE_BACKGROUND_COLOR: _r,
        STYLE_BORDER: yr,
        STYLE_TEXT_COLOR: Ir,
        GENERAL_DISPLAY: di,
        OBJECT_VALUE: _D,
      } = Wt.ActionTypeConsts,
      Uh = (e) => e.trim(),
      Ha = Object.freeze({ [_r]: Dh, [yr]: pD, [Ir]: vD }),
      Vh = Object.freeze({
        [Xe.TRANSFORM_PREFIXED]: iD,
        [Dh]: nD,
        [ci]: ci,
        [Yr]: Yr,
        [ft]: ft,
        [dt]: dt,
        [Qr]: Qr,
      }),
      ui = new Map();
    function yD() {
      ui.clear();
    }
    var ID = 1;
    function mD() {
      return "i" + ID++;
    }
    var TD = 1;
    function OD(e, t) {
      for (let r in e) {
        let n = e[r];
        if (n && n.ref === t) return n.id;
      }
      return "e" + TD++;
    }
    function bD({ events: e, actionLists: t, site: r } = {}) {
      let n = (0, Va.default)(
          e,
          (a, s) => {
            let { eventTypeId: c } = s;
            return a[c] || (a[c] = {}), (a[c][s.id] = s), a;
          },
          {}
        ),
        o = r && r.mediaQueries,
        i = [];
      return (
        o
          ? (i = o.map((a) => a.key))
          : ((o = []), console.warn("IX2 missing mediaQueries in site data")),
        {
          ixData: {
            events: e,
            actionLists: t,
            eventTypeMap: n,
            mediaQueries: o,
            mediaQueryKeys: i,
          },
        }
      );
    }
    var SD = (e, t) => e === t;
    function AD({ store: e, select: t, onChange: r, comparator: n = SD }) {
      let { getState: o, subscribe: i } = e,
        a = i(c),
        s = t(o());
      function c() {
        let f = t(o());
        if (f == null) {
          a();
          return;
        }
        n(f, s) || ((s = f), r(s, e));
      }
      return a;
    }
    function qh(e) {
      let t = typeof e;
      if (t === "string") return { id: e };
      if (e != null && t === "object") {
        let {
          id: r,
          objectId: n,
          selector: o,
          selectorGuids: i,
          appliesTo: a,
          useEventTarget: s,
        } = e;
        return {
          id: r,
          objectId: n,
          selector: o,
          selectorGuids: i,
          appliesTo: a,
          useEventTarget: s,
        };
      }
      return {};
    }
    function ja({
      config: e,
      event: t,
      eventTarget: r,
      elementRoot: n,
      elementApi: o,
    }) {
      var i, a, s;
      if (!o) throw new Error("IX2 missing elementApi");
      let { targets: c } = e;
      if (Array.isArray(c) && c.length > 0)
        return c.reduce(
          (D, G) =>
            D.concat(
              ja({
                config: { target: G },
                event: t,
                eventTarget: r,
                elementRoot: n,
                elementApi: o,
              })
            ),
          []
        );
      let {
          getValidDocument: f,
          getQuerySelector: E,
          queryDocument: v,
          getChildElements: h,
          getSiblingElements: y,
          matchSelector: R,
          elementContains: S,
          isSiblingNode: C,
        } = o,
        { target: A } = e;
      if (!A) return [];
      let {
        id: w,
        objectId: m,
        selector: x,
        selectorGuids: L,
        appliesTo: N,
        useEventTarget: X,
      } = qh(A);
      if (m) return [ui.has(m) ? ui.get(m) : ui.set(m, {}).get(m)];
      if (N === Wt.EventAppliesTo.PAGE) {
        let D = f(w);
        return D ? [D] : [];
      }
      let Y =
          ((i =
            t == null ||
            (a = t.action) === null ||
            a === void 0 ||
            (s = a.config) === null ||
            s === void 0
              ? void 0
              : s.affectedElements) !== null && i !== void 0
            ? i
            : {})[w || x] || {},
        se = !!(Y.id || Y.selector),
        te,
        M,
        I,
        P = t && E(qh(t.target));
      if (
        (se
          ? ((te = Y.limitAffectedElements), (M = P), (I = E(Y)))
          : (M = I = E({ id: w, selector: x, selectorGuids: L })),
        t && X)
      ) {
        let D = r && (I || X === !0) ? [r] : v(P);
        if (I) {
          if (X === hD) return v(I).filter((G) => D.some((Q) => S(G, Q)));
          if (X === Ch) return v(I).filter((G) => D.some((Q) => S(Q, G)));
          if (X === Nh) return v(I).filter((G) => D.some((Q) => C(Q, G)));
        }
        return D;
      }
      return M == null || I == null
        ? []
        : Xe.IS_BROWSER_ENV && n
        ? v(I).filter((D) => n.contains(D))
        : te === Ch
        ? v(M, I)
        : te === ED
        ? h(v(M)).filter(R(I))
        : te === Nh
        ? y(v(M)).filter(R(I))
        : v(I);
    }
    function wD({ element: e, actionItem: t }) {
      if (!Xe.IS_BROWSER_ENV) return {};
      let { actionTypeId: r } = t;
      switch (r) {
        case gr:
        case _r:
        case yr:
        case Ir:
        case di:
          return window.getComputedStyle(e);
        default:
          return {};
      }
    }
    var Ph = /px/,
      RD = (e, t) =>
        t.reduce(
          (r, n) => (r[n.type] == null && (r[n.type] = FD[n.type]), r),
          e || {}
        ),
      CD = (e, t) =>
        t.reduce(
          (r, n) => (
            r[n.type] == null &&
              (r[n.type] = GD[n.type] || n.defaultValue || 0),
            r
          ),
          e || {}
        );
    function ND(e, t = {}, r = {}, n, o) {
      let { getStyle: i } = o,
        { actionTypeId: a } = n;
      if ((0, pt.isPluginType)(a)) return (0, pt.getPluginOrigin)(a)(t[a], n);
      switch (n.actionTypeId) {
        case vr:
        case Er:
        case hr:
        case Zr:
          return t[n.actionTypeId] || ka[n.actionTypeId];
        case Jr:
          return RD(t[n.actionTypeId], n.config.filters);
        case en:
          return CD(t[n.actionTypeId], n.config.fontVariations);
        case Xh:
          return { value: (0, Rt.default)(parseFloat(i(e, ci)), 1) };
        case gr: {
          let s = i(e, ft),
            c = i(e, dt),
            f,
            E;
          return (
            n.config.widthUnit === Ct
              ? (f = Ph.test(s) ? parseFloat(s) : parseFloat(r.width))
              : (f = (0, Rt.default)(parseFloat(s), parseFloat(r.width))),
            n.config.heightUnit === Ct
              ? (E = Ph.test(c) ? parseFloat(c) : parseFloat(r.height))
              : (E = (0, Rt.default)(parseFloat(c), parseFloat(r.height))),
            { widthValue: f, heightValue: E }
          );
        }
        case _r:
        case yr:
        case Ir:
          return YD({
            element: e,
            actionTypeId: n.actionTypeId,
            computedStyle: r,
            getStyle: i,
          });
        case di:
          return { value: (0, Rt.default)(i(e, li), r.display) };
        case _D:
          return t[n.actionTypeId] || { value: 0 };
        default:
          return;
      }
    }
    var qD = (e, t) => (t && (e[t.type] = t.value || 0), e),
      PD = (e, t) => (t && (e[t.type] = t.value || 0), e),
      LD = (e, t, r) => {
        if ((0, pt.isPluginType)(e)) return (0, pt.getPluginConfig)(e)(r, t);
        switch (e) {
          case Jr: {
            let n = (0, Ua.default)(r.filters, ({ type: o }) => o === t);
            return n ? n.value : 0;
          }
          case en: {
            let n = (0, Ua.default)(r.fontVariations, ({ type: o }) => o === t);
            return n ? n.value : 0;
          }
          default:
            return r[t];
        }
      };
    he.getItemConfigByKey = LD;
    function xD({ element: e, actionItem: t, elementApi: r }) {
      if ((0, pt.isPluginType)(t.actionTypeId))
        return (0, pt.getPluginDestination)(t.actionTypeId)(t.config);
      switch (t.actionTypeId) {
        case vr:
        case Er:
        case hr:
        case Zr: {
          let { xValue: n, yValue: o, zValue: i } = t.config;
          return { xValue: n, yValue: o, zValue: i };
        }
        case gr: {
          let { getStyle: n, setStyle: o, getProperty: i } = r,
            { widthUnit: a, heightUnit: s } = t.config,
            { widthValue: c, heightValue: f } = t.config;
          if (!Xe.IS_BROWSER_ENV) return { widthValue: c, heightValue: f };
          if (a === Ct) {
            let E = n(e, ft);
            o(e, ft, ""), (c = i(e, "offsetWidth")), o(e, ft, E);
          }
          if (s === Ct) {
            let E = n(e, dt);
            o(e, dt, ""), (f = i(e, "offsetHeight")), o(e, dt, E);
          }
          return { widthValue: c, heightValue: f };
        }
        case _r:
        case yr:
        case Ir: {
          let { rValue: n, gValue: o, bValue: i, aValue: a } = t.config;
          return { rValue: n, gValue: o, bValue: i, aValue: a };
        }
        case Jr:
          return t.config.filters.reduce(qD, {});
        case en:
          return t.config.fontVariations.reduce(PD, {});
        default: {
          let { value: n } = t.config;
          return { value: n };
        }
      }
    }
    function Wh(e) {
      if (/^TRANSFORM_/.test(e)) return Fh;
      if (/^STYLE_/.test(e)) return Ba;
      if (/^GENERAL_/.test(e)) return Wa;
      if (/^PLUGIN_/.test(e)) return Gh;
    }
    function MD(e, t) {
      return e === Ba ? t.replace("STYLE_", "").toLowerCase() : null;
    }
    function DD(e, t, r, n, o, i, a, s, c) {
      switch (s) {
        case Fh:
          return VD(e, t, r, o, a);
        case Ba:
          return QD(e, t, r, o, i, a);
        case Wa:
          return $D(e, o, a);
        case Gh: {
          let { actionTypeId: f } = o;
          if ((0, pt.isPluginType)(f)) return (0, pt.renderPlugin)(f)(c, t, o);
        }
      }
    }
    var ka = {
        [vr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [Er]: Object.freeze({ xValue: 1, yValue: 1, zValue: 1 }),
        [hr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [Zr]: Object.freeze({ xValue: 0, yValue: 0 }),
      },
      FD = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100,
      }),
      GD = Object.freeze({ wght: 0, opsz: 0, wdth: 0, slnt: 0 }),
      XD = (e, t) => {
        let r = (0, Ua.default)(t.filters, ({ type: n }) => n === e);
        if (r && r.unit) return r.unit;
        switch (e) {
          case "blur":
            return "px";
          case "hue-rotate":
            return "deg";
          default:
            return "%";
        }
      },
      UD = Object.keys(ka);
    function VD(e, t, r, n, o) {
      let i = UD.map((s) => {
          let c = ka[s],
            {
              xValue: f = c.xValue,
              yValue: E = c.yValue,
              zValue: v = c.zValue,
              xUnit: h = "",
              yUnit: y = "",
              zUnit: R = "",
            } = t[s] || {};
          switch (s) {
            case vr:
              return `${oD}(${f}${h}, ${E}${y}, ${v}${R})`;
            case Er:
              return `${aD}(${f}${h}, ${E}${y}, ${v}${R})`;
            case hr:
              return `${sD}(${f}${h}) ${uD}(${E}${y}) ${cD}(${v}${R})`;
            case Zr:
              return `${lD}(${f}${h}, ${E}${y})`;
            default:
              return "";
          }
        }).join(" "),
        { setStyle: a } = o;
      Bt(e, Xe.TRANSFORM_PREFIXED, o),
        a(e, Xe.TRANSFORM_PREFIXED, i),
        HD(n, r) && a(e, Xe.TRANSFORM_STYLE_PREFIXED, fD);
    }
    function WD(e, t, r, n) {
      let o = (0, Va.default)(t, (a, s, c) => `${a} ${c}(${s}${XD(c, r)})`, ""),
        { setStyle: i } = n;
      Bt(e, Yr, n), i(e, Yr, o);
    }
    function BD(e, t, r, n) {
      let o = (0, Va.default)(
          t,
          (a, s, c) => (a.push(`"${c}" ${s}`), a),
          []
        ).join(", "),
        { setStyle: i } = n;
      Bt(e, Qr, n), i(e, Qr, o);
    }
    function HD({ actionTypeId: e }, { xValue: t, yValue: r, zValue: n }) {
      return (
        (e === vr && n !== void 0) ||
        (e === Er && n !== void 0) ||
        (e === hr && (t !== void 0 || r !== void 0))
      );
    }
    var jD = "\\(([^)]+)\\)",
      kD = /^rgb/,
      KD = RegExp(`rgba?${jD}`);
    function zD(e, t) {
      let r = e.exec(t);
      return r ? r[1] : "";
    }
    function YD({
      element: e,
      actionTypeId: t,
      computedStyle: r,
      getStyle: n,
    }) {
      let o = Ha[t],
        i = n(e, o),
        a = kD.test(i) ? i : r[o],
        s = zD(KD, a).split($r);
      return {
        rValue: (0, Rt.default)(parseInt(s[0], 10), 255),
        gValue: (0, Rt.default)(parseInt(s[1], 10), 255),
        bValue: (0, Rt.default)(parseInt(s[2], 10), 255),
        aValue: (0, Rt.default)(parseFloat(s[3]), 1),
      };
    }
    function QD(e, t, r, n, o, i) {
      let { setStyle: a } = i;
      switch (n.actionTypeId) {
        case gr: {
          let { widthUnit: s = "", heightUnit: c = "" } = n.config,
            { widthValue: f, heightValue: E } = r;
          f !== void 0 &&
            (s === Ct && (s = "px"), Bt(e, ft, i), a(e, ft, f + s)),
            E !== void 0 &&
              (c === Ct && (c = "px"), Bt(e, dt, i), a(e, dt, E + c));
          break;
        }
        case Jr: {
          WD(e, r, n.config, i);
          break;
        }
        case en: {
          BD(e, r, n.config, i);
          break;
        }
        case _r:
        case yr:
        case Ir: {
          let s = Ha[n.actionTypeId],
            c = Math.round(r.rValue),
            f = Math.round(r.gValue),
            E = Math.round(r.bValue),
            v = r.aValue;
          Bt(e, s, i),
            a(
              e,
              s,
              v >= 1 ? `rgb(${c},${f},${E})` : `rgba(${c},${f},${E},${v})`
            );
          break;
        }
        default: {
          let { unit: s = "" } = n.config;
          Bt(e, o, i), a(e, o, r.value + s);
          break;
        }
      }
    }
    function $D(e, t, r) {
      let { setStyle: n } = r;
      switch (t.actionTypeId) {
        case di: {
          let { value: o } = t.config;
          o === dD && Xe.IS_BROWSER_ENV
            ? n(e, li, Xe.FLEX_PREFIXED)
            : n(e, li, o);
          return;
        }
      }
    }
    function Bt(e, t, r) {
      if (!Xe.IS_BROWSER_ENV) return;
      let n = Vh[t];
      if (!n) return;
      let { getStyle: o, setStyle: i } = r,
        a = o(e, pr);
      if (!a) {
        i(e, pr, n);
        return;
      }
      let s = a.split($r).map(Uh);
      s.indexOf(n) === -1 && i(e, pr, s.concat(n).join($r));
    }
    function Bh(e, t, r) {
      if (!Xe.IS_BROWSER_ENV) return;
      let n = Vh[t];
      if (!n) return;
      let { getStyle: o, setStyle: i } = r,
        a = o(e, pr);
      !a ||
        a.indexOf(n) === -1 ||
        i(
          e,
          pr,
          a
            .split($r)
            .map(Uh)
            .filter((s) => s !== n)
            .join($r)
        );
    }
    function ZD({ store: e, elementApi: t }) {
      let { ixData: r } = e.getState(),
        { events: n = {}, actionLists: o = {} } = r;
      Object.keys(n).forEach((i) => {
        let a = n[i],
          { config: s } = a.action,
          { actionListId: c } = s,
          f = o[c];
        f && Lh({ actionList: f, event: a, elementApi: t });
      }),
        Object.keys(o).forEach((i) => {
          Lh({ actionList: o[i], elementApi: t });
        });
    }
    function Lh({ actionList: e = {}, event: t, elementApi: r }) {
      let { actionItemGroups: n, continuousParameterGroups: o } = e;
      n &&
        n.forEach((i) => {
          xh({ actionGroup: i, event: t, elementApi: r });
        }),
        o &&
          o.forEach((i) => {
            let { continuousActionGroups: a } = i;
            a.forEach((s) => {
              xh({ actionGroup: s, event: t, elementApi: r });
            });
          });
    }
    function xh({ actionGroup: e, event: t, elementApi: r }) {
      let { actionItems: n } = e;
      n.forEach(({ actionTypeId: o, config: i }) => {
        let a;
        (0, pt.isPluginType)(o)
          ? (a = (0, pt.clearPlugin)(o))
          : (a = Hh({ effect: eF, actionTypeId: o, elementApi: r })),
          ja({ config: i, event: t, elementApi: r }).forEach(a);
      });
    }
    function JD(e, t, r) {
      let { setStyle: n, getStyle: o } = r,
        { actionTypeId: i } = t;
      if (i === gr) {
        let { config: a } = t;
        a.widthUnit === Ct && n(e, ft, ""), a.heightUnit === Ct && n(e, dt, "");
      }
      o(e, pr) && Hh({ effect: Bh, actionTypeId: i, elementApi: r })(e);
    }
    var Hh =
      ({ effect: e, actionTypeId: t, elementApi: r }) =>
      (n) => {
        switch (t) {
          case vr:
          case Er:
          case hr:
          case Zr:
            e(n, Xe.TRANSFORM_PREFIXED, r);
            break;
          case Jr:
            e(n, Yr, r);
            break;
          case en:
            e(n, Qr, r);
            break;
          case Xh:
            e(n, ci, r);
            break;
          case gr:
            e(n, ft, r), e(n, dt, r);
            break;
          case _r:
          case yr:
          case Ir:
            e(n, Ha[t], r);
            break;
          case di:
            e(n, li, r);
            break;
        }
      };
    function eF(e, t, r) {
      let { setStyle: n } = r;
      Bh(e, t, r),
        n(e, t, ""),
        t === Xe.TRANSFORM_PREFIXED && n(e, Xe.TRANSFORM_STYLE_PREFIXED, "");
    }
    function jh(e) {
      let t = 0,
        r = 0;
      return (
        e.forEach((n, o) => {
          let { config: i } = n,
            a = i.delay + i.duration;
          a >= t && ((t = a), (r = o));
        }),
        r
      );
    }
    function tF(e, t) {
      let { actionItemGroups: r, useFirstGroupAsInitialState: n } = e,
        { actionItem: o, verboseTimeElapsed: i = 0 } = t,
        a = 0,
        s = 0;
      return (
        r.forEach((c, f) => {
          if (n && f === 0) return;
          let { actionItems: E } = c,
            v = E[jh(E)],
            { config: h, actionTypeId: y } = v;
          o.id === v.id && (s = a + i);
          let R = Wh(y) === Wa ? 0 : h.duration;
          a += h.delay + R;
        }),
        a > 0 ? (0, rD.optimizeFloat)(s / a) : 0
      );
    }
    function rF({ actionList: e, actionItemId: t, rawData: r }) {
      let { actionItemGroups: n, continuousParameterGroups: o } = e,
        i = [],
        a = (s) => (
          i.push((0, Rh.mergeIn)(s, ["config"], { delay: 0, duration: 0 })),
          s.id === t
        );
      return (
        n && n.some(({ actionItems: s }) => s.some(a)),
        o &&
          o.some((s) => {
            let { continuousActionGroups: c } = s;
            return c.some(({ actionItems: f }) => f.some(a));
          }),
        (0, Rh.setIn)(r, ["actionLists"], {
          [e.id]: { id: e.id, actionItemGroups: [{ actionItems: i }] },
        })
      );
    }
    function nF(e, { basedOn: t }) {
      return (
        (e === Wt.EventTypeConsts.SCROLLING_IN_VIEW &&
          (t === Wt.EventBasedOn.ELEMENT || t == null)) ||
        (e === Wt.EventTypeConsts.MOUSE_MOVE && t === Wt.EventBasedOn.ELEMENT)
      );
    }
    function iF(e, t) {
      return e + gD + t;
    }
    function oF(e, t) {
      return t == null ? !0 : e.indexOf(t) !== -1;
    }
    function aF(e, t) {
      return (0, Mh.default)(e && e.sort(), t && t.sort());
    }
    function sF(e) {
      if (typeof e == "string") return e;
      if (e.pluginElement && e.objectId)
        return e.pluginElement + Xa + e.objectId;
      let { id: t = "", selector: r = "", useEventTarget: n = "" } = e;
      return t + Xa + r + Xa + n;
    }
  });
  var Ht = u((Ue) => {
    "use strict";
    var mr = Mt().default;
    Object.defineProperty(Ue, "__esModule", { value: !0 });
    Ue.IX2VanillaUtils =
      Ue.IX2VanillaPlugins =
      Ue.IX2ElementsReducer =
      Ue.IX2Easings =
      Ue.IX2EasingUtils =
      Ue.IX2BrowserSupport =
        void 0;
    var uF = mr(ti());
    Ue.IX2BrowserSupport = uF;
    var cF = mr(Pa());
    Ue.IX2Easings = cF;
    var lF = mr(xa());
    Ue.IX2EasingUtils = lF;
    var fF = mr($E());
    Ue.IX2ElementsReducer = fF;
    var dF = mr(Da());
    Ue.IX2VanillaPlugins = dF;
    var pF = mr(kh());
    Ue.IX2VanillaUtils = pF;
  });
  var Qh = u((vi) => {
    "use strict";
    Object.defineProperty(vi, "__esModule", { value: !0 });
    vi.ixInstances = void 0;
    var Kh = We(),
      zh = Ht(),
      Tr = nr(),
      {
        IX2_RAW_DATA_IMPORTED: vF,
        IX2_SESSION_STOPPED: EF,
        IX2_INSTANCE_ADDED: hF,
        IX2_INSTANCE_STARTED: gF,
        IX2_INSTANCE_REMOVED: _F,
        IX2_ANIMATION_FRAME_CHANGED: yF,
      } = Kh.IX2EngineActionTypes,
      {
        optimizeFloat: pi,
        applyEasing: Yh,
        createBezierEasing: IF,
      } = zh.IX2EasingUtils,
      { RENDER_GENERAL: mF } = Kh.IX2EngineConstants,
      {
        getItemConfigByKey: Ka,
        getRenderType: TF,
        getStyleProp: OF,
      } = zh.IX2VanillaUtils,
      bF = (e, t) => {
        let {
            position: r,
            parameterId: n,
            actionGroups: o,
            destinationKeys: i,
            smoothing: a,
            restingValue: s,
            actionTypeId: c,
            customEasingFn: f,
            skipMotion: E,
            skipToValue: v,
          } = e,
          { parameters: h } = t.payload,
          y = Math.max(1 - a, 0.01),
          R = h[n];
        R == null && ((y = 1), (R = s));
        let S = Math.max(R, 0) || 0,
          C = pi(S - r),
          A = E ? v : pi(r + C * y),
          w = A * 100;
        if (A === r && e.current) return e;
        let m, x, L, N;
        for (let k = 0, { length: Y } = o; k < Y; k++) {
          let { keyframe: se, actionItems: te } = o[k];
          if ((k === 0 && (m = te[0]), w >= se)) {
            m = te[0];
            let M = o[k + 1],
              I = M && w !== se;
            (x = I ? M.actionItems[0] : null),
              I && ((L = se / 100), (N = (M.keyframe - se) / 100));
          }
        }
        let X = {};
        if (m && !x)
          for (let k = 0, { length: Y } = i; k < Y; k++) {
            let se = i[k];
            X[se] = Ka(c, se, m.config);
          }
        else if (m && x && L !== void 0 && N !== void 0) {
          let k = (A - L) / N,
            Y = m.config.easing,
            se = Yh(Y, k, f);
          for (let te = 0, { length: M } = i; te < M; te++) {
            let I = i[te],
              P = Ka(c, I, m.config),
              Q = (Ka(c, I, x.config) - P) * se + P;
            X[I] = Q;
          }
        }
        return (0, Tr.merge)(e, { position: A, current: X });
      },
      SF = (e, t) => {
        let {
            active: r,
            origin: n,
            start: o,
            immediate: i,
            renderType: a,
            verbose: s,
            actionItem: c,
            destination: f,
            destinationKeys: E,
            pluginDuration: v,
            instanceDelay: h,
            customEasingFn: y,
            skipMotion: R,
          } = e,
          S = c.config.easing,
          { duration: C, delay: A } = c.config;
        v != null && (C = v),
          (A = h ?? A),
          a === mF ? (C = 0) : (i || R) && (C = A = 0);
        let { now: w } = t.payload;
        if (r && n) {
          let m = w - (o + A);
          if (s) {
            let k = w - o,
              Y = C + A,
              se = pi(Math.min(Math.max(0, k / Y), 1));
            e = (0, Tr.set)(e, "verboseTimeElapsed", Y * se);
          }
          if (m < 0) return e;
          let x = pi(Math.min(Math.max(0, m / C), 1)),
            L = Yh(S, x, y),
            N = {},
            X = null;
          return (
            E.length &&
              (X = E.reduce((k, Y) => {
                let se = f[Y],
                  te = parseFloat(n[Y]) || 0,
                  I = (parseFloat(se) - te) * L + te;
                return (k[Y] = I), k;
              }, {})),
            (N.current = X),
            (N.position = x),
            x === 1 && ((N.active = !1), (N.complete = !0)),
            (0, Tr.merge)(e, N)
          );
        }
        return e;
      },
      AF = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case vF:
            return t.payload.ixInstances || Object.freeze({});
          case EF:
            return Object.freeze({});
          case hF: {
            let {
                instanceId: r,
                elementId: n,
                actionItem: o,
                eventId: i,
                eventTarget: a,
                eventStateKey: s,
                actionListId: c,
                groupIndex: f,
                isCarrier: E,
                origin: v,
                destination: h,
                immediate: y,
                verbose: R,
                continuous: S,
                parameterId: C,
                actionGroups: A,
                smoothing: w,
                restingValue: m,
                pluginInstance: x,
                pluginDuration: L,
                instanceDelay: N,
                skipMotion: X,
                skipToValue: k,
              } = t.payload,
              { actionTypeId: Y } = o,
              se = TF(Y),
              te = OF(se, Y),
              M = Object.keys(h).filter((P) => h[P] != null),
              { easing: I } = o.config;
            return (0, Tr.set)(e, r, {
              id: r,
              elementId: n,
              active: !1,
              position: 0,
              start: 0,
              origin: v,
              destination: h,
              destinationKeys: M,
              immediate: y,
              verbose: R,
              current: null,
              actionItem: o,
              actionTypeId: Y,
              eventId: i,
              eventTarget: a,
              eventStateKey: s,
              actionListId: c,
              groupIndex: f,
              renderType: se,
              isCarrier: E,
              styleProp: te,
              continuous: S,
              parameterId: C,
              actionGroups: A,
              smoothing: w,
              restingValue: m,
              pluginInstance: x,
              pluginDuration: L,
              instanceDelay: N,
              skipMotion: X,
              skipToValue: k,
              customEasingFn:
                Array.isArray(I) && I.length === 4 ? IF(I) : void 0,
            });
          }
          case gF: {
            let { instanceId: r, time: n } = t.payload;
            return (0, Tr.mergeIn)(e, [r], {
              active: !0,
              complete: !1,
              start: n,
            });
          }
          case _F: {
            let { instanceId: r } = t.payload;
            if (!e[r]) return e;
            let n = {},
              o = Object.keys(e),
              { length: i } = o;
            for (let a = 0; a < i; a++) {
              let s = o[a];
              s !== r && (n[s] = e[s]);
            }
            return n;
          }
          case yF: {
            let r = e,
              n = Object.keys(e),
              { length: o } = n;
            for (let i = 0; i < o; i++) {
              let a = n[i],
                s = e[a],
                c = s.continuous ? bF : SF;
              r = (0, Tr.set)(r, a, c(s, t));
            }
            return r;
          }
          default:
            return e;
        }
      };
    vi.ixInstances = AF;
  });
  var $h = u((Ei) => {
    "use strict";
    Object.defineProperty(Ei, "__esModule", { value: !0 });
    Ei.ixParameters = void 0;
    var wF = We(),
      {
        IX2_RAW_DATA_IMPORTED: RF,
        IX2_SESSION_STOPPED: CF,
        IX2_PARAMETER_CHANGED: NF,
      } = wF.IX2EngineActionTypes,
      qF = (e = {}, t) => {
        switch (t.type) {
          case RF:
            return t.payload.ixParameters || {};
          case CF:
            return {};
          case NF: {
            let { key: r, value: n } = t.payload;
            return (e[r] = n), e;
          }
          default:
            return e;
        }
      };
    Ei.ixParameters = qF;
  });
  var Zh = u((hi) => {
    "use strict";
    Object.defineProperty(hi, "__esModule", { value: !0 });
    hi.default = void 0;
    var PF = Yo(),
      LF = Ef(),
      xF = xf(),
      MF = Df(),
      DF = Ht(),
      FF = Qh(),
      GF = $h(),
      { ixElements: XF } = DF.IX2ElementsReducer,
      UF = (0, PF.combineReducers)({
        ixData: LF.ixData,
        ixRequest: xF.ixRequest,
        ixSession: MF.ixSession,
        ixElements: XF,
        ixInstances: FF.ixInstances,
        ixParameters: GF.ixParameters,
      });
    hi.default = UF;
  });
  var Jh = u((ck, tn) => {
    function VF(e, t) {
      if (e == null) return {};
      var r = {},
        n = Object.keys(e),
        o,
        i;
      for (i = 0; i < n.length; i++)
        (o = n[i]), !(t.indexOf(o) >= 0) && (r[o] = e[o]);
      return r;
    }
    (tn.exports = VF),
      (tn.exports.__esModule = !0),
      (tn.exports.default = tn.exports);
  });
  var tg = u((lk, eg) => {
    var WF = St(),
      BF = qe(),
      HF = _t(),
      jF = "[object String]";
    function kF(e) {
      return typeof e == "string" || (!BF(e) && HF(e) && WF(e) == jF);
    }
    eg.exports = kF;
  });
  var ng = u((fk, rg) => {
    var KF = Aa(),
      zF = KF("length");
    rg.exports = zF;
  });
  var og = u((dk, ig) => {
    var YF = "\\ud800-\\udfff",
      QF = "\\u0300-\\u036f",
      $F = "\\ufe20-\\ufe2f",
      ZF = "\\u20d0-\\u20ff",
      JF = QF + $F + ZF,
      e1 = "\\ufe0e\\ufe0f",
      t1 = "\\u200d",
      r1 = RegExp("[" + t1 + YF + JF + e1 + "]");
    function n1(e) {
      return r1.test(e);
    }
    ig.exports = n1;
  });
  var vg = u((pk, pg) => {
    var sg = "\\ud800-\\udfff",
      i1 = "\\u0300-\\u036f",
      o1 = "\\ufe20-\\ufe2f",
      a1 = "\\u20d0-\\u20ff",
      s1 = i1 + o1 + a1,
      u1 = "\\ufe0e\\ufe0f",
      c1 = "[" + sg + "]",
      za = "[" + s1 + "]",
      Ya = "\\ud83c[\\udffb-\\udfff]",
      l1 = "(?:" + za + "|" + Ya + ")",
      ug = "[^" + sg + "]",
      cg = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      lg = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      f1 = "\\u200d",
      fg = l1 + "?",
      dg = "[" + u1 + "]?",
      d1 = "(?:" + f1 + "(?:" + [ug, cg, lg].join("|") + ")" + dg + fg + ")*",
      p1 = dg + fg + d1,
      v1 = "(?:" + [ug + za + "?", za, cg, lg, c1].join("|") + ")",
      ag = RegExp(Ya + "(?=" + Ya + ")|" + v1 + p1, "g");
    function E1(e) {
      for (var t = (ag.lastIndex = 0); ag.test(e); ) ++t;
      return t;
    }
    pg.exports = E1;
  });
  var hg = u((vk, Eg) => {
    var h1 = ng(),
      g1 = og(),
      _1 = vg();
    function y1(e) {
      return g1(e) ? _1(e) : h1(e);
    }
    Eg.exports = y1;
  });
  var _g = u((Ek, gg) => {
    var I1 = kn(),
      m1 = Kn(),
      T1 = Xt(),
      O1 = tg(),
      b1 = hg(),
      S1 = "[object Map]",
      A1 = "[object Set]";
    function w1(e) {
      if (e == null) return 0;
      if (T1(e)) return O1(e) ? b1(e) : e.length;
      var t = m1(e);
      return t == S1 || t == A1 ? e.size : I1(e).length;
    }
    gg.exports = w1;
  });
  var Ig = u((hk, yg) => {
    var R1 = "Expected a function";
    function C1(e) {
      if (typeof e != "function") throw new TypeError(R1);
      return function () {
        var t = arguments;
        switch (t.length) {
          case 0:
            return !e.call(this);
          case 1:
            return !e.call(this, t[0]);
          case 2:
            return !e.call(this, t[0], t[1]);
          case 3:
            return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
      };
    }
    yg.exports = C1;
  });
  var Qa = u((gk, mg) => {
    var N1 = At(),
      q1 = (function () {
        try {
          var e = N1(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch {}
      })();
    mg.exports = q1;
  });
  var $a = u((_k, Og) => {
    var Tg = Qa();
    function P1(e, t, r) {
      t == "__proto__" && Tg
        ? Tg(e, t, { configurable: !0, enumerable: !0, value: r, writable: !0 })
        : (e[t] = r);
    }
    Og.exports = P1;
  });
  var Sg = u((yk, bg) => {
    var L1 = $a(),
      x1 = Dn(),
      M1 = Object.prototype,
      D1 = M1.hasOwnProperty;
    function F1(e, t, r) {
      var n = e[t];
      (!(D1.call(e, t) && x1(n, r)) || (r === void 0 && !(t in e))) &&
        L1(e, t, r);
    }
    bg.exports = F1;
  });
  var Rg = u((Ik, wg) => {
    var G1 = Sg(),
      X1 = kr(),
      U1 = Wn(),
      Ag = lt(),
      V1 = fr();
    function W1(e, t, r, n) {
      if (!Ag(e)) return e;
      t = X1(t, e);
      for (var o = -1, i = t.length, a = i - 1, s = e; s != null && ++o < i; ) {
        var c = V1(t[o]),
          f = r;
        if (c === "__proto__" || c === "constructor" || c === "prototype")
          return e;
        if (o != a) {
          var E = s[c];
          (f = n ? n(E, c, s) : void 0),
            f === void 0 && (f = Ag(E) ? E : U1(t[o + 1]) ? [] : {});
        }
        G1(s, c, f), (s = s[c]);
      }
      return e;
    }
    wg.exports = W1;
  });
  var Ng = u((mk, Cg) => {
    var B1 = Qn(),
      H1 = Rg(),
      j1 = kr();
    function k1(e, t, r) {
      for (var n = -1, o = t.length, i = {}; ++n < o; ) {
        var a = t[n],
          s = B1(e, a);
        r(s, a) && H1(i, j1(a, e), s);
      }
      return i;
    }
    Cg.exports = k1;
  });
  var Pg = u((Tk, qg) => {
    var K1 = Un(),
      z1 = Do(),
      Y1 = fa(),
      Q1 = la(),
      $1 = Object.getOwnPropertySymbols,
      Z1 = $1
        ? function (e) {
            for (var t = []; e; ) K1(t, Y1(e)), (e = z1(e));
            return t;
          }
        : Q1;
    qg.exports = Z1;
  });
  var xg = u((Ok, Lg) => {
    function J1(e) {
      var t = [];
      if (e != null) for (var r in Object(e)) t.push(r);
      return t;
    }
    Lg.exports = J1;
  });
  var Dg = u((bk, Mg) => {
    var e2 = lt(),
      t2 = jn(),
      r2 = xg(),
      n2 = Object.prototype,
      i2 = n2.hasOwnProperty;
    function o2(e) {
      if (!e2(e)) return r2(e);
      var t = t2(e),
        r = [];
      for (var n in e)
        (n == "constructor" && (t || !i2.call(e, n))) || r.push(n);
      return r;
    }
    Mg.exports = o2;
  });
  var Gg = u((Sk, Fg) => {
    var a2 = pa(),
      s2 = Dg(),
      u2 = Xt();
    function c2(e) {
      return u2(e) ? a2(e, !0) : s2(e);
    }
    Fg.exports = c2;
  });
  var Ug = u((Ak, Xg) => {
    var l2 = ca(),
      f2 = Pg(),
      d2 = Gg();
    function p2(e) {
      return l2(e, d2, f2);
    }
    Xg.exports = p2;
  });
  var Wg = u((wk, Vg) => {
    var v2 = Sa(),
      E2 = wt(),
      h2 = Ng(),
      g2 = Ug();
    function _2(e, t) {
      if (e == null) return {};
      var r = v2(g2(e), function (n) {
        return [n];
      });
      return (
        (t = E2(t)),
        h2(e, r, function (n, o) {
          return t(n, o[0]);
        })
      );
    }
    Vg.exports = _2;
  });
  var Hg = u((Rk, Bg) => {
    var y2 = wt(),
      I2 = Ig(),
      m2 = Wg();
    function T2(e, t) {
      return m2(e, I2(y2(t)));
    }
    Bg.exports = T2;
  });
  var kg = u((Ck, jg) => {
    var O2 = kn(),
      b2 = Kn(),
      S2 = Ur(),
      A2 = qe(),
      w2 = Xt(),
      R2 = Vn(),
      C2 = jn(),
      N2 = Hn(),
      q2 = "[object Map]",
      P2 = "[object Set]",
      L2 = Object.prototype,
      x2 = L2.hasOwnProperty;
    function M2(e) {
      if (e == null) return !0;
      if (
        w2(e) &&
        (A2(e) ||
          typeof e == "string" ||
          typeof e.splice == "function" ||
          R2(e) ||
          N2(e) ||
          S2(e))
      )
        return !e.length;
      var t = b2(e);
      if (t == q2 || t == P2) return !e.size;
      if (C2(e)) return !O2(e).length;
      for (var r in e) if (x2.call(e, r)) return !1;
      return !0;
    }
    jg.exports = M2;
  });
  var zg = u((Nk, Kg) => {
    var D2 = $a(),
      F2 = Fa(),
      G2 = wt();
    function X2(e, t) {
      var r = {};
      return (
        (t = G2(t, 3)),
        F2(e, function (n, o, i) {
          D2(r, o, t(n, o, i));
        }),
        r
      );
    }
    Kg.exports = X2;
  });
  var Qg = u((qk, Yg) => {
    function U2(e, t) {
      for (
        var r = -1, n = e == null ? 0 : e.length;
        ++r < n && t(e[r], r, e) !== !1;

      );
      return e;
    }
    Yg.exports = U2;
  });
  var Zg = u((Pk, $g) => {
    var V2 = Zn();
    function W2(e) {
      return typeof e == "function" ? e : V2;
    }
    $g.exports = W2;
  });
  var e_ = u((Lk, Jg) => {
    var B2 = Qg(),
      H2 = Ga(),
      j2 = Zg(),
      k2 = qe();
    function K2(e, t) {
      var r = k2(e) ? B2 : H2;
      return r(e, j2(t));
    }
    Jg.exports = K2;
  });
  var r_ = u((xk, t_) => {
    var z2 = et(),
      Y2 = function () {
        return z2.Date.now();
      };
    t_.exports = Y2;
  });
  var o_ = u((Mk, i_) => {
    var Q2 = lt(),
      Za = r_(),
      n_ = Jn(),
      $2 = "Expected a function",
      Z2 = Math.max,
      J2 = Math.min;
    function eG(e, t, r) {
      var n,
        o,
        i,
        a,
        s,
        c,
        f = 0,
        E = !1,
        v = !1,
        h = !0;
      if (typeof e != "function") throw new TypeError($2);
      (t = n_(t) || 0),
        Q2(r) &&
          ((E = !!r.leading),
          (v = "maxWait" in r),
          (i = v ? Z2(n_(r.maxWait) || 0, t) : i),
          (h = "trailing" in r ? !!r.trailing : h));
      function y(N) {
        var X = n,
          k = o;
        return (n = o = void 0), (f = N), (a = e.apply(k, X)), a;
      }
      function R(N) {
        return (f = N), (s = setTimeout(A, t)), E ? y(N) : a;
      }
      function S(N) {
        var X = N - c,
          k = N - f,
          Y = t - X;
        return v ? J2(Y, i - k) : Y;
      }
      function C(N) {
        var X = N - c,
          k = N - f;
        return c === void 0 || X >= t || X < 0 || (v && k >= i);
      }
      function A() {
        var N = Za();
        if (C(N)) return w(N);
        s = setTimeout(A, S(N));
      }
      function w(N) {
        return (s = void 0), h && n ? y(N) : ((n = o = void 0), a);
      }
      function m() {
        s !== void 0 && clearTimeout(s), (f = 0), (n = c = o = s = void 0);
      }
      function x() {
        return s === void 0 ? a : w(Za());
      }
      function L() {
        var N = Za(),
          X = C(N);
        if (((n = arguments), (o = this), (c = N), X)) {
          if (s === void 0) return R(c);
          if (v) return clearTimeout(s), (s = setTimeout(A, t)), y(c);
        }
        return s === void 0 && (s = setTimeout(A, t)), a;
      }
      return (L.cancel = m), (L.flush = x), L;
    }
    i_.exports = eG;
  });
  var s_ = u((Dk, a_) => {
    var tG = o_(),
      rG = lt(),
      nG = "Expected a function";
    function iG(e, t, r) {
      var n = !0,
        o = !0;
      if (typeof e != "function") throw new TypeError(nG);
      return (
        rG(r) &&
          ((n = "leading" in r ? !!r.leading : n),
          (o = "trailing" in r ? !!r.trailing : o)),
        tG(e, t, { leading: n, maxWait: t, trailing: o })
      );
    }
    a_.exports = iG;
  });
  var gi = u((ae) => {
    "use strict";
    var oG = $e().default;
    Object.defineProperty(ae, "__esModule", { value: !0 });
    ae.viewportWidthChanged =
      ae.testFrameRendered =
      ae.stopRequested =
      ae.sessionStopped =
      ae.sessionStarted =
      ae.sessionInitialized =
      ae.rawDataImported =
      ae.previewRequested =
      ae.playbackRequested =
      ae.parameterChanged =
      ae.mediaQueriesDefined =
      ae.instanceStarted =
      ae.instanceRemoved =
      ae.instanceAdded =
      ae.eventStateChanged =
      ae.eventListenerAdded =
      ae.elementStateChanged =
      ae.clearRequested =
      ae.animationFrameChanged =
      ae.actionListPlaybackChanged =
        void 0;
    var u_ = oG(rr()),
      c_ = We(),
      aG = Ht(),
      {
        IX2_RAW_DATA_IMPORTED: sG,
        IX2_SESSION_INITIALIZED: uG,
        IX2_SESSION_STARTED: cG,
        IX2_SESSION_STOPPED: lG,
        IX2_PREVIEW_REQUESTED: fG,
        IX2_PLAYBACK_REQUESTED: dG,
        IX2_STOP_REQUESTED: pG,
        IX2_CLEAR_REQUESTED: vG,
        IX2_EVENT_LISTENER_ADDED: EG,
        IX2_TEST_FRAME_RENDERED: hG,
        IX2_EVENT_STATE_CHANGED: gG,
        IX2_ANIMATION_FRAME_CHANGED: _G,
        IX2_PARAMETER_CHANGED: yG,
        IX2_INSTANCE_ADDED: IG,
        IX2_INSTANCE_STARTED: mG,
        IX2_INSTANCE_REMOVED: TG,
        IX2_ELEMENT_STATE_CHANGED: OG,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: bG,
        IX2_VIEWPORT_WIDTH_CHANGED: SG,
        IX2_MEDIA_QUERIES_DEFINED: AG,
      } = c_.IX2EngineActionTypes,
      { reifyState: wG } = aG.IX2VanillaUtils,
      RG = (e) => ({ type: sG, payload: (0, u_.default)({}, wG(e)) });
    ae.rawDataImported = RG;
    var CG = ({ hasBoundaryNodes: e, reducedMotion: t }) => ({
      type: uG,
      payload: { hasBoundaryNodes: e, reducedMotion: t },
    });
    ae.sessionInitialized = CG;
    var NG = () => ({ type: cG });
    ae.sessionStarted = NG;
    var qG = () => ({ type: lG });
    ae.sessionStopped = qG;
    var PG = ({ rawData: e, defer: t }) => ({
      type: fG,
      payload: { defer: t, rawData: e },
    });
    ae.previewRequested = PG;
    var LG = ({
      actionTypeId: e = c_.ActionTypeConsts.GENERAL_START_ACTION,
      actionListId: t,
      actionItemId: r,
      eventId: n,
      allowEvents: o,
      immediate: i,
      testManual: a,
      verbose: s,
      rawData: c,
    }) => ({
      type: dG,
      payload: {
        actionTypeId: e,
        actionListId: t,
        actionItemId: r,
        testManual: a,
        eventId: n,
        allowEvents: o,
        immediate: i,
        verbose: s,
        rawData: c,
      },
    });
    ae.playbackRequested = LG;
    var xG = (e) => ({ type: pG, payload: { actionListId: e } });
    ae.stopRequested = xG;
    var MG = () => ({ type: vG });
    ae.clearRequested = MG;
    var DG = (e, t) => ({
      type: EG,
      payload: { target: e, listenerParams: t },
    });
    ae.eventListenerAdded = DG;
    var FG = (e = 1) => ({ type: hG, payload: { step: e } });
    ae.testFrameRendered = FG;
    var GG = (e, t) => ({ type: gG, payload: { stateKey: e, newState: t } });
    ae.eventStateChanged = GG;
    var XG = (e, t) => ({ type: _G, payload: { now: e, parameters: t } });
    ae.animationFrameChanged = XG;
    var UG = (e, t) => ({ type: yG, payload: { key: e, value: t } });
    ae.parameterChanged = UG;
    var VG = (e) => ({ type: IG, payload: (0, u_.default)({}, e) });
    ae.instanceAdded = VG;
    var WG = (e, t) => ({ type: mG, payload: { instanceId: e, time: t } });
    ae.instanceStarted = WG;
    var BG = (e) => ({ type: TG, payload: { instanceId: e } });
    ae.instanceRemoved = BG;
    var HG = (e, t, r, n) => ({
      type: OG,
      payload: { elementId: e, actionTypeId: t, current: r, actionItem: n },
    });
    ae.elementStateChanged = HG;
    var jG = ({ actionListId: e, isPlaying: t }) => ({
      type: bG,
      payload: { actionListId: e, isPlaying: t },
    });
    ae.actionListPlaybackChanged = jG;
    var kG = ({ width: e, mediaQueries: t }) => ({
      type: SG,
      payload: { width: e, mediaQueries: t },
    });
    ae.viewportWidthChanged = kG;
    var KG = () => ({ type: AG });
    ae.mediaQueriesDefined = KG;
  });
  var d_ = u((xe) => {
    "use strict";
    Object.defineProperty(xe, "__esModule", { value: !0 });
    xe.elementContains = oX;
    xe.getChildElements = sX;
    xe.getClosestElement = void 0;
    xe.getProperty = eX;
    xe.getQuerySelector = rX;
    xe.getRefType = lX;
    xe.getSiblingElements = uX;
    xe.getStyle = JG;
    xe.getValidDocument = nX;
    xe.isSiblingNode = aX;
    xe.matchSelector = tX;
    xe.queryDocument = iX;
    xe.setStyle = ZG;
    var zG = Ht(),
      YG = We(),
      { ELEMENT_MATCHES: Ja } = zG.IX2BrowserSupport,
      {
        IX2_ID_DELIMITER: l_,
        HTML_ELEMENT: QG,
        PLAIN_OBJECT: $G,
        WF_PAGE: f_,
      } = YG.IX2EngineConstants;
    function ZG(e, t, r) {
      e.style[t] = r;
    }
    function JG(e, t) {
      return e.style[t];
    }
    function eX(e, t) {
      return e[t];
    }
    function tX(e) {
      return (t) => t[Ja](e);
    }
    function rX({ id: e, selector: t }) {
      if (e) {
        let r = e;
        if (e.indexOf(l_) !== -1) {
          let n = e.split(l_),
            o = n[0];
          if (((r = n[1]), o !== document.documentElement.getAttribute(f_)))
            return null;
        }
        return `[data-w-id="${r}"], [data-w-id^="${r}_instance"]`;
      }
      return t;
    }
    function nX(e) {
      return e == null || e === document.documentElement.getAttribute(f_)
        ? document
        : null;
    }
    function iX(e, t) {
      return Array.prototype.slice.call(
        document.querySelectorAll(t ? e + " " + t : e)
      );
    }
    function oX(e, t) {
      return e.contains(t);
    }
    function aX(e, t) {
      return e !== t && e.parentNode === t.parentNode;
    }
    function sX(e) {
      let t = [];
      for (let r = 0, { length: n } = e || []; r < n; r++) {
        let { children: o } = e[r],
          { length: i } = o;
        if (i) for (let a = 0; a < i; a++) t.push(o[a]);
      }
      return t;
    }
    function uX(e = []) {
      let t = [],
        r = [];
      for (let n = 0, { length: o } = e; n < o; n++) {
        let { parentNode: i } = e[n];
        if (!i || !i.children || !i.children.length || r.indexOf(i) !== -1)
          continue;
        r.push(i);
        let a = i.firstElementChild;
        for (; a != null; )
          e.indexOf(a) === -1 && t.push(a), (a = a.nextElementSibling);
      }
      return t;
    }
    var cX = Element.prototype.closest
      ? (e, t) => (document.documentElement.contains(e) ? e.closest(t) : null)
      : (e, t) => {
          if (!document.documentElement.contains(e)) return null;
          let r = e;
          do {
            if (r[Ja] && r[Ja](t)) return r;
            r = r.parentNode;
          } while (r != null);
          return null;
        };
    xe.getClosestElement = cX;
    function lX(e) {
      return e != null && typeof e == "object"
        ? e instanceof Element
          ? QG
          : $G
        : null;
    }
  });
  var es = u((Xk, v_) => {
    var fX = lt(),
      p_ = Object.create,
      dX = (function () {
        function e() {}
        return function (t) {
          if (!fX(t)) return {};
          if (p_) return p_(t);
          e.prototype = t;
          var r = new e();
          return (e.prototype = void 0), r;
        };
      })();
    v_.exports = dX;
  });
  var _i = u((Uk, E_) => {
    function pX() {}
    E_.exports = pX;
  });
  var Ii = u((Vk, h_) => {
    var vX = es(),
      EX = _i();
    function yi(e, t) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__chain__ = !!t),
        (this.__index__ = 0),
        (this.__values__ = void 0);
    }
    yi.prototype = vX(EX.prototype);
    yi.prototype.constructor = yi;
    h_.exports = yi;
  });
  var I_ = u((Wk, y_) => {
    var g_ = Zt(),
      hX = Ur(),
      gX = qe(),
      __ = g_ ? g_.isConcatSpreadable : void 0;
    function _X(e) {
      return gX(e) || hX(e) || !!(__ && e && e[__]);
    }
    y_.exports = _X;
  });
  var O_ = u((Bk, T_) => {
    var yX = Un(),
      IX = I_();
    function m_(e, t, r, n, o) {
      var i = -1,
        a = e.length;
      for (r || (r = IX), o || (o = []); ++i < a; ) {
        var s = e[i];
        t > 0 && r(s)
          ? t > 1
            ? m_(s, t - 1, r, n, o)
            : yX(o, s)
          : n || (o[o.length] = s);
      }
      return o;
    }
    T_.exports = m_;
  });
  var S_ = u((Hk, b_) => {
    var mX = O_();
    function TX(e) {
      var t = e == null ? 0 : e.length;
      return t ? mX(e, 1) : [];
    }
    b_.exports = TX;
  });
  var w_ = u((jk, A_) => {
    function OX(e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, r[0]);
        case 2:
          return e.call(t, r[0], r[1]);
        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }
      return e.apply(t, r);
    }
    A_.exports = OX;
  });
  var N_ = u((kk, C_) => {
    var bX = w_(),
      R_ = Math.max;
    function SX(e, t, r) {
      return (
        (t = R_(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (
            var n = arguments, o = -1, i = R_(n.length - t, 0), a = Array(i);
            ++o < i;

          )
            a[o] = n[t + o];
          o = -1;
          for (var s = Array(t + 1); ++o < t; ) s[o] = n[o];
          return (s[t] = r(a)), bX(e, this, s);
        }
      );
    }
    C_.exports = SX;
  });
  var P_ = u((Kk, q_) => {
    function AX(e) {
      return function () {
        return e;
      };
    }
    q_.exports = AX;
  });
  var M_ = u((zk, x_) => {
    var wX = P_(),
      L_ = Qa(),
      RX = Zn(),
      CX = L_
        ? function (e, t) {
            return L_(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: wX(t),
              writable: !0,
            });
          }
        : RX;
    x_.exports = CX;
  });
  var F_ = u((Yk, D_) => {
    var NX = 800,
      qX = 16,
      PX = Date.now;
    function LX(e) {
      var t = 0,
        r = 0;
      return function () {
        var n = PX(),
          o = qX - (n - r);
        if (((r = n), o > 0)) {
          if (++t >= NX) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    D_.exports = LX;
  });
  var X_ = u((Qk, G_) => {
    var xX = M_(),
      MX = F_(),
      DX = MX(xX);
    G_.exports = DX;
  });
  var V_ = u(($k, U_) => {
    var FX = S_(),
      GX = N_(),
      XX = X_();
    function UX(e) {
      return XX(GX(e, void 0, FX), e + "");
    }
    U_.exports = UX;
  });
  var H_ = u((Zk, B_) => {
    var W_ = va(),
      VX = W_ && new W_();
    B_.exports = VX;
  });
  var k_ = u((Jk, j_) => {
    function WX() {}
    j_.exports = WX;
  });
  var ts = u((eK, z_) => {
    var K_ = H_(),
      BX = k_(),
      HX = K_
        ? function (e) {
            return K_.get(e);
          }
        : BX;
    z_.exports = HX;
  });
  var Q_ = u((tK, Y_) => {
    var jX = {};
    Y_.exports = jX;
  });
  var rs = u((rK, Z_) => {
    var $_ = Q_(),
      kX = Object.prototype,
      KX = kX.hasOwnProperty;
    function zX(e) {
      for (
        var t = e.name + "", r = $_[t], n = KX.call($_, t) ? r.length : 0;
        n--;

      ) {
        var o = r[n],
          i = o.func;
        if (i == null || i == e) return o.name;
      }
      return t;
    }
    Z_.exports = zX;
  });
  var Ti = u((nK, J_) => {
    var YX = es(),
      QX = _i(),
      $X = 4294967295;
    function mi(e) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__dir__ = 1),
        (this.__filtered__ = !1),
        (this.__iteratees__ = []),
        (this.__takeCount__ = $X),
        (this.__views__ = []);
    }
    mi.prototype = YX(QX.prototype);
    mi.prototype.constructor = mi;
    J_.exports = mi;
  });
  var ty = u((iK, ey) => {
    function ZX(e, t) {
      var r = -1,
        n = e.length;
      for (t || (t = Array(n)); ++r < n; ) t[r] = e[r];
      return t;
    }
    ey.exports = ZX;
  });
  var ny = u((oK, ry) => {
    var JX = Ti(),
      eU = Ii(),
      tU = ty();
    function rU(e) {
      if (e instanceof JX) return e.clone();
      var t = new eU(e.__wrapped__, e.__chain__);
      return (
        (t.__actions__ = tU(e.__actions__)),
        (t.__index__ = e.__index__),
        (t.__values__ = e.__values__),
        t
      );
    }
    ry.exports = rU;
  });
  var ay = u((aK, oy) => {
    var nU = Ti(),
      iy = Ii(),
      iU = _i(),
      oU = qe(),
      aU = _t(),
      sU = ny(),
      uU = Object.prototype,
      cU = uU.hasOwnProperty;
    function Oi(e) {
      if (aU(e) && !oU(e) && !(e instanceof nU)) {
        if (e instanceof iy) return e;
        if (cU.call(e, "__wrapped__")) return sU(e);
      }
      return new iy(e);
    }
    Oi.prototype = iU.prototype;
    Oi.prototype.constructor = Oi;
    oy.exports = Oi;
  });
  var uy = u((sK, sy) => {
    var lU = Ti(),
      fU = ts(),
      dU = rs(),
      pU = ay();
    function vU(e) {
      var t = dU(e),
        r = pU[t];
      if (typeof r != "function" || !(t in lU.prototype)) return !1;
      if (e === r) return !0;
      var n = fU(r);
      return !!n && e === n[0];
    }
    sy.exports = vU;
  });
  var dy = u((uK, fy) => {
    var cy = Ii(),
      EU = V_(),
      hU = ts(),
      ns = rs(),
      gU = qe(),
      ly = uy(),
      _U = "Expected a function",
      yU = 8,
      IU = 32,
      mU = 128,
      TU = 256;
    function OU(e) {
      return EU(function (t) {
        var r = t.length,
          n = r,
          o = cy.prototype.thru;
        for (e && t.reverse(); n--; ) {
          var i = t[n];
          if (typeof i != "function") throw new TypeError(_U);
          if (o && !a && ns(i) == "wrapper") var a = new cy([], !0);
        }
        for (n = a ? n : r; ++n < r; ) {
          i = t[n];
          var s = ns(i),
            c = s == "wrapper" ? hU(i) : void 0;
          c &&
          ly(c[0]) &&
          c[1] == (mU | yU | IU | TU) &&
          !c[4].length &&
          c[9] == 1
            ? (a = a[ns(c[0])].apply(a, c[3]))
            : (a = i.length == 1 && ly(i) ? a[s]() : a.thru(i));
        }
        return function () {
          var f = arguments,
            E = f[0];
          if (a && f.length == 1 && gU(E)) return a.plant(E).value();
          for (var v = 0, h = r ? t[v].apply(this, f) : E; ++v < r; )
            h = t[v].call(this, h);
          return h;
        };
      });
    }
    fy.exports = OU;
  });
  var vy = u((cK, py) => {
    var bU = dy(),
      SU = bU();
    py.exports = SU;
  });
  var hy = u((lK, Ey) => {
    function AU(e, t, r) {
      return (
        e === e &&
          (r !== void 0 && (e = e <= r ? e : r),
          t !== void 0 && (e = e >= t ? e : t)),
        e
      );
    }
    Ey.exports = AU;
  });
  var _y = u((fK, gy) => {
    var wU = hy(),
      is = Jn();
    function RU(e, t, r) {
      return (
        r === void 0 && ((r = t), (t = void 0)),
        r !== void 0 && ((r = is(r)), (r = r === r ? r : 0)),
        t !== void 0 && ((t = is(t)), (t = t === t ? t : 0)),
        wU(is(e), t, r)
      );
    }
    gy.exports = RU;
  });
  var Dy = u((Ri) => {
    "use strict";
    var wi = $e().default;
    Object.defineProperty(Ri, "__esModule", { value: !0 });
    Ri.default = void 0;
    var ke = wi(rr()),
      CU = wi(vy()),
      NU = wi($n()),
      qU = wi(_y()),
      jt = We(),
      os = cs(),
      bi = gi(),
      PU = Ht(),
      {
        MOUSE_CLICK: LU,
        MOUSE_SECOND_CLICK: xU,
        MOUSE_DOWN: MU,
        MOUSE_UP: DU,
        MOUSE_OVER: FU,
        MOUSE_OUT: GU,
        DROPDOWN_CLOSE: XU,
        DROPDOWN_OPEN: UU,
        SLIDER_ACTIVE: VU,
        SLIDER_INACTIVE: WU,
        TAB_ACTIVE: BU,
        TAB_INACTIVE: HU,
        NAVBAR_CLOSE: jU,
        NAVBAR_OPEN: kU,
        MOUSE_MOVE: KU,
        PAGE_SCROLL_DOWN: wy,
        SCROLL_INTO_VIEW: Ry,
        SCROLL_OUT_OF_VIEW: zU,
        PAGE_SCROLL_UP: YU,
        SCROLLING_IN_VIEW: QU,
        PAGE_FINISH: Cy,
        ECOMMERCE_CART_CLOSE: $U,
        ECOMMERCE_CART_OPEN: ZU,
        PAGE_START: Ny,
        PAGE_SCROLL: JU,
      } = jt.EventTypeConsts,
      as = "COMPONENT_ACTIVE",
      qy = "COMPONENT_INACTIVE",
      { COLON_DELIMITER: yy } = jt.IX2EngineConstants,
      { getNamespacedParameterId: Iy } = PU.IX2VanillaUtils,
      Py = (e) => (t) => typeof t == "object" && e(t) ? !0 : t,
      nn = Py(({ element: e, nativeEvent: t }) => e === t.target),
      eV = Py(({ element: e, nativeEvent: t }) => e.contains(t.target)),
      vt = (0, CU.default)([nn, eV]),
      Ly = (e, t) => {
        if (t) {
          let { ixData: r } = e.getState(),
            { events: n } = r,
            o = n[t];
          if (o && !rV[o.eventTypeId]) return o;
        }
        return null;
      },
      tV = ({ store: e, event: t }) => {
        let { action: r } = t,
          { autoStopEventId: n } = r.config;
        return !!Ly(e, n);
      },
      He = ({ store: e, event: t, element: r, eventStateKey: n }, o) => {
        let { action: i, id: a } = t,
          { actionListId: s, autoStopEventId: c } = i.config,
          f = Ly(e, c);
        return (
          f &&
            (0, os.stopActionGroup)({
              store: e,
              eventId: c,
              eventTarget: r,
              eventStateKey: c + yy + n.split(yy)[1],
              actionListId: (0, NU.default)(f, "action.config.actionListId"),
            }),
          (0, os.stopActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          (0, os.startActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          o
        );
      },
      tt = (e, t) => (r, n) => e(r, n) === !0 ? t(r, n) : n,
      on = { handler: tt(vt, He) },
      xy = (0, ke.default)({}, on, { types: [as, qy].join(" ") }),
      ss = [
        { target: window, types: "resize orientationchange", throttle: !0 },
        {
          target: document,
          types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
          throttle: !0,
        },
      ],
      my = "mouseover mouseout",
      us = { types: ss },
      rV = { PAGE_START: Ny, PAGE_FINISH: Cy },
      rn = (() => {
        let e = window.pageXOffset !== void 0,
          r =
            document.compatMode === "CSS1Compat"
              ? document.documentElement
              : document.body;
        return () => ({
          scrollLeft: e ? window.pageXOffset : r.scrollLeft,
          scrollTop: e ? window.pageYOffset : r.scrollTop,
          stiffScrollTop: (0, qU.default)(
            e ? window.pageYOffset : r.scrollTop,
            0,
            r.scrollHeight - window.innerHeight
          ),
          scrollWidth: r.scrollWidth,
          scrollHeight: r.scrollHeight,
          clientWidth: r.clientWidth,
          clientHeight: r.clientHeight,
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        });
      })(),
      nV = (e, t) =>
        !(
          e.left > t.right ||
          e.right < t.left ||
          e.top > t.bottom ||
          e.bottom < t.top
        ),
      iV = ({ element: e, nativeEvent: t }) => {
        let { type: r, target: n, relatedTarget: o } = t,
          i = e.contains(n);
        if (r === "mouseover" && i) return !0;
        let a = e.contains(o);
        return !!(r === "mouseout" && i && a);
      },
      oV = (e) => {
        let {
            element: t,
            event: { config: r },
          } = e,
          { clientWidth: n, clientHeight: o } = rn(),
          i = r.scrollOffsetValue,
          c = r.scrollOffsetUnit === "PX" ? i : (o * (i || 0)) / 100;
        return nV(t.getBoundingClientRect(), {
          left: 0,
          top: c,
          right: n,
          bottom: o - c,
        });
      },
      My = (e) => (t, r) => {
        let { type: n } = t.nativeEvent,
          o = [as, qy].indexOf(n) !== -1 ? n === as : r.isActive,
          i = (0, ke.default)({}, r, { isActive: o });
        return ((!r || i.isActive !== r.isActive) && e(t, i)) || i;
      },
      Ty = (e) => (t, r) => {
        let n = { elementHovered: iV(t) };
        return (
          ((r ? n.elementHovered !== r.elementHovered : n.elementHovered) &&
            e(t, n)) ||
          n
        );
      },
      aV = (e) => (t, r) => {
        let n = (0, ke.default)({}, r, { elementVisible: oV(t) });
        return (
          ((r ? n.elementVisible !== r.elementVisible : n.elementVisible) &&
            e(t, n)) ||
          n
        );
      },
      Oy =
        (e) =>
        (t, r = {}) => {
          let { stiffScrollTop: n, scrollHeight: o, innerHeight: i } = rn(),
            {
              event: { config: a, eventTypeId: s },
            } = t,
            { scrollOffsetValue: c, scrollOffsetUnit: f } = a,
            E = f === "PX",
            v = o - i,
            h = Number((n / v).toFixed(2));
          if (r && r.percentTop === h) return r;
          let y = (E ? c : (i * (c || 0)) / 100) / v,
            R,
            S,
            C = 0;
          r &&
            ((R = h > r.percentTop),
            (S = r.scrollingDown !== R),
            (C = S ? h : r.anchorTop));
          let A = s === wy ? h >= C + y : h <= C - y,
            w = (0, ke.default)({}, r, {
              percentTop: h,
              inBounds: A,
              anchorTop: C,
              scrollingDown: R,
            });
          return (r && A && (S || w.inBounds !== r.inBounds) && e(t, w)) || w;
        },
      sV = (e, t) =>
        e.left > t.left &&
        e.left < t.right &&
        e.top > t.top &&
        e.top < t.bottom,
      uV = (e) => (t, r) => {
        let n = { finished: document.readyState === "complete" };
        return n.finished && !(r && r.finshed) && e(t), n;
      },
      cV = (e) => (t, r) => {
        let n = { started: !0 };
        return r || e(t), n;
      },
      by =
        (e) =>
        (t, r = { clickCount: 0 }) => {
          let n = { clickCount: (r.clickCount % 2) + 1 };
          return (n.clickCount !== r.clickCount && e(t, n)) || n;
        },
      Si = (e = !0) =>
        (0, ke.default)({}, xy, {
          handler: tt(
            e ? vt : nn,
            My((t, r) => (r.isActive ? on.handler(t, r) : r))
          ),
        }),
      Ai = (e = !0) =>
        (0, ke.default)({}, xy, {
          handler: tt(
            e ? vt : nn,
            My((t, r) => (r.isActive ? r : on.handler(t, r)))
          ),
        }),
      Sy = (0, ke.default)({}, us, {
        handler: aV((e, t) => {
          let { elementVisible: r } = t,
            { event: n, store: o } = e,
            { ixData: i } = o.getState(),
            { events: a } = i;
          return !a[n.action.config.autoStopEventId] && t.triggered
            ? t
            : (n.eventTypeId === Ry) === r
            ? (He(e), (0, ke.default)({}, t, { triggered: !0 }))
            : t;
        }),
      }),
      Ay = 0.05,
      lV = {
        [VU]: Si(),
        [WU]: Ai(),
        [UU]: Si(),
        [XU]: Ai(),
        [kU]: Si(!1),
        [jU]: Ai(!1),
        [BU]: Si(),
        [HU]: Ai(),
        [ZU]: { types: "ecommerce-cart-open", handler: tt(vt, He) },
        [$U]: { types: "ecommerce-cart-close", handler: tt(vt, He) },
        [LU]: {
          types: "click",
          handler: tt(
            vt,
            by((e, { clickCount: t }) => {
              tV(e) ? t === 1 && He(e) : He(e);
            })
          ),
        },
        [xU]: {
          types: "click",
          handler: tt(
            vt,
            by((e, { clickCount: t }) => {
              t === 2 && He(e);
            })
          ),
        },
        [MU]: (0, ke.default)({}, on, { types: "mousedown" }),
        [DU]: (0, ke.default)({}, on, { types: "mouseup" }),
        [FU]: {
          types: my,
          handler: tt(
            vt,
            Ty((e, t) => {
              t.elementHovered && He(e);
            })
          ),
        },
        [GU]: {
          types: my,
          handler: tt(
            vt,
            Ty((e, t) => {
              t.elementHovered || He(e);
            })
          ),
        },
        [KU]: {
          types: "mousemove mouseout scroll",
          handler: (
            {
              store: e,
              element: t,
              eventConfig: r,
              nativeEvent: n,
              eventStateKey: o,
            },
            i = { clientX: 0, clientY: 0, pageX: 0, pageY: 0 }
          ) => {
            let {
                basedOn: a,
                selectedAxis: s,
                continuousParameterGroupId: c,
                reverse: f,
                restingState: E = 0,
              } = r,
              {
                clientX: v = i.clientX,
                clientY: h = i.clientY,
                pageX: y = i.pageX,
                pageY: R = i.pageY,
              } = n,
              S = s === "X_AXIS",
              C = n.type === "mouseout",
              A = E / 100,
              w = c,
              m = !1;
            switch (a) {
              case jt.EventBasedOn.VIEWPORT: {
                A = S
                  ? Math.min(v, window.innerWidth) / window.innerWidth
                  : Math.min(h, window.innerHeight) / window.innerHeight;
                break;
              }
              case jt.EventBasedOn.PAGE: {
                let {
                  scrollLeft: x,
                  scrollTop: L,
                  scrollWidth: N,
                  scrollHeight: X,
                } = rn();
                A = S ? Math.min(x + y, N) / N : Math.min(L + R, X) / X;
                break;
              }
              case jt.EventBasedOn.ELEMENT:
              default: {
                w = Iy(o, c);
                let x = n.type.indexOf("mouse") === 0;
                if (x && vt({ element: t, nativeEvent: n }) !== !0) break;
                let L = t.getBoundingClientRect(),
                  { left: N, top: X, width: k, height: Y } = L;
                if (!x && !sV({ left: v, top: h }, L)) break;
                (m = !0), (A = S ? (v - N) / k : (h - X) / Y);
                break;
              }
            }
            return (
              C && (A > 1 - Ay || A < Ay) && (A = Math.round(A)),
              (a !== jt.EventBasedOn.ELEMENT || m || m !== i.elementHovered) &&
                ((A = f ? 1 - A : A),
                e.dispatch((0, bi.parameterChanged)(w, A))),
              { elementHovered: m, clientX: v, clientY: h, pageX: y, pageY: R }
            );
          },
        },
        [JU]: {
          types: ss,
          handler: ({ store: e, eventConfig: t }) => {
            let { continuousParameterGroupId: r, reverse: n } = t,
              { scrollTop: o, scrollHeight: i, clientHeight: a } = rn(),
              s = o / (i - a);
            (s = n ? 1 - s : s), e.dispatch((0, bi.parameterChanged)(r, s));
          },
        },
        [QU]: {
          types: ss,
          handler: (
            { element: e, store: t, eventConfig: r, eventStateKey: n },
            o = { scrollPercent: 0 }
          ) => {
            let {
                scrollLeft: i,
                scrollTop: a,
                scrollWidth: s,
                scrollHeight: c,
                clientHeight: f,
              } = rn(),
              {
                basedOn: E,
                selectedAxis: v,
                continuousParameterGroupId: h,
                startsEntering: y,
                startsExiting: R,
                addEndOffset: S,
                addStartOffset: C,
                addOffsetValue: A = 0,
                endOffsetValue: w = 0,
              } = r,
              m = v === "X_AXIS";
            if (E === jt.EventBasedOn.VIEWPORT) {
              let x = m ? i / s : a / c;
              return (
                x !== o.scrollPercent &&
                  t.dispatch((0, bi.parameterChanged)(h, x)),
                { scrollPercent: x }
              );
            } else {
              let x = Iy(n, h),
                L = e.getBoundingClientRect(),
                N = (C ? A : 0) / 100,
                X = (S ? w : 0) / 100;
              (N = y ? N : 1 - N), (X = R ? X : 1 - X);
              let k = L.top + Math.min(L.height * N, f),
                se = L.top + L.height * X - k,
                te = Math.min(f + se, c),
                I = Math.min(Math.max(0, f - k), te) / te;
              return (
                I !== o.scrollPercent &&
                  t.dispatch((0, bi.parameterChanged)(x, I)),
                { scrollPercent: I }
              );
            }
          },
        },
        [Ry]: Sy,
        [zU]: Sy,
        [wy]: (0, ke.default)({}, us, {
          handler: Oy((e, t) => {
            t.scrollingDown && He(e);
          }),
        }),
        [YU]: (0, ke.default)({}, us, {
          handler: Oy((e, t) => {
            t.scrollingDown || He(e);
          }),
        }),
        [Cy]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: tt(nn, uV(He)),
        },
        [Ny]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: tt(nn, cV(He)),
        },
      };
    Ri.default = lV;
  });
  var cs = u((qt) => {
    "use strict";
    var nt = $e().default,
      fV = Mt().default;
    Object.defineProperty(qt, "__esModule", { value: !0 });
    qt.observeRequests = VV;
    qt.startActionGroup = Es;
    qt.startEngine = Li;
    qt.stopActionGroup = vs;
    qt.stopAllActionGroups = jy;
    qt.stopEngine = xi;
    var dV = nt(rr()),
      pV = nt(Jh()),
      vV = nt(Na()),
      Nt = nt($n()),
      EV = nt(_g()),
      hV = nt(Hg()),
      gV = nt(kg()),
      _V = nt(zg()),
      an = nt(e_()),
      yV = nt(s_()),
      rt = We(),
      Xy = Ht(),
      be = gi(),
      Re = fV(d_()),
      IV = nt(Dy()),
      mV = ["store", "computedStyle"],
      TV = Object.keys(rt.QuickEffectIds),
      ls = (e) => TV.includes(e),
      {
        COLON_DELIMITER: fs,
        BOUNDARY_SELECTOR: Ci,
        HTML_ELEMENT: Uy,
        RENDER_GENERAL: OV,
        W_MOD_IX: Fy,
      } = rt.IX2EngineConstants,
      {
        getAffectedElements: Ni,
        getElementId: bV,
        getDestinationValues: ds,
        observeStore: kt,
        getInstanceId: SV,
        renderHTMLElement: AV,
        clearAllStyles: Vy,
        getMaxDurationItemIndex: wV,
        getComputedStyle: RV,
        getInstanceOrigin: CV,
        reduceListToGroup: NV,
        shouldNamespaceEventParameter: qV,
        getNamespacedParameterId: PV,
        shouldAllowMediaQuery: qi,
        cleanupHTMLElement: LV,
        clearObjectCache: xV,
        stringifyTarget: MV,
        mediaQueriesEqual: DV,
        shallowEqual: FV,
      } = Xy.IX2VanillaUtils,
      {
        isPluginType: Pi,
        createPluginInstance: ps,
        getPluginDuration: GV,
      } = Xy.IX2VanillaPlugins,
      Gy = navigator.userAgent,
      XV = Gy.match(/iPad/i) || Gy.match(/iPhone/),
      UV = 12;
    function VV(e) {
      kt({ store: e, select: ({ ixRequest: t }) => t.preview, onChange: HV }),
        kt({
          store: e,
          select: ({ ixRequest: t }) => t.playback,
          onChange: jV,
        }),
        kt({ store: e, select: ({ ixRequest: t }) => t.stop, onChange: kV }),
        kt({ store: e, select: ({ ixRequest: t }) => t.clear, onChange: KV });
    }
    function WV(e) {
      kt({
        store: e,
        select: ({ ixSession: t }) => t.mediaQueryKey,
        onChange: () => {
          xi(e),
            Vy({ store: e, elementApi: Re }),
            Li({ store: e, allowEvents: !0 }),
            Wy();
        },
      });
    }
    function BV(e, t) {
      let r = kt({
        store: e,
        select: ({ ixSession: n }) => n.tick,
        onChange: (n) => {
          t(n), r();
        },
      });
    }
    function HV({ rawData: e, defer: t }, r) {
      let n = () => {
        Li({ store: r, rawData: e, allowEvents: !0 }), Wy();
      };
      t ? setTimeout(n, 0) : n();
    }
    function Wy() {
      document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
    }
    function jV(e, t) {
      let {
          actionTypeId: r,
          actionListId: n,
          actionItemId: o,
          eventId: i,
          allowEvents: a,
          immediate: s,
          testManual: c,
          verbose: f = !0,
        } = e,
        { rawData: E } = e;
      if (n && o && E && s) {
        let v = E.actionLists[n];
        v && (E = NV({ actionList: v, actionItemId: o, rawData: E }));
      }
      if (
        (Li({ store: t, rawData: E, allowEvents: a, testManual: c }),
        (n && r === rt.ActionTypeConsts.GENERAL_START_ACTION) || ls(r))
      ) {
        vs({ store: t, actionListId: n }),
          Hy({ store: t, actionListId: n, eventId: i });
        let v = Es({
          store: t,
          eventId: i,
          actionListId: n,
          immediate: s,
          verbose: f,
        });
        f &&
          v &&
          t.dispatch(
            (0, be.actionListPlaybackChanged)({
              actionListId: n,
              isPlaying: !s,
            })
          );
      }
    }
    function kV({ actionListId: e }, t) {
      e ? vs({ store: t, actionListId: e }) : jy({ store: t }), xi(t);
    }
    function KV(e, t) {
      xi(t), Vy({ store: t, elementApi: Re });
    }
    function Li({ store: e, rawData: t, allowEvents: r, testManual: n }) {
      let { ixSession: o } = e.getState();
      t && e.dispatch((0, be.rawDataImported)(t)),
        o.active ||
          (e.dispatch(
            (0, be.sessionInitialized)({
              hasBoundaryNodes: !!document.querySelector(Ci),
              reducedMotion:
                document.body.hasAttribute("data-wf-ix-vacation") &&
                window.matchMedia("(prefers-reduced-motion)").matches,
            })
          ),
          r &&
            (JV(e),
            zV(),
            e.getState().ixSession.hasDefinedMediaQueries && WV(e)),
          e.dispatch((0, be.sessionStarted)()),
          YV(e, n));
    }
    function zV() {
      let { documentElement: e } = document;
      e.className.indexOf(Fy) === -1 && (e.className += ` ${Fy}`);
    }
    function YV(e, t) {
      let r = (n) => {
        let { ixSession: o, ixParameters: i } = e.getState();
        o.active &&
          (e.dispatch((0, be.animationFrameChanged)(n, i)),
          t ? BV(e, r) : requestAnimationFrame(r));
      };
      r(window.performance.now());
    }
    function xi(e) {
      let { ixSession: t } = e.getState();
      if (t.active) {
        let { eventListeners: r } = t;
        r.forEach(QV), xV(), e.dispatch((0, be.sessionStopped)());
      }
    }
    function QV({ target: e, listenerParams: t }) {
      e.removeEventListener.apply(e, t);
    }
    function $V({
      store: e,
      eventStateKey: t,
      eventTarget: r,
      eventId: n,
      eventConfig: o,
      actionListId: i,
      parameterGroup: a,
      smoothing: s,
      restingValue: c,
    }) {
      let { ixData: f, ixSession: E } = e.getState(),
        { events: v } = f,
        h = v[n],
        { eventTypeId: y } = h,
        R = {},
        S = {},
        C = [],
        { continuousActionGroups: A } = a,
        { id: w } = a;
      qV(y, o) && (w = PV(t, w));
      let m = E.hasBoundaryNodes && r ? Re.getClosestElement(r, Ci) : null;
      A.forEach((x) => {
        let { keyframe: L, actionItems: N } = x;
        N.forEach((X) => {
          let { actionTypeId: k } = X,
            { target: Y } = X.config;
          if (!Y) return;
          let se = Y.boundaryMode ? m : null,
            te = MV(Y) + fs + k;
          if (((S[te] = ZV(S[te], L, X)), !R[te])) {
            R[te] = !0;
            let { config: M } = X;
            Ni({
              config: M,
              event: h,
              eventTarget: r,
              elementRoot: se,
              elementApi: Re,
            }).forEach((I) => {
              C.push({ element: I, key: te });
            });
          }
        });
      }),
        C.forEach(({ element: x, key: L }) => {
          let N = S[L],
            X = (0, Nt.default)(N, "[0].actionItems[0]", {}),
            { actionTypeId: k } = X,
            Y = Pi(k) ? ps(k)(x, X) : null,
            se = ds({ element: x, actionItem: X, elementApi: Re }, Y);
          hs({
            store: e,
            element: x,
            eventId: n,
            actionListId: i,
            actionItem: X,
            destination: se,
            continuous: !0,
            parameterId: w,
            actionGroups: N,
            smoothing: s,
            restingValue: c,
            pluginInstance: Y,
          });
        });
    }
    function ZV(e = [], t, r) {
      let n = [...e],
        o;
      return (
        n.some((i, a) => (i.keyframe === t ? ((o = a), !0) : !1)),
        o == null && ((o = n.length), n.push({ keyframe: t, actionItems: [] })),
        n[o].actionItems.push(r),
        n
      );
    }
    function JV(e) {
      let { ixData: t } = e.getState(),
        { eventTypeMap: r } = t;
      By(e),
        (0, an.default)(r, (o, i) => {
          let a = IV.default[i];
          if (!a) {
            console.warn(`IX2 event type not configured: ${i}`);
            return;
          }
          oW({ logic: a, store: e, events: o });
        });
      let { ixSession: n } = e.getState();
      n.eventListeners.length && tW(e);
    }
    var eW = ["resize", "orientationchange"];
    function tW(e) {
      let t = () => {
        By(e);
      };
      eW.forEach((r) => {
        window.addEventListener(r, t),
          e.dispatch((0, be.eventListenerAdded)(window, [r, t]));
      }),
        t();
    }
    function By(e) {
      let { ixSession: t, ixData: r } = e.getState(),
        n = window.innerWidth;
      if (n !== t.viewportWidth) {
        let { mediaQueries: o } = r;
        e.dispatch((0, be.viewportWidthChanged)({ width: n, mediaQueries: o }));
      }
    }
    var rW = (e, t) => (0, hV.default)((0, _V.default)(e, t), gV.default),
      nW = (e, t) => {
        (0, an.default)(e, (r, n) => {
          r.forEach((o, i) => {
            let a = n + fs + i;
            t(o, n, a);
          });
        });
      },
      iW = (e) => {
        let t = { target: e.target, targets: e.targets };
        return Ni({ config: t, elementApi: Re });
      };
    function oW({ logic: e, store: t, events: r }) {
      aW(r);
      let { types: n, handler: o } = e,
        { ixData: i } = t.getState(),
        { actionLists: a } = i,
        s = rW(r, iW);
      if (!(0, EV.default)(s)) return;
      (0, an.default)(s, (v, h) => {
        let y = r[h],
          { action: R, id: S, mediaQueries: C = i.mediaQueryKeys } = y,
          { actionListId: A } = R.config;
        DV(C, i.mediaQueryKeys) || t.dispatch((0, be.mediaQueriesDefined)()),
          R.actionTypeId === rt.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION &&
            (Array.isArray(y.config) ? y.config : [y.config]).forEach((m) => {
              let { continuousParameterGroupId: x } = m,
                L = (0, Nt.default)(a, `${A}.continuousParameterGroups`, []),
                N = (0, vV.default)(L, ({ id: Y }) => Y === x),
                X = (m.smoothing || 0) / 100,
                k = (m.restingState || 0) / 100;
              N &&
                v.forEach((Y, se) => {
                  let te = S + fs + se;
                  $V({
                    store: t,
                    eventStateKey: te,
                    eventTarget: Y,
                    eventId: S,
                    eventConfig: m,
                    actionListId: A,
                    parameterGroup: N,
                    smoothing: X,
                    restingValue: k,
                  });
                });
            }),
          (R.actionTypeId === rt.ActionTypeConsts.GENERAL_START_ACTION ||
            ls(R.actionTypeId)) &&
            Hy({ store: t, actionListId: A, eventId: S });
      });
      let c = (v) => {
          let { ixSession: h } = t.getState();
          nW(s, (y, R, S) => {
            let C = r[R],
              A = h.eventState[S],
              { action: w, mediaQueries: m = i.mediaQueryKeys } = C;
            if (!qi(m, h.mediaQueryKey)) return;
            let x = (L = {}) => {
              let N = o(
                {
                  store: t,
                  element: y,
                  event: C,
                  eventConfig: L,
                  nativeEvent: v,
                  eventStateKey: S,
                },
                A
              );
              FV(N, A) || t.dispatch((0, be.eventStateChanged)(S, N));
            };
            w.actionTypeId === rt.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION
              ? (Array.isArray(C.config) ? C.config : [C.config]).forEach(x)
              : x();
          });
        },
        f = (0, yV.default)(c, UV),
        E = ({ target: v = document, types: h, throttle: y }) => {
          h.split(" ")
            .filter(Boolean)
            .forEach((R) => {
              let S = y ? f : c;
              v.addEventListener(R, S),
                t.dispatch((0, be.eventListenerAdded)(v, [R, S]));
            });
        };
      Array.isArray(n) ? n.forEach(E) : typeof n == "string" && E(e);
    }
    function aW(e) {
      if (!XV) return;
      let t = {},
        r = "";
      for (let n in e) {
        let { eventTypeId: o, target: i } = e[n],
          a = Re.getQuerySelector(i);
        t[a] ||
          ((o === rt.EventTypeConsts.MOUSE_CLICK ||
            o === rt.EventTypeConsts.MOUSE_SECOND_CLICK) &&
            ((t[a] = !0),
            (r += a + "{cursor: pointer;touch-action: manipulation;}")));
      }
      if (r) {
        let n = document.createElement("style");
        (n.textContent = r), document.body.appendChild(n);
      }
    }
    function Hy({ store: e, actionListId: t, eventId: r }) {
      let { ixData: n, ixSession: o } = e.getState(),
        { actionLists: i, events: a } = n,
        s = a[r],
        c = i[t];
      if (c && c.useFirstGroupAsInitialState) {
        let f = (0, Nt.default)(c, "actionItemGroups[0].actionItems", []),
          E = (0, Nt.default)(s, "mediaQueries", n.mediaQueryKeys);
        if (!qi(E, o.mediaQueryKey)) return;
        f.forEach((v) => {
          var h;
          let { config: y, actionTypeId: R } = v,
            S =
              (y == null || (h = y.target) === null || h === void 0
                ? void 0
                : h.useEventTarget) === !0
                ? { target: s.target, targets: s.targets }
                : y,
            C = Ni({ config: S, event: s, elementApi: Re }),
            A = Pi(R);
          C.forEach((w) => {
            let m = A ? ps(R)(w, v) : null;
            hs({
              destination: ds({ element: w, actionItem: v, elementApi: Re }, m),
              immediate: !0,
              store: e,
              element: w,
              eventId: r,
              actionItem: v,
              actionListId: t,
              pluginInstance: m,
            });
          });
        });
      }
    }
    function jy({ store: e }) {
      let { ixInstances: t } = e.getState();
      (0, an.default)(t, (r) => {
        if (!r.continuous) {
          let { actionListId: n, verbose: o } = r;
          gs(r, e),
            o &&
              e.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: n,
                  isPlaying: !1,
                })
              );
        }
      });
    }
    function vs({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: o,
    }) {
      let { ixInstances: i, ixSession: a } = e.getState(),
        s = a.hasBoundaryNodes && r ? Re.getClosestElement(r, Ci) : null;
      (0, an.default)(i, (c) => {
        let f = (0, Nt.default)(c, "actionItem.config.target.boundaryMode"),
          E = n ? c.eventStateKey === n : !0;
        if (c.actionListId === o && c.eventId === t && E) {
          if (s && f && !Re.elementContains(s, c.element)) return;
          gs(c, e),
            c.verbose &&
              e.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: o,
                  isPlaying: !1,
                })
              );
        }
      });
    }
    function Es({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: o,
      groupIndex: i = 0,
      immediate: a,
      verbose: s,
    }) {
      var c;
      let { ixData: f, ixSession: E } = e.getState(),
        { events: v } = f,
        h = v[t] || {},
        { mediaQueries: y = f.mediaQueryKeys } = h,
        R = (0, Nt.default)(f, `actionLists.${o}`, {}),
        { actionItemGroups: S, useFirstGroupAsInitialState: C } = R;
      if (!S || !S.length) return !1;
      i >= S.length && (0, Nt.default)(h, "config.loop") && (i = 0),
        i === 0 && C && i++;
      let w =
          (i === 0 || (i === 1 && C)) &&
          ls((c = h.action) === null || c === void 0 ? void 0 : c.actionTypeId)
            ? h.config.delay
            : void 0,
        m = (0, Nt.default)(S, [i, "actionItems"], []);
      if (!m.length || !qi(y, E.mediaQueryKey)) return !1;
      let x = E.hasBoundaryNodes && r ? Re.getClosestElement(r, Ci) : null,
        L = wV(m),
        N = !1;
      return (
        m.forEach((X, k) => {
          let { config: Y, actionTypeId: se } = X,
            te = Pi(se),
            { target: M } = Y;
          if (!M) return;
          let I = M.boundaryMode ? x : null;
          Ni({
            config: Y,
            event: h,
            eventTarget: r,
            elementRoot: I,
            elementApi: Re,
          }).forEach((D, G) => {
            let Q = te ? ps(se)(D, X) : null,
              re = te ? GV(se)(D, X) : null;
            N = !0;
            let q = L === k && G === 0,
              H = RV({ element: D, actionItem: X }),
              j = ds({ element: D, actionItem: X, elementApi: Re }, Q);
            hs({
              store: e,
              element: D,
              actionItem: X,
              eventId: t,
              eventTarget: r,
              eventStateKey: n,
              actionListId: o,
              groupIndex: i,
              isCarrier: q,
              computedStyle: H,
              destination: j,
              immediate: a,
              verbose: s,
              pluginInstance: Q,
              pluginDuration: re,
              instanceDelay: w,
            });
          });
        }),
        N
      );
    }
    function hs(e) {
      var t;
      let { store: r, computedStyle: n } = e,
        o = (0, pV.default)(e, mV),
        {
          element: i,
          actionItem: a,
          immediate: s,
          pluginInstance: c,
          continuous: f,
          restingValue: E,
          eventId: v,
        } = o,
        h = !f,
        y = SV(),
        { ixElements: R, ixSession: S, ixData: C } = r.getState(),
        A = bV(R, i),
        { refState: w } = R[A] || {},
        m = Re.getRefType(i),
        x = S.reducedMotion && rt.ReducedMotionTypes[a.actionTypeId],
        L;
      if (x && f)
        switch (
          (t = C.events[v]) === null || t === void 0 ? void 0 : t.eventTypeId
        ) {
          case rt.EventTypeConsts.MOUSE_MOVE:
          case rt.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
            L = E;
            break;
          default:
            L = 0.5;
            break;
        }
      let N = CV(i, w, n, a, Re, c);
      if (
        (r.dispatch(
          (0, be.instanceAdded)(
            (0, dV.default)(
              {
                instanceId: y,
                elementId: A,
                origin: N,
                refType: m,
                skipMotion: x,
                skipToValue: L,
              },
              o
            )
          )
        ),
        ky(document.body, "ix2-animation-started", y),
        s)
      ) {
        sW(r, y);
        return;
      }
      kt({ store: r, select: ({ ixInstances: X }) => X[y], onChange: Ky }),
        h && r.dispatch((0, be.instanceStarted)(y, S.tick));
    }
    function gs(e, t) {
      ky(document.body, "ix2-animation-stopping", {
        instanceId: e.id,
        state: t.getState(),
      });
      let { elementId: r, actionItem: n } = e,
        { ixElements: o } = t.getState(),
        { ref: i, refType: a } = o[r] || {};
      a === Uy && LV(i, n, Re), t.dispatch((0, be.instanceRemoved)(e.id));
    }
    function ky(e, t, r) {
      let n = document.createEvent("CustomEvent");
      n.initCustomEvent(t, !0, !0, r), e.dispatchEvent(n);
    }
    function sW(e, t) {
      let { ixParameters: r } = e.getState();
      e.dispatch((0, be.instanceStarted)(t, 0)),
        e.dispatch((0, be.animationFrameChanged)(performance.now(), r));
      let { ixInstances: n } = e.getState();
      Ky(n[t], e);
    }
    function Ky(e, t) {
      let {
          active: r,
          continuous: n,
          complete: o,
          elementId: i,
          actionItem: a,
          actionTypeId: s,
          renderType: c,
          current: f,
          groupIndex: E,
          eventId: v,
          eventTarget: h,
          eventStateKey: y,
          actionListId: R,
          isCarrier: S,
          styleProp: C,
          verbose: A,
          pluginInstance: w,
        } = e,
        { ixData: m, ixSession: x } = t.getState(),
        { events: L } = m,
        N = L[v] || {},
        { mediaQueries: X = m.mediaQueryKeys } = N;
      if (qi(X, x.mediaQueryKey) && (n || r || o)) {
        if (f || (c === OV && o)) {
          t.dispatch((0, be.elementStateChanged)(i, s, f, a));
          let { ixElements: k } = t.getState(),
            { ref: Y, refType: se, refState: te } = k[i] || {},
            M = te && te[s];
          (se === Uy || Pi(s)) && AV(Y, te, M, v, a, C, Re, c, w);
        }
        if (o) {
          if (S) {
            let k = Es({
              store: t,
              eventId: v,
              eventTarget: h,
              eventStateKey: y,
              actionListId: R,
              groupIndex: E + 1,
              verbose: A,
            });
            A &&
              !k &&
              t.dispatch(
                (0, be.actionListPlaybackChanged)({
                  actionListId: R,
                  isPlaying: !1,
                })
              );
          }
          gs(e, t);
        }
      }
    }
  });
  var Yy = u((mt) => {
    "use strict";
    var uW = Mt().default,
      cW = $e().default;
    Object.defineProperty(mt, "__esModule", { value: !0 });
    mt.actions = void 0;
    mt.destroy = zy;
    mt.init = vW;
    mt.setEnv = pW;
    mt.store = void 0;
    Pl();
    var lW = Yo(),
      fW = cW(Zh()),
      _s = cs(),
      dW = uW(gi());
    mt.actions = dW;
    var Mi = (0, lW.createStore)(fW.default);
    mt.store = Mi;
    function pW(e) {
      e() && (0, _s.observeRequests)(Mi);
    }
    function vW(e) {
      zy(), (0, _s.startEngine)({ store: Mi, rawData: e, allowEvents: !0 });
    }
    function zy() {
      (0, _s.stopEngine)(Mi);
    }
  });
  var Jy = u((EK, Zy) => {
    var Qy = at(),
      $y = Yy();
    $y.setEnv(Qy.env);
    Qy.define(
      "ix2",
      (Zy.exports = function () {
        return $y;
      })
    );
  });
  var tI = u((hK, eI) => {
    var Or = at();
    Or.define(
      "links",
      (eI.exports = function (e, t) {
        var r = {},
          n = e(window),
          o,
          i = Or.env(),
          a = window.location,
          s = document.createElement("a"),
          c = "w--current",
          f = /index\.(html|php)$/,
          E = /\/$/,
          v,
          h;
        r.ready = r.design = r.preview = y;
        function y() {
          (o = i && Or.env("design")),
            (h = Or.env("slug") || a.pathname || ""),
            Or.scroll.off(S),
            (v = []);
          for (var A = document.links, w = 0; w < A.length; ++w) R(A[w]);
          v.length && (Or.scroll.on(S), S());
        }
        function R(A) {
          var w =
            (o && A.getAttribute("href-disabled")) || A.getAttribute("href");
          if (((s.href = w), !(w.indexOf(":") >= 0))) {
            var m = e(A);
            if (
              s.hash.length > 1 &&
              s.host + s.pathname === a.host + a.pathname
            ) {
              if (!/^#[a-zA-Z0-9\-\_]+$/.test(s.hash)) return;
              var x = e(s.hash);
              x.length && v.push({ link: m, sec: x, active: !1 });
              return;
            }
            if (!(w === "#" || w === "")) {
              var L = s.href === a.href || w === h || (f.test(w) && E.test(h));
              C(m, c, L);
            }
          }
        }
        function S() {
          var A = n.scrollTop(),
            w = n.height();
          t.each(v, function (m) {
            var x = m.link,
              L = m.sec,
              N = L.offset().top,
              X = L.outerHeight(),
              k = w * 0.5,
              Y = L.is(":visible") && N + X - k >= A && N + k <= A + w;
            m.active !== Y && ((m.active = Y), C(x, c, Y));
          });
        }
        function C(A, w, m) {
          var x = A.hasClass(w);
          (m && x) || (!m && !x) || (m ? A.addClass(w) : A.removeClass(w));
        }
        return r;
      })
    );
  });
  var nI = u((gK, rI) => {
    var Di = at();
    Di.define(
      "scroll",
      (rI.exports = function (e) {
        var t = {
            WF_CLICK_EMPTY: "click.wf-empty-link",
            WF_CLICK_SCROLL: "click.wf-scroll",
          },
          r = window.location,
          n = R() ? null : window.history,
          o = e(window),
          i = e(document),
          a = e(document.body),
          s =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (M) {
              window.setTimeout(M, 15);
            },
          c = Di.env("editor") ? ".w-editor-body" : "body",
          f =
            "header, " +
            c +
            " > .header, " +
            c +
            " > .w-nav:not([data-no-scroll])",
          E = 'a[href="#"]',
          v = 'a[href*="#"]:not(.w-tab-link):not(' + E + ")",
          h = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}',
          y = document.createElement("style");
        y.appendChild(document.createTextNode(h));
        function R() {
          try {
            return !!window.frameElement;
          } catch {
            return !0;
          }
        }
        var S = /^#[a-zA-Z0-9][\w:.-]*$/;
        function C(M) {
          return S.test(M.hash) && M.host + M.pathname === r.host + r.pathname;
        }
        let A =
          typeof window.matchMedia == "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)");
        function w() {
          return (
            document.body.getAttribute("data-wf-scroll-motion") === "none" ||
            A.matches
          );
        }
        function m(M, I) {
          var P;
          switch (I) {
            case "add":
              (P = M.attr("tabindex")),
                P
                  ? M.attr("data-wf-tabindex-swap", P)
                  : M.attr("tabindex", "-1");
              break;
            case "remove":
              (P = M.attr("data-wf-tabindex-swap")),
                P
                  ? (M.attr("tabindex", P),
                    M.removeAttr("data-wf-tabindex-swap"))
                  : M.removeAttr("tabindex");
              break;
          }
          M.toggleClass("wf-force-outline-none", I === "add");
        }
        function x(M) {
          var I = M.currentTarget;
          if (
            !(
              Di.env("design") ||
              (window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(I.className))
            )
          ) {
            var P = C(I) ? I.hash : "";
            if (P !== "") {
              var D = e(P);
              D.length &&
                (M && (M.preventDefault(), M.stopPropagation()),
                L(P, M),
                window.setTimeout(
                  function () {
                    N(D, function () {
                      m(D, "add"),
                        D.get(0).focus({ preventScroll: !0 }),
                        m(D, "remove");
                    });
                  },
                  M ? 0 : 300
                ));
            }
          }
        }
        function L(M) {
          if (
            r.hash !== M &&
            n &&
            n.pushState &&
            !(Di.env.chrome && r.protocol === "file:")
          ) {
            var I = n.state && n.state.hash;
            I !== M && n.pushState({ hash: M }, "", M);
          }
        }
        function N(M, I) {
          var P = o.scrollTop(),
            D = X(M);
          if (P !== D) {
            var G = k(M, P, D),
              Q = Date.now(),
              re = function () {
                var q = Date.now() - Q;
                window.scroll(0, Y(P, D, q, G)),
                  q <= G ? s(re) : typeof I == "function" && I();
              };
            s(re);
          }
        }
        function X(M) {
          var I = e(f),
            P = I.css("position") === "fixed" ? I.outerHeight() : 0,
            D = M.offset().top - P;
          if (M.data("scroll") === "mid") {
            var G = o.height() - P,
              Q = M.outerHeight();
            Q < G && (D -= Math.round((G - Q) / 2));
          }
          return D;
        }
        function k(M, I, P) {
          if (w()) return 0;
          var D = 1;
          return (
            a.add(M).each(function (G, Q) {
              var re = parseFloat(Q.getAttribute("data-scroll-time"));
              !isNaN(re) && re >= 0 && (D = re);
            }),
            (472.143 * Math.log(Math.abs(I - P) + 125) - 2e3) * D
          );
        }
        function Y(M, I, P, D) {
          return P > D ? I : M + (I - M) * se(P / D);
        }
        function se(M) {
          return M < 0.5
            ? 4 * M * M * M
            : (M - 1) * (2 * M - 2) * (2 * M - 2) + 1;
        }
        function te() {
          var { WF_CLICK_EMPTY: M, WF_CLICK_SCROLL: I } = t;
          i.on(I, v, x),
            i.on(M, E, function (P) {
              P.preventDefault();
            }),
            document.head.insertBefore(y, document.head.firstChild);
        }
        return { ready: te };
      })
    );
  });
  var oI = u((_K, iI) => {
    var EW = at();
    EW.define(
      "touch",
      (iI.exports = function (e) {
        var t = {},
          r = window.getSelection;
        (e.event.special.tap = { bindType: "click", delegateType: "click" }),
          (t.init = function (i) {
            return (
              (i = typeof i == "string" ? e(i).get(0) : i), i ? new n(i) : null
            );
          });
        function n(i) {
          var a = !1,
            s = !1,
            c = Math.min(Math.round(window.innerWidth * 0.04), 40),
            f,
            E;
          i.addEventListener("touchstart", v, !1),
            i.addEventListener("touchmove", h, !1),
            i.addEventListener("touchend", y, !1),
            i.addEventListener("touchcancel", R, !1),
            i.addEventListener("mousedown", v, !1),
            i.addEventListener("mousemove", h, !1),
            i.addEventListener("mouseup", y, !1),
            i.addEventListener("mouseout", R, !1);
          function v(C) {
            var A = C.touches;
            (A && A.length > 1) ||
              ((a = !0),
              A ? ((s = !0), (f = A[0].clientX)) : (f = C.clientX),
              (E = f));
          }
          function h(C) {
            if (a) {
              if (s && C.type === "mousemove") {
                C.preventDefault(), C.stopPropagation();
                return;
              }
              var A = C.touches,
                w = A ? A[0].clientX : C.clientX,
                m = w - E;
              (E = w),
                Math.abs(m) > c &&
                  r &&
                  String(r()) === "" &&
                  (o("swipe", C, { direction: m > 0 ? "right" : "left" }), R());
            }
          }
          function y(C) {
            if (a && ((a = !1), s && C.type === "mouseup")) {
              C.preventDefault(), C.stopPropagation(), (s = !1);
              return;
            }
          }
          function R() {
            a = !1;
          }
          function S() {
            i.removeEventListener("touchstart", v, !1),
              i.removeEventListener("touchmove", h, !1),
              i.removeEventListener("touchend", y, !1),
              i.removeEventListener("touchcancel", R, !1),
              i.removeEventListener("mousedown", v, !1),
              i.removeEventListener("mousemove", h, !1),
              i.removeEventListener("mouseup", y, !1),
              i.removeEventListener("mouseout", R, !1),
              (i = null);
          }
          this.destroy = S;
        }
        function o(i, a, s) {
          var c = e.Event(i, { originalEvent: a });
          e(a.target).trigger(c, s);
        }
        return (t.instance = t.init(document)), t;
      })
    );
  });
  var sI = u((yK, aI) => {
    var ys = at();
    ys.define(
      "forms",
      (aI.exports = function (e, t) {
        var r = {},
          n = e(document),
          o,
          i = window.location,
          a = window.XDomainRequest && !window.atob,
          s = ".w-form",
          c,
          f = /e(-)?mail/i,
          E = /^\S+@\S+$/,
          v = window.alert,
          h = ys.env(),
          y,
          R,
          S,
          C = /list-manage[1-9]?.com/i,
          A = t.debounce(function () {
            v(
              "Oops! This page has improperly configured forms. Please contact your website administrator to fix this issue."
            );
          }, 100);
        r.ready =
          r.design =
          r.preview =
            function () {
              w(), !h && !y && x();
            };
        function w() {
          (c = e("html").attr("data-wf-site")),
            (R = "https://webflow.com/api/v1/form/" + c),
            a &&
              R.indexOf("https://webflow.com") >= 0 &&
              (R = R.replace(
                "https://webflow.com",
                "https://formdata.webflow.com"
              )),
            (S = `${R}/signFile`),
            (o = e(s + " form")),
            o.length && o.each(m);
        }
        function m(q, H) {
          var j = e(H),
            U = e.data(H, s);
          U || (U = e.data(H, s, { form: j })), L(U);
          var F = j.closest("div.w-form");
          (U.done = F.find("> .w-form-done")),
            (U.fail = F.find("> .w-form-fail")),
            (U.fileUploads = F.find(".w-file-upload")),
            U.fileUploads.each(function (le) {
              G(le, U);
            });
          var Z =
            U.form.attr("aria-label") || U.form.attr("data-name") || "Form";
          U.done.attr("aria-label") || U.form.attr("aria-label", Z),
            U.done.attr("tabindex", "-1"),
            U.done.attr("role", "region"),
            U.done.attr("aria-label") ||
              U.done.attr("aria-label", Z + " success"),
            U.fail.attr("tabindex", "-1"),
            U.fail.attr("role", "region"),
            U.fail.attr("aria-label") ||
              U.fail.attr("aria-label", Z + " failure");
          var ce = (U.action = j.attr("action"));
          if (
            ((U.handler = null),
            (U.redirect = j.attr("data-redirect")),
            C.test(ce))
          ) {
            U.handler = I;
            return;
          }
          if (!ce) {
            if (c) {
              U.handler = M;
              return;
            }
            A();
          }
        }
        function x() {
          (y = !0),
            n.on("submit", s + " form", function (le) {
              var ee = e.data(this, s);
              ee.handler && ((ee.evt = le), ee.handler(ee));
            });
          let q = ".w-checkbox-input",
            H = ".w-radio-input",
            j = "w--redirected-checked",
            U = "w--redirected-focus",
            F = "w--redirected-focus-visible",
            Z = ":focus-visible, [data-wf-focus-visible]",
            ce = [
              ["checkbox", q],
              ["radio", H],
            ];
          n.on(
            "change",
            s + ' form input[type="checkbox"]:not(' + q + ")",
            (le) => {
              e(le.target).siblings(q).toggleClass(j);
            }
          ),
            n.on("change", s + ' form input[type="radio"]', (le) => {
              e(`input[name="${le.target.name}"]:not(${q})`).map((ge, Et) =>
                e(Et).siblings(H).removeClass(j)
              );
              let ee = e(le.target);
              ee.hasClass("w-radio-input") || ee.siblings(H).addClass(j);
            }),
            ce.forEach(([le, ee]) => {
              n.on(
                "focus",
                s + ` form input[type="${le}"]:not(` + ee + ")",
                (ge) => {
                  e(ge.target).siblings(ee).addClass(U),
                    e(ge.target).filter(Z).siblings(ee).addClass(F);
                }
              ),
                n.on(
                  "blur",
                  s + ` form input[type="${le}"]:not(` + ee + ")",
                  (ge) => {
                    e(ge.target).siblings(ee).removeClass(`${U} ${F}`);
                  }
                );
            });
        }
        function L(q) {
          var H = (q.btn = q.form.find(':input[type="submit"]'));
          (q.wait = q.btn.attr("data-wait") || null),
            (q.success = !1),
            H.prop("disabled", !1),
            q.label && H.val(q.label);
        }
        function N(q) {
          var H = q.btn,
            j = q.wait;
          H.prop("disabled", !0), j && ((q.label = H.val()), H.val(j));
        }
        function X(q, H) {
          var j = null;
          return (
            (H = H || {}),
            q
              .find(':input:not([type="submit"]):not([type="file"])')
              .each(function (U, F) {
                var Z = e(F),
                  ce = Z.attr("type"),
                  le =
                    Z.attr("data-name") || Z.attr("name") || "Field " + (U + 1),
                  ee = Z.val();
                if (ce === "checkbox") ee = Z.is(":checked");
                else if (ce === "radio") {
                  if (H[le] === null || typeof H[le] == "string") return;
                  ee =
                    q
                      .find('input[name="' + Z.attr("name") + '"]:checked')
                      .val() || null;
                }
                typeof ee == "string" && (ee = e.trim(ee)),
                  (H[le] = ee),
                  (j = j || te(Z, ce, le, ee));
              }),
            j
          );
        }
        function k(q) {
          var H = {};
          return (
            q.find(':input[type="file"]').each(function (j, U) {
              var F = e(U),
                Z = F.attr("data-name") || F.attr("name") || "File " + (j + 1),
                ce = F.attr("data-value");
              typeof ce == "string" && (ce = e.trim(ce)), (H[Z] = ce);
            }),
            H
          );
        }
        let Y = { _mkto_trk: "marketo" };
        function se() {
          return document.cookie.split("; ").reduce(function (H, j) {
            let U = j.split("="),
              F = U[0];
            if (F in Y) {
              let Z = Y[F],
                ce = U.slice(1).join("=");
              H[Z] = ce;
            }
            return H;
          }, {});
        }
        function te(q, H, j, U) {
          var F = null;
          return (
            H === "password"
              ? (F = "Passwords cannot be submitted.")
              : q.attr("required")
              ? U
                ? f.test(q.attr("type")) &&
                  (E.test(U) ||
                    (F = "Please enter a valid email address for: " + j))
                : (F = "Please fill out the required field: " + j)
              : j === "g-recaptcha-response" &&
                !U &&
                (F = "Please confirm you\u2019re not a robot."),
            F
          );
        }
        function M(q) {
          D(q), P(q);
        }
        function I(q) {
          L(q);
          var H = q.form,
            j = {};
          if (/^https/.test(i.href) && !/^https/.test(q.action)) {
            H.attr("method", "post");
            return;
          }
          D(q);
          var U = X(H, j);
          if (U) return v(U);
          N(q);
          var F;
          t.each(j, function (ee, ge) {
            f.test(ge) && (j.EMAIL = ee),
              /^((full[ _-]?)?name)$/i.test(ge) && (F = ee),
              /^(first[ _-]?name)$/i.test(ge) && (j.FNAME = ee),
              /^(last[ _-]?name)$/i.test(ge) && (j.LNAME = ee);
          }),
            F &&
              !j.FNAME &&
              ((F = F.split(" ")),
              (j.FNAME = F[0]),
              (j.LNAME = j.LNAME || F[1]));
          var Z = q.action.replace("/post?", "/post-json?") + "&c=?",
            ce = Z.indexOf("u=") + 2;
          ce = Z.substring(ce, Z.indexOf("&", ce));
          var le = Z.indexOf("id=") + 3;
          (le = Z.substring(le, Z.indexOf("&", le))),
            (j["b_" + ce + "_" + le] = ""),
            e
              .ajax({ url: Z, data: j, dataType: "jsonp" })
              .done(function (ee) {
                (q.success = ee.result === "success" || /already/.test(ee.msg)),
                  q.success || console.info("MailChimp error: " + ee.msg),
                  P(q);
              })
              .fail(function () {
                P(q);
              });
        }
        function P(q) {
          var H = q.form,
            j = q.redirect,
            U = q.success;
          if (U && j) {
            ys.location(j);
            return;
          }
          q.done.toggle(U),
            q.fail.toggle(!U),
            U ? q.done.focus() : q.fail.focus(),
            H.toggle(!U),
            L(q);
        }
        function D(q) {
          q.evt && q.evt.preventDefault(), (q.evt = null);
        }
        function G(q, H) {
          if (!H.fileUploads || !H.fileUploads[q]) return;
          var j,
            U = e(H.fileUploads[q]),
            F = U.find("> .w-file-upload-default"),
            Z = U.find("> .w-file-upload-uploading"),
            ce = U.find("> .w-file-upload-success"),
            le = U.find("> .w-file-upload-error"),
            ee = F.find(".w-file-upload-input"),
            ge = F.find(".w-file-upload-label"),
            Et = ge.children(),
            pe = le.find(".w-file-upload-error-msg"),
            d = ce.find(".w-file-upload-file"),
            V = ce.find(".w-file-remove-link"),
            K = d.find(".w-file-upload-file-name"),
            B = pe.attr("data-w-size-error"),
            ye = pe.attr("data-w-type-error"),
            Lt = pe.attr("data-w-generic-error");
          if (
            (h ||
              ge.on("click keydown", function (g) {
                (g.type === "keydown" && g.which !== 13 && g.which !== 32) ||
                  (g.preventDefault(), ee.click());
              }),
            ge.find(".w-icon-file-upload-icon").attr("aria-hidden", "true"),
            V.find(".w-icon-file-upload-remove").attr("aria-hidden", "true"),
            h)
          )
            ee.on("click", function (g) {
              g.preventDefault();
            }),
              ge.on("click", function (g) {
                g.preventDefault();
              }),
              Et.on("click", function (g) {
                g.preventDefault();
              });
          else {
            V.on("click keydown", function (g) {
              if (g.type === "keydown") {
                if (g.which !== 13 && g.which !== 32) return;
                g.preventDefault();
              }
              ee.removeAttr("data-value"),
                ee.val(""),
                K.html(""),
                F.toggle(!0),
                ce.toggle(!1),
                ge.focus();
            }),
              ee.on("change", function (g) {
                (j = g.target && g.target.files && g.target.files[0]),
                  j &&
                    (F.toggle(!1),
                    le.toggle(!1),
                    Z.toggle(!0),
                    Z.focus(),
                    K.text(j.name),
                    T() || N(H),
                    (H.fileUploads[q].uploading = !0),
                    Q(j, p));
              });
            var ht = ge.outerHeight();
            ee.height(ht), ee.width(1);
          }
          function l(g) {
            var O = g.responseJSON && g.responseJSON.msg,
              z = Lt;
            typeof O == "string" && O.indexOf("InvalidFileTypeError") === 0
              ? (z = ye)
              : typeof O == "string" &&
                O.indexOf("MaxFileSizeError") === 0 &&
                (z = B),
              pe.text(z),
              ee.removeAttr("data-value"),
              ee.val(""),
              Z.toggle(!1),
              F.toggle(!0),
              le.toggle(!0),
              le.focus(),
              (H.fileUploads[q].uploading = !1),
              T() || L(H);
          }
          function p(g, O) {
            if (g) return l(g);
            var z = O.fileName,
              ne = O.postData,
              _e = O.fileId,
              W = O.s3Url;
            ee.attr("data-value", _e), re(W, ne, j, z, _);
          }
          function _(g) {
            if (g) return l(g);
            Z.toggle(!1),
              ce.css("display", "inline-block"),
              ce.focus(),
              (H.fileUploads[q].uploading = !1),
              T() || L(H);
          }
          function T() {
            var g = (H.fileUploads && H.fileUploads.toArray()) || [];
            return g.some(function (O) {
              return O.uploading;
            });
          }
        }
        function Q(q, H) {
          var j = new URLSearchParams({ name: q.name, size: q.size });
          e.ajax({ type: "GET", url: `${S}?${j}`, crossDomain: !0 })
            .done(function (U) {
              H(null, U);
            })
            .fail(function (U) {
              H(U);
            });
        }
        function re(q, H, j, U, F) {
          var Z = new FormData();
          for (var ce in H) Z.append(ce, H[ce]);
          Z.append("file", j, U),
            e
              .ajax({
                type: "POST",
                url: q,
                data: Z,
                processData: !1,
                contentType: !1,
              })
              .done(function () {
                F(null);
              })
              .fail(function (le) {
                F(le);
              });
        }
        return r;
      })
    );
  });
  var cI = u((IK, uI) => {
    var Pt = at(),
      hW = Hi(),
      Me = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40,
        ESCAPE: 27,
        SPACE: 32,
        ENTER: 13,
        HOME: 36,
        END: 35,
      };
    Pt.define(
      "navbar",
      (uI.exports = function (e, t) {
        var r = {},
          n = e.tram,
          o = e(window),
          i = e(document),
          a = t.debounce,
          s,
          c,
          f,
          E,
          v = Pt.env(),
          h = '<div class="w-nav-overlay" data-wf-ignore />',
          y = ".w-nav",
          R = "w--open",
          S = "w--nav-dropdown-open",
          C = "w--nav-dropdown-toggle-open",
          A = "w--nav-dropdown-list-open",
          w = "w--nav-link-open",
          m = hW.triggers,
          x = e();
        (r.ready = r.design = r.preview = L),
          (r.destroy = function () {
            (x = e()), N(), c && c.length && c.each(se);
          });
        function L() {
          (f = v && Pt.env("design")),
            (E = Pt.env("editor")),
            (s = e(document.body)),
            (c = i.find(y)),
            c.length && (c.each(Y), N(), X());
        }
        function N() {
          Pt.resize.off(k);
        }
        function X() {
          Pt.resize.on(k);
        }
        function k() {
          c.each(F);
        }
        function Y(d, V) {
          var K = e(V),
            B = e.data(V, y);
          B ||
            (B = e.data(V, y, {
              open: !1,
              el: K,
              config: {},
              selectedIdx: -1,
            })),
            (B.menu = K.find(".w-nav-menu")),
            (B.links = B.menu.find(".w-nav-link")),
            (B.dropdowns = B.menu.find(".w-dropdown")),
            (B.dropdownToggle = B.menu.find(".w-dropdown-toggle")),
            (B.dropdownList = B.menu.find(".w-dropdown-list")),
            (B.button = K.find(".w-nav-button")),
            (B.container = K.find(".w-container")),
            (B.overlayContainerId = "w-nav-overlay-" + d),
            (B.outside = j(B));
          var ye = K.find(".w-nav-brand");
          ye &&
            ye.attr("href") === "/" &&
            ye.attr("aria-label") == null &&
            ye.attr("aria-label", "home"),
            B.button.attr("style", "-webkit-user-select: text;"),
            B.button.attr("aria-label") == null &&
              B.button.attr("aria-label", "menu"),
            B.button.attr("role", "button"),
            B.button.attr("tabindex", "0"),
            B.button.attr("aria-controls", B.overlayContainerId),
            B.button.attr("aria-haspopup", "menu"),
            B.button.attr("aria-expanded", "false"),
            B.el.off(y),
            B.button.off(y),
            B.menu.off(y),
            I(B),
            f
              ? (te(B), B.el.on("setting" + y, P(B)))
              : (M(B),
                B.button.on("click" + y, q(B)),
                B.menu.on("click" + y, "a", H(B)),
                B.button.on("keydown" + y, D(B)),
                B.el.on("keydown" + y, G(B))),
            F(d, V);
        }
        function se(d, V) {
          var K = e.data(V, y);
          K && (te(K), e.removeData(V, y));
        }
        function te(d) {
          d.overlay && (pe(d, !0), d.overlay.remove(), (d.overlay = null));
        }
        function M(d) {
          d.overlay ||
            ((d.overlay = e(h).appendTo(d.el)),
            d.overlay.attr("id", d.overlayContainerId),
            (d.parent = d.menu.parent()),
            pe(d, !0));
        }
        function I(d) {
          var V = {},
            K = d.config || {},
            B = (V.animation = d.el.attr("data-animation") || "default");
          (V.animOver = /^over/.test(B)),
            (V.animDirect = /left$/.test(B) ? -1 : 1),
            K.animation !== B && d.open && t.defer(re, d),
            (V.easing = d.el.attr("data-easing") || "ease"),
            (V.easing2 = d.el.attr("data-easing2") || "ease");
          var ye = d.el.attr("data-duration");
          (V.duration = ye != null ? Number(ye) : 400),
            (V.docHeight = d.el.attr("data-doc-height")),
            (d.config = V);
        }
        function P(d) {
          return function (V, K) {
            K = K || {};
            var B = o.width();
            I(d),
              K.open === !0 && ge(d, !0),
              K.open === !1 && pe(d, !0),
              d.open &&
                t.defer(function () {
                  B !== o.width() && re(d);
                });
          };
        }
        function D(d) {
          return function (V) {
            switch (V.keyCode) {
              case Me.SPACE:
              case Me.ENTER:
                return q(d)(), V.preventDefault(), V.stopPropagation();
              case Me.ESCAPE:
                return pe(d), V.preventDefault(), V.stopPropagation();
              case Me.ARROW_RIGHT:
              case Me.ARROW_DOWN:
              case Me.HOME:
              case Me.END:
                return d.open
                  ? (V.keyCode === Me.END
                      ? (d.selectedIdx = d.links.length - 1)
                      : (d.selectedIdx = 0),
                    Q(d),
                    V.preventDefault(),
                    V.stopPropagation())
                  : (V.preventDefault(), V.stopPropagation());
            }
          };
        }
        function G(d) {
          return function (V) {
            if (d.open)
              switch (
                ((d.selectedIdx = d.links.index(document.activeElement)),
                V.keyCode)
              ) {
                case Me.HOME:
                case Me.END:
                  return (
                    V.keyCode === Me.END
                      ? (d.selectedIdx = d.links.length - 1)
                      : (d.selectedIdx = 0),
                    Q(d),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Me.ESCAPE:
                  return (
                    pe(d),
                    d.button.focus(),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Me.ARROW_LEFT:
                case Me.ARROW_UP:
                  return (
                    (d.selectedIdx = Math.max(-1, d.selectedIdx - 1)),
                    Q(d),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
                case Me.ARROW_RIGHT:
                case Me.ARROW_DOWN:
                  return (
                    (d.selectedIdx = Math.min(
                      d.links.length - 1,
                      d.selectedIdx + 1
                    )),
                    Q(d),
                    V.preventDefault(),
                    V.stopPropagation()
                  );
              }
          };
        }
        function Q(d) {
          if (d.links[d.selectedIdx]) {
            var V = d.links[d.selectedIdx];
            V.focus(), H(V);
          }
        }
        function re(d) {
          d.open && (pe(d, !0), ge(d, !0));
        }
        function q(d) {
          return a(function () {
            d.open ? pe(d) : ge(d);
          });
        }
        function H(d) {
          return function (V) {
            var K = e(this),
              B = K.attr("href");
            if (!Pt.validClick(V.currentTarget)) {
              V.preventDefault();
              return;
            }
            B && B.indexOf("#") === 0 && d.open && pe(d);
          };
        }
        function j(d) {
          return (
            d.outside && i.off("click" + y, d.outside),
            function (V) {
              var K = e(V.target);
              (E && K.closest(".w-editor-bem-EditorOverlay").length) || U(d, K);
            }
          );
        }
        var U = a(function (d, V) {
          if (d.open) {
            var K = V.closest(".w-nav-menu");
            d.menu.is(K) || pe(d);
          }
        });
        function F(d, V) {
          var K = e.data(V, y),
            B = (K.collapsed = K.button.css("display") !== "none");
          if ((K.open && !B && !f && pe(K, !0), K.container.length)) {
            var ye = ce(K);
            K.links.each(ye), K.dropdowns.each(ye);
          }
          K.open && Et(K);
        }
        var Z = "max-width";
        function ce(d) {
          var V = d.container.css(Z);
          return (
            V === "none" && (V = ""),
            function (K, B) {
              (B = e(B)), B.css(Z, ""), B.css(Z) === "none" && B.css(Z, V);
            }
          );
        }
        function le(d, V) {
          V.setAttribute("data-nav-menu-open", "");
        }
        function ee(d, V) {
          V.removeAttribute("data-nav-menu-open");
        }
        function ge(d, V) {
          if (d.open) return;
          (d.open = !0),
            d.menu.each(le),
            d.links.addClass(w),
            d.dropdowns.addClass(S),
            d.dropdownToggle.addClass(C),
            d.dropdownList.addClass(A),
            d.button.addClass(R);
          var K = d.config,
            B = K.animation;
          (B === "none" || !n.support.transform || K.duration <= 0) && (V = !0);
          var ye = Et(d),
            Lt = d.menu.outerHeight(!0),
            ht = d.menu.outerWidth(!0),
            l = d.el.height(),
            p = d.el[0];
          if (
            (F(0, p),
            m.intro(0, p),
            Pt.redraw.up(),
            f || i.on("click" + y, d.outside),
            V)
          ) {
            g();
            return;
          }
          var _ = "transform " + K.duration + "ms " + K.easing;
          if (
            (d.overlay &&
              ((x = d.menu.prev()), d.overlay.show().append(d.menu)),
            K.animOver)
          ) {
            n(d.menu)
              .add(_)
              .set({ x: K.animDirect * ht, height: ye })
              .start({ x: 0 })
              .then(g),
              d.overlay && d.overlay.width(ht);
            return;
          }
          var T = l + Lt;
          n(d.menu).add(_).set({ y: -T }).start({ y: 0 }).then(g);
          function g() {
            d.button.attr("aria-expanded", "true");
          }
        }
        function Et(d) {
          var V = d.config,
            K = V.docHeight ? i.height() : s.height();
          return (
            V.animOver
              ? d.menu.height(K)
              : d.el.css("position") !== "fixed" && (K -= d.el.outerHeight(!0)),
            d.overlay && d.overlay.height(K),
            K
          );
        }
        function pe(d, V) {
          if (!d.open) return;
          (d.open = !1), d.button.removeClass(R);
          var K = d.config;
          if (
            ((K.animation === "none" ||
              !n.support.transform ||
              K.duration <= 0) &&
              (V = !0),
            m.outro(0, d.el[0]),
            i.off("click" + y, d.outside),
            V)
          ) {
            n(d.menu).stop(), p();
            return;
          }
          var B = "transform " + K.duration + "ms " + K.easing2,
            ye = d.menu.outerHeight(!0),
            Lt = d.menu.outerWidth(!0),
            ht = d.el.height();
          if (K.animOver) {
            n(d.menu)
              .add(B)
              .start({ x: Lt * K.animDirect })
              .then(p);
            return;
          }
          var l = ht + ye;
          n(d.menu).add(B).start({ y: -l }).then(p);
          function p() {
            d.menu.height(""),
              n(d.menu).set({ x: 0, y: 0 }),
              d.menu.each(ee),
              d.links.removeClass(w),
              d.dropdowns.removeClass(S),
              d.dropdownToggle.removeClass(C),
              d.dropdownList.removeClass(A),
              d.overlay &&
                d.overlay.children().length &&
                (x.length ? d.menu.insertAfter(x) : d.menu.prependTo(d.parent),
                d.overlay.attr("style", "").hide()),
              d.el.triggerHandler("w-close"),
              d.button.attr("aria-expanded", "false");
          }
        }
        return r;
      })
    );
  });
  Is();
  ms();
  xs();
  Ds();
  Xs();
  Hi();
  Jy();
  tI();
  nI();
  oI();
  sI();
  cI();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require("ix2").init({
  events: {
    e: {
      id: "e",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-2",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".button",
        originalId:
          "64c77e571e789c60590e1b49|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".button",
          originalId:
            "64c77e571e789c60590e1b49|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1683818336893,
    },
    "e-2": {
      id: "e-2",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-2",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".button",
        originalId:
          "64c77e571e789c60590e1b49|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".button",
          originalId:
            "64c77e571e789c60590e1b49|d0e16afa-af7b-ba4f-0f1a-1ad023b6fc2a",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1683818336894,
    },
    "e-3": {
      id: "e-3",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "FADE_EFFECT",
        instant: false,
        config: { actionListId: "fadeIn", autoStopEventId: "e-4" },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "64c77e571e789c60590e1b44|805a8d95-8451-ec2b-c376-1928c277b4b1",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c77e571e789c60590e1b44|805a8d95-8451-ec2b-c376-1928c277b4b1",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: null,
        effectIn: true,
      },
      createdOn: 1679166764591,
    },
    "e-5": {
      id: "e-5",
      name: "",
      animationType: "preset",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "FADE_EFFECT",
        instant: false,
        config: { actionListId: "fadeIn", autoStopEventId: "e-6" },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "02e1cc36-5a24-42f4-38c6-3e63a056636c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "02e1cc36-5a24-42f4-38c6-3e63a056636c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: 200,
        direction: null,
        effectIn: true,
      },
      createdOn: 1683878587933,
    },
    "e-9": {
      id: "e-9",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-3",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-10",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".faq-question",
        originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".faq-question",
          originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684145241909,
    },
    "e-10": {
      id: "e-10",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-9",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".faq-question",
        originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".faq-question",
          originalId: "0bf51656-0f3b-fc60-82a5-0bfc6471b258",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684145241909,
    },
    "e-11": {
      id: "e-11",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-12",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-form-item",
        originalId:
          "64c77e571e789c60590e1b44|43ec2dde-3809-53fe-173c-578d276a4138",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-form-item",
          originalId:
            "64c77e571e789c60590e1b44|43ec2dde-3809-53fe-173c-578d276a4138",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684237789895,
    },
    "e-13": {
      id: "e-13",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-14",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c77e571e789c60590e1b44|053dfe66-23bf-30db-821c-47666f67182c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c77e571e789c60590e1b44|053dfe66-23bf-30db-821c-47666f67182c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684238922999,
    },
    "e-15": {
      id: "e-15",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-6",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-16",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684241614541,
    },
    "e-16": {
      id: "e-16",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-7",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-15",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684241614541,
    },
    "e-17": {
      id: "e-17",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-8",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-18",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-faq-question",
        originalId:
          "64c77e571e789c60590e1b44|d06bf445-deeb-543f-ce27-4b67cf9e96df",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-faq-question",
          originalId:
            "64c77e571e789c60590e1b44|d06bf445-deeb-543f-ce27-4b67cf9e96df",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684246038841,
    },
    "e-18": {
      id: "e-18",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_SECOND_CLICK",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-9",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-17",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        selector: ".product-faq-question",
        originalId:
          "64c77e571e789c60590e1b44|d06bf445-deeb-543f-ce27-4b67cf9e96df",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".product-faq-question",
          originalId:
            "64c77e571e789c60590e1b44|d06bf445-deeb-543f-ce27-4b67cf9e96df",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684246038842,
    },
    "e-19": {
      id: "e-19",
      name: "",
      animationType: "custom",
      eventTypeId: "NAVBAR_OPEN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-10",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-20",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684251655124,
    },
    "e-20": {
      id: "e-20",
      name: "",
      animationType: "custom",
      eventTypeId: "NAVBAR_CLOSE",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-11",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-19",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "3b7e8291-76fb-a7e8-ebe8-603db68a396c",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1684251655124,
    },
    "e-21": {
      id: "e-21",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-12", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64c77e571e789c60590e1b44",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64c77e571e789c60590e1b44",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-12-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1684253320449,
    },
    "e-32": {
      id: "e-32",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OVER",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-13",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-33",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".shilajit-block",
        originalId:
          "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".shilajit-block",
          originalId:
            "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690891583952,
    },
    "e-33": {
      id: "e-33",
      name: "",
      animationType: "custom",
      eventTypeId: "MOUSE_OUT",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-14",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-32",
        },
      },
      mediaQueries: ["main"],
      target: {
        selector: ".shilajit-block",
        originalId:
          "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".shilajit-block",
          originalId:
            "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690891583952,
    },
    "e-34": {
      id: "e-34",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_INTO_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-15",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-35",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        selector: ".shilajit-block",
        originalId:
          "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".shilajit-block",
          originalId:
            "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 10,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690895088857,
    },
    "e-35": {
      id: "e-35",
      name: "",
      animationType: "custom",
      eventTypeId: "SCROLL_OUT_OF_VIEW",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-16",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-34",
        },
      },
      mediaQueries: ["medium", "small", "tiny"],
      target: {
        selector: ".shilajit-block",
        originalId:
          "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
        appliesTo: "CLASS",
      },
      targets: [
        {
          selector: ".shilajit-block",
          originalId:
            "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
          appliesTo: "CLASS",
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 30,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1690895088857,
    },
  },
  actionLists: {
    a: {
      id: "a",
      title: "Button - hover in",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "outCirc",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button-icon",
                  selectorGuids: ["c7df2065-9188-1a39-28f7-d8458e162b0d"],
                },
                xValue: 12,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1683818348557,
    },
    "a-2": {
      id: "a-2",
      title: "Button - hover out",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-2-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "inCirc",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button-icon",
                  selectorGuids: ["c7df2065-9188-1a39-28f7-d8458e162b0d"],
                },
                xValue: 0,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1683818348557,
    },
    "a-3": {
      id: "a-3",
      title: "FAQ - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-3-n",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-3-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".faq-arrow",
                  selectorGuids: ["c0657ad0-c02b-84a1-ccc1-c6b84bd26431"],
                },
                xValue: 180,
                xUnit: "deg",
                yUnit: "DEG",
                zUnit: "DEG",
              },
            },
            {
              id: "a-3-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                widthUnit: "PX",
                heightUnit: "AUTO",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1684145058168,
    },
    "a-4": {
      id: "a-4",
      title: "FAQ - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-4-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".faq-arrow",
                  selectorGuids: ["c0657ad0-c02b-84a1-ccc1-c6b84bd26431"],
                },
                xValue: 0,
                xUnit: "deg",
                yUnit: "DEG",
                zUnit: "DEG",
              },
            },
            {
              id: "a-4-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "inOutQuad",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".faq-answer",
                  selectorGuids: ["786b16e7-1268-c7d4-59da-99a230848e0a"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684145058168,
    },
    "a-5": {
      id: "a-5",
      title: "Product Form Item",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-5-n-3",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-form-item",
                  selectorGuids: ["95e3f479-3574-e2a8-ee2d-9710ce9007cc"],
                },
                globalSwatchId: "",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 0.12,
              },
            },
            {
              id: "a-5-n-4",
              actionTypeId: "STYLE_TEXT_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  selector: ".product-form-name",
                  selectorGuids: ["e6c50a00-6d9e-2d8b-e901-4ce09385d89f"],
                },
                globalSwatchId: "234cab64",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 1,
              },
            },
            {
              id: "a-5-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|43ec2dde-3809-53fe-173c-578d276a4138",
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
            {
              id: "a-5-n-2",
              actionTypeId: "STYLE_TEXT_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-name",
                  selectorGuids: ["e6c50a00-6d9e-2d8b-e901-4ce09385d89f"],
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684237930492,
    },
    "a-6": {
      id: "a-6",
      title: "Switch - click on",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-6-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse-block",
                  selectorGuids: ["6d5a07ee-cf61-d3cf-8c69-e91ad13b31dd"],
                },
                xValue: 28,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-6-n-3",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
                },
                globalSwatchId: "45490373",
                rValue: 246,
                bValue: 103,
                gValue: 197,
                aValue: 1,
              },
            },
            {
              id: "a-6-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse",
                  selectorGuids: ["722c2bd2-6bce-0978-f405-cefc48b3a7ce"],
                },
                globalSwatchId: "9783e1a9",
                rValue: 23,
                bValue: 133,
                gValue: 43,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684241617639,
    },
    "a-7": {
      id: "a-7",
      title: "Switch - click on 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-7-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse-block",
                  selectorGuids: ["6d5a07ee-cf61-d3cf-8c69-e91ad13b31dd"],
                },
                xValue: 0,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-7-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|8e88e922-0f0f-3c55-1f91-04c26ebd102c",
                },
                globalSwatchId: "",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 0.12,
              },
            },
            {
              id: "a-7-n-3",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-form-switch-ellipse",
                  selectorGuids: ["722c2bd2-6bce-0978-f405-cefc48b3a7ce"],
                },
                globalSwatchId: "234cab64",
                rValue: 0,
                bValue: 0,
                gValue: 0,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684241617639,
    },
    "a-8": {
      id: "a-8",
      title: "Product FAQ - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-8-n-2",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-8-n",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-faq-plus",
                  selectorGuids: ["aaac6d2b-6efa-7e78-3751-8bea460b5c9d"],
                },
                zValue: 225,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-8-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                widthUnit: "PX",
                heightUnit: "AUTO",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1684246042835,
    },
    "a-9": {
      id: "a-9",
      title: "Product FAQ - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-9-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".product-faq-plus",
                  selectorGuids: ["aaac6d2b-6efa-7e78-3751-8bea460b5c9d"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-9-n-3",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".product-faq-answer",
                  selectorGuids: ["45423f84-727f-f3b8-203f-16c9eade7225"],
                },
                heightValue: 0,
                widthUnit: "PX",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684246042835,
    },
    "a-10": {
      id: "a-10",
      title: "Nav Menu - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-10-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                yValue: 6,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-7",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "blur", filterId: "0979", value: 9, unit: "px" },
                ],
              },
            },
            {
              id: "a-10-n-6",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  {
                    type: "grayscale",
                    filterId: "317f",
                    value: 100,
                    unit: "%",
                  },
                ],
              },
            },
            {
              id: "a-10-n-5",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                zValue: -45,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-10-n-4",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                zValue: 45,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-10-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                yValue: -6,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-10-n-2",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["6df53799-ea50-8500-4c43-193691f82dcd"],
                },
                value: 0,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684251660870,
    },
    "a-11": {
      id: "a-11",
      title: "Nav Menu - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-11-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-11-n-2",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "blur", filterId: "0979", value: 0, unit: "px" },
                ],
              },
            },
            {
              id: "a-11-n-3",
              actionTypeId: "STYLE_FILTER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "SIBLINGS",
                  selector: ".page-wrapper",
                  selectorGuids: ["1458cc90-c968-acab-e784-a52b416f400d"],
                },
                filters: [
                  { type: "grayscale", filterId: "317f", value: 0, unit: "%" },
                ],
              },
            },
            {
              id: "a-11-n-4",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-11-n-5",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["c65294c2-5ed2-807c-1ffb-950bd0c2d045"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-11-n-6",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["d94c09f5-f9d2-18fb-4735-f06d582b293d"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-11-n-7",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["6df53799-ea50-8500-4c43-193691f82dcd"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1684251660870,
    },
    "a-12": {
      id: "a-12",
      title: "Navbar - scrolls",
      continuousParameterGroups: [
        {
          id: "a-12-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 0,
              actionItems: [
                {
                  id: "a-12-n",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["b36ca07c-90b9-6623-2917-5106d3b35fa7"],
                    },
                    globalSwatchId: "",
                    rValue: 0,
                    bValue: 0,
                    gValue: 0,
                    aValue: 0,
                  },
                },
              ],
            },
            {
              keyframe: 3,
              actionItems: [
                {
                  id: "a-12-n-3",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["b36ca07c-90b9-6623-2917-5106d3b35fa7"],
                    },
                    globalSwatchId: "",
                    rValue: 0,
                    bValue: 0,
                    gValue: 0,
                    aValue: 0.12,
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1684253324135,
    },
    "a-13": {
      id: "a-13",
      title: "Shilajit Block - hover in",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-13-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                globalSwatchId: "27c910d1",
                rValue: 255,
                bValue: 255,
                gValue: 255,
                aValue: 1,
              },
            },
            {
              id: "a-13-n-2",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                yValue: -12,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1690891590586,
    },
    "a-14": {
      id: "a-14",
      title: "Shilajit Block - hover out",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-14-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                globalSwatchId: "",
                rValue: 255,
                bValue: 255,
                gValue: 255,
                aValue: 0,
              },
            },
            {
              id: "a-14-n-2",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 300,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1690891590586,
    },
    "a-15": {
      id: "a-15",
      title: "Shilajit Block - hover in 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-15-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                globalSwatchId: "27c910d1",
                rValue: 255,
                bValue: 255,
                gValue: 255,
                aValue: 1,
              },
            },
            {
              id: "a-15-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button",
                  selectorGuids: ["353468c3-b92b-8d75-98e0-31c0823c4ab0"],
                },
                globalSwatchId: "45490373",
                rValue: 246,
                bValue: 103,
                gValue: 197,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1690891590586,
    },
    "a-16": {
      id: "a-16",
      title: "Shilajit Block - hover out 2",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-16-n",
              actionTypeId: "STYLE_BORDER",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: true,
                  id: "64c77e571e789c60590e1b44|e033a01d-4413-6c32-f419-d81a0d9c546e",
                },
                globalSwatchId: "",
                rValue: 255,
                bValue: 255,
                gValue: 255,
                aValue: 0,
              },
            },
            {
              id: "a-16-n-2",
              actionTypeId: "STYLE_BACKGROUND_COLOR",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".button",
                  selectorGuids: ["353468c3-b92b-8d75-98e0-31c0823c4ab0"],
                },
                globalSwatchId: "27c910d1",
                rValue: 255,
                bValue: 255,
                gValue: 255,
                aValue: 1,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1690891590586,
    },
    fadeIn: {
      id: "fadeIn",
      useFirstGroupAsInitialState: true,
      actionItemGroups: [
        {
          actionItems: [
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                duration: 0,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 0,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "outQuart",
                duration: 1000,
                target: {
                  id: "N/A",
                  appliesTo: "TRIGGER_ELEMENT",
                  useEventTarget: true,
                },
                value: 1,
              },
            },
          ],
        },
      ],
    },
  },
  site: {
    mediaQueries: [
      { key: "main", min: 992, max: 10000 },
      { key: "medium", min: 768, max: 991 },
      { key: "small", min: 480, max: 767 },
      { key: "tiny", min: 0, max: 479 },
    ],
  },
});
